/*
 * @Author: WGL
 * @Date: 2023-04-03 15:28:54
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-01 14:10:36
 * @Description:
 */
export default {
  vabI18n: {
    首页: 'Ana Sayfa',
    看板: 'Pano',
    工作台: 'Çalışma Alanı',
    个人中心: 'Kişisel Merkez',
    Excel: 'Excel',
    错误页: 'Hata Sayfaları',
    403: '403',
    404: '404',
    邮件: 'E-posta',
    更多: 'Daha Fazla',
    退出登录: 'Çıkış Yap',
    登录: 'Giriş',
    验证码: 'Doğrulama Kodu',
    注册: 'Kayıt Ol',
    国际化: 'Uluslararasılaştırma',
    刷新: 'Yenile',
    通知: 'Bildirimler',
    全屏: 'Tam Ekran',
    页面动画: 'Sayfa Animasyonları',
    搜索: 'Ara',
    重置: 'Sıfırla',
    开启: 'Aç',
    关闭: 'Kapat',
    保存: 'Kaydet',
    欢迎来到: 'Hoş Geldiniz',
    请输入用户名: 'Kullanıcı Adınızı Girin',
    请输入密码: 'Şifrenizi Girin',
    用户名不能为空: 'Kullanıcı Adı Boş Bırakılamaz',
    密码不能少于6位: 'Şifre En Az 6 Karakter Olmalıdır',
    请输入正确的手机号: 'Lütfen Geçerli Bir Telefon Numarası Girin',
    请输入手机号: 'Lütfen Telefon Numarasını Girin',
    请输入手机验证码: 'Lütfen Telefon Doğrulama Kodunu Girin',
    获取验证码: 'Doğrulama Kodunu Al',
    大: 'Büyük',
    中: 'Orta',
    小: 'Küçük',
    基本信息: 'Temel Bilgiler',
    分类名称: 'Kategori Adı',
    请输入分类名称: 'Lütfen Kategori Adını Girin',
    排序: 'Sıralama',
    状态: 'Durum',
    备注: 'Not',
    请输入备注: 'Lütfen Notunuzu Girin',
    序号: 'Sıra No',
    规格: 'Özellikler',
    '重量/长-宽-高/体积': 'Ağırlık/Uzunluk-Genişlik-Yükseklik/Hacim',
    价格: 'Fiyat',
    '价格(元)': 'Fiyat (TL)',
    销量: 'Satış Miktarı',
    封面图: 'Kapak Resmi',
    图片: 'Resim',
    图标: 'Sembol',
    编码: 'Kod',
    OEM编码: 'OEM Kodu',
    '产品编码/OEM编码': 'Ürün Kodu/OEM Kodu',
    '编码超级搜索，多个编码换行隔开':
      'Kodları Süper Ara, Birden Fazla Kodu Satır Atlatarak Girin',
    库存: 'Stok',
    调出仓库: 'Çıkış Deposu',
    调入仓库: 'Giriş Deposu',
    '真实库存(锁定库存)': 'Gerçek Stok (Kilitli Stok)',
    采购价: 'Satın Alma Fiyatı',
    毛利率: 'Brüt Kar Marjı',
    客户报价: 'Müşteri Teklifi',
    报价状态: 'Teklif Durumu',
    来源: 'Kaynak',
    创建时间: 'Oluşturulma Tarihi',
    更新时间: 'Güncelleme Tarihi',
    使用状态: 'Kullanım Durumu',
    总价: 'Toplam Fiyat',
    操作: 'İşlem',
    名称: 'Ad',
    加载数据中: 'Veriler Yükleniyor...',
    系统: 'Sistem',
    确定: 'Onayla',
    确认: 'Onayla',
    取消: 'İptal',
    取消操作: 'İptal Et',
    '此操作将会永久删除数据，是否继续?':
      'Bu işlem verileri kalıcı olarak silecektir, devam etmek istiyor musunuz?',
    '确定要复制当前数据?':
      'Mevcut veriyi kopyalamak istediğinize emin misiniz?',
    请配置打印接口: 'Lütfen yazdırma arayüzünü yapılandırın!',
    暂无数据可导出: 'Dışa aktarılacak veri yok!',
    正在生成中: 'Oluşturuluyor...',
    请配置导出接口: 'Lütfen dışa aktarma arayüzünü yapılandırın!',
    '当前页面可能存在未保存内容，直接离开内容将不被保存':
      'Bu sayfada kaydedilmemiş içerikler olabilir, doğrudan ayrılırsanız içerik kaydedilmeyecektir',
    请配置上传的路径地址: 'Lütfen yükleme yolunu yapılandırın!',
    编辑: 'Düzenle',
    删除: 'Sil',
    新建: 'Yeni Ekle',
    提示: 'İpucu',
    '请配置导出接口！': 'Dışa Aktarma Arabirimini Yapılandırın!',
    '暂无数据可导出！': 'Dışa Aktarılabilir Veri Yok!',
    正在下载中: 'İndiriliyor...',
    文件: 'Dosya',
    '请配置文件上传接口！': 'Dosya Yükleme Arabirimini Yapılandırın!',
    '请配置编辑接口！': 'Düzenleme Arabirimini Yapılandırın!',
    '导出数据过多，已添加至异步导出队列生成':
      'Çok fazla veri dışa aktarıldı, asenkron dışa aktarma sırasına eklendi',
    请配置文件上传接口: 'Dosya Yükleme Arabirimini Yapılandırın!',
    请配置编辑接口: 'Düzenleme Arabirimini Yapılandırın!',
    请配置详情接口: 'Ayrıntılar Arabirimini Yapılandırın!',
    头像裁剪: 'Avatar Kırpma',
    选择图片: 'Resim Seç',
    上传并保存: 'Yükle ve Kaydet',
    返回: 'Geri',
    产品详情: 'Ürün Detayları',
    总计: 'Toplam',
    查询: 'Sorgula',
    单位: 'Birim',
    附件: 'Eklenti',
    仓库: 'Depo',
    手机号: 'Telefon Numarası',
    角色: 'Rol',
    权限: 'İzinler',
    是否负责人: 'Sorumlu Mu?',
    固定号码: 'Sabit Numara',
    上传文件: 'Dosya Yükle',
    '附件名称(点击预览)': 'Eklenti Adı (Önizlemek için Tıklayın)',
    附件类型: 'Eklenti Türü',
    附件大小: 'Eklenti Boyutu',
    上传人: 'Yükleyen',
    上传图片大小不能超过: 'Resim Yükleme Boyutu Aşmamalıdır:',
    最多上传: 'En Fazla Yükle:',
    您选择了: 'Seçtiniz:',
    '个文件,请重新选择': 'Dosya, lütfen yeniden seçin.',
    你确定要删除: 'Silmek istediğinizden emin misiniz?',
    上传时间: 'Yükleme Zamanı',
    明细: 'Detaylar',
    文件名称: 'Dosya Adı',
    请输入分类排序: 'Sıralamayı Girin',
    展开: 'Aç',
    合并: 'Birleştir',
    紧急程度: 'Aciliyet Derecesi',
    添加: 'Ekle',
    请选择: 'Lütfen Seçin',
    供应商: 'Tedarikçi',
    最近报价: 'Son Teklif',
    品牌: 'Marka',
    车型: 'Araç Modeli',
    请选择车型: 'Araç Modeli Seçin',
    部件: 'Parça',
    请选择部件: 'Parça Seçin',
    年份: 'Yıl',
    请选择年份: 'Yıl Seçin',
    发表评论: 'Yorum Yap',
    修改: 'Düzenle',
    '暂无评论~': 'Henüz yorum yok~',
    评论人员: 'Yorum Yapanlar',
    '暂无信息~': 'Henüz bilgi yok~',
    姓名: 'Ad',
    电话: 'Telefon',
    请输入电话: 'Telefon Numarası Girin',
    邮箱: 'E-posta',
    部门: 'Departman',
    职务: 'Görev',
    图表显示: 'Grafik Görünümü',
    指标值: 'Gösterge Değeri',
    日: 'Gün',
    月: 'Ay',
    年: 'Yıl',
    已选择: 'Seçilenler',
    请输入关键词: 'Anahtar Kelime Girin',
    使用选择: 'Seçimi Kullan',
    暂无内容: 'Henüz İçerik Yok',
    选择成功: 'Başarıyla Seçildi',
    跟进: 'Takip',
    已添加: 'Eklenen',
    库存不足: 'Stok Yetersiz',
    是: 'Evet',
    否: 'Hayır',
    请填写: 'Lütfen doldurun',
    币种: 'Para Birimi',
    创建人: 'Oluşturan Kişi',
    最近更新: 'Son Güncelleme',
    从素材库选择: 'Materyal Kütüphanesinden Seç',
    从素材库选: 'Materyal Kütüphanesinden Seç',
    在此处粘贴图片即上传: 'Buraya resim yapıştırın veya yükleyin',
    '上传图片只能是JPG,PNG,GIF,WEBP格式':
      'Sadece JPG, PNG, GIF, WEBP formatında resim yüklenebilir',
    只能上传一张图片: 'Sadece bir resim yüklenebilir',
    当前浏览器不支持本地图片粘贴:
      'Mevcut tarayıcı yerel resim yapıştırmayı desteklemiyor',
    粘贴内容非图片: 'Yapıştırılan içerik bir resim değil',
    上传文件大小不能超过: 'Yükleme dosya boyutu aşılamaz',
    正在上传中: 'Yükleniyor...',
    上传: 'Yükle',
    上传完成: 'Yükleme Tamamlandı',
    上传失败请重新上传: 'Yükleme Başarısız, Lütfen Tekrar Deneyin',
    正在导入中: 'Veri İçeri Aktarılıyor...',
    导入: 'İçeri Aktar',
    导出: 'Dışa Aktar',
    全选: 'Tümünü Seç',
    使用选中: 'Seçileni Kullan',
    一键抠图: 'Tek Tıkla Kes',
    抠图: 'Kes',
    不抠图: 'Kesme',
    完成: 'Tamamla',
    下载: 'İndir',
    查看: 'Görüntüle',
    暂无数据: 'Veri Yok',
    上级分类: 'Üst Kategori',
    添加分类: 'Kategori Ekle',
    编辑分类: 'Kategori Düzenle',
    删除分类: 'Kategori Sil',
    分类名称不能为空: 'Kategori Adı Boş Bırakılamaz',
    音频: 'Ses',
    只能选择一张图片: 'Yalnızca bir resim seçebilirsiniz',
    请配置分类接口: 'Kategori Arabirimini Yapılandırın!',
    全部: 'Tümü',
    请配置素材接口: 'Malzeme Arabirimini Yapılandırın!',
    请添加分类: 'Lütfen Kategori Ekleyin',
    请配置分类添加接口: 'Kategori Ekleme Arabirimini Yapılandırın',
    请配置分类编辑接口: 'Kategori Düzenleme Arabirimini Yapılandırın',
    请配置分类删除接口: 'Kategori Silme Arabirimini Yapılandırın',
    文件类型格式不正确: 'Dosya Türü Biçimi Doğru Değil!',
    大小不能超过: 'Büyüklüğü Aşamaz:',
    个文件请重新选择: 'Dosya, lütfen yeniden seçin.',
    请配置素材分类导出接口:
      'Malzeme Kategori Dışa Aktarma Arabirimini Yapılandırın!',
    立即新增: 'Hemen Ekle',
    上传视频大小不能超过: 'Video Yükleme Boyutu Aşamaz:',
    图标选择器: 'Simge Seçici',
    最后编辑: 'Son Düzenleme',
    步骤: 'Adım',
    标题: 'Başlık',
    审核: 'Denetleme',
    审核状态: 'Denetleme Durumu',
    请选择类型: 'Lütfen Tür Seçin',
    请选择审核状态: 'Lütfen Denetleme Durumu Seçin',
    通过: 'Onayla',
    不通过: 'Onaylama',
    付款状态: 'Ödeme Durumu',
    请选择付款状态: 'Lütfen Ödeme Durumu Seçin',
    发货状态: 'Sevkiyat Durumu',
    请选择发货状态: 'Lütfen Sevkiyat Durumu Seçin',
    提成金额: 'Komisyon Miktarı',
    请输入提成金额: 'Lütfen Komisyon Miktarını Girin',
    回款方式: 'Ödeme Yöntemi',
    请选择回款方式: 'Lütfen Ödeme Yöntemi Seçin',
    回款日期: 'Ödeme Tarihi',
    请输入回款日期: 'Lütfen Ödeme Tarihini Girin',
    流水单号: 'Hesap Özeti Numarası',
    请输入支付流水单号: 'Lütfen Ödeme Hesap Numarasını Girin',
    支付凭证: 'Ödeme Belgeleri',
    付款方式: 'Ödeme Yöntemi',
    请选择付款方式: 'Lütfen Ödeme Yöntemi Seçin',
    付款日期: 'Ödeme Tarihi',
    请输入付款日期: 'Lütfen Ödeme Tarihini Girin',
    下单日期: 'Sipariş Tarihi',
    请选择下单日期: 'Lütfen Sipariş Tarihi Seçin',
    请输入名称: 'Lütfen Adı Girin',
    保存并新增: 'Kaydet ve Yeni Ekle',
    您确定要对当前数据进行提审:
      'Mevcut veriyi denetlemek istediğinizden emin misiniz?',
    您确定要对当前数据进行提审并通过:
      'Mevcut veriyi denetlemek ve onaylamak istediğinizden emin misiniz?',
    '您确定要对当前状态进行撤销？撤销后可重新编辑提审':
      'Mevcut durumu geri almak istediğinizden emin misiniz? Geri aldıktan sonra yeniden düzenleme yapabilirsiniz.',
    您确定要对当前订单进行续单:
      'Mevcut siparişi yenilemek istediğinizden emin misiniz?',
    您确定要对当前订单生成出库单:
      'Mevcut siparişten çıkış belgesi oluşturmak istediğinizden emin misiniz?',
    邮件模版: 'E-posta Şablonu',
    生成预览: 'Önizleme Oluştur',
    表格: 'Tablo',
    取消附件: 'Eklemeyi İptal Et',
    单选: 'Tek Seçim',
    只看我的: 'Sadece Benimkini Gör',
    先发给自己: 'Önce Kendime Gönder',
    主题: 'Konu',
    请输入主题: 'Lütfen Konu Girin',
    请输入标题: 'Lütfen Başlık Girin',
    收件人: 'Alıcı',
    请选择收件人: 'Lütfen Alıcı Seçin',
    头部: 'Üst Kısım',
    尾部: 'Alt Kısım',
    发送: 'Gönder',
    下次联系时间: 'Sonraki İletişim Zamanı',
    跟进内容: 'İletişim İçeriği',
    上传附件: 'Ek Dosya Yükle',
    '是否删除这条跟进记录?': 'Bu iletişim kaydını silmek istiyor musunuz?',
    确定进入: 'Giriş Yap',
    阶段: 'Aşama',
    成员管理: 'Üye Yönetimi',
    成员: 'Üye',
    请选择成员: 'Lütfen Üye Seçin',
    只读: 'Sadece Okuma',
    读写: 'Okuma ve Yazma',
    负责人: 'Sorumlu Kişi',
    更换负责人: 'Sorumlu Kişiyi Değiştir',
    设置为负责人: 'Sorumlu Kişi Olarak Ayarla',
    请选择负责人: 'Lütfen Sorumlu Kişi Seçin',
    产品: 'Ürün',
    数量: 'Miktar',
    邮箱模版: 'E-posta Şablonu',
    表格模版: 'Tablo Şablonu',
    去添加: 'Ekleme Git',
    产品名称: 'Ürün Adı',
    请输入产品名称: 'Lütfen Ürün Adı Girin',
    产品分类: 'Ürün Kategorisi',
    请选择产品分类: 'Lütfen Ürün Kategorisi Seçin',
    产品类型: 'Ürün Türü',
    请选择产品类型: 'Lütfen Ürün Türü Seçin',
    请输入排序: 'Sıralama Girin',
    产品编码: 'Ürün Kodu',
    请输入产品编码: 'Lütfen Ürün Kodu Girin',
    请输入OEM编码: 'Lütfen OEM Kodu Girin',
    适用车型: 'Uygun Araç Modelleri',
    请选择适用车型: 'Lütfen Uygun Araç Modelleri Seçin',
    车身部件: 'Araç Gövde Parçası',
    请选择车身部件: 'Lütfen Araç Gövde Parçası Seçin',
    产品货币: 'Ürün Para Birimi',
    请选择产品货币单位: 'Lütfen Ürün Para Birimi Birimini Seçin',
    预警库存: 'Uyarı Stoku',
    '建议售价/最低售价/成本':
      'Önerilen satış fiyatı/minimal satış fiyatı/maliyeti',
    外贸: 'Dış Ticaret',
    零售: 'Perakende',
    成本: 'Maliyet',
    '名称/编码/OEM编码': 'Ad/Kod/OEM Kodu',
    '重量/体积/长-宽-高': 'Ağırlık/Hacim/Uzunluk-Genişlik-Yükseklik',
    上下架: 'Yayınla/Kaldır',
    上架: 'Yayınla',
    下架: 'Kaldır',
    请选择单位: 'Lütfen Birim Seçin',
    建议售价: 'Satış fiyatı önerildi',
    最低售价: 'En düşük satış fiyatı',
    成本价: 'Maliyet Fiyatı',
    装箱量: 'Ambalaj Miktarı',
    箱规: 'Ambalaj Boyutu',
    '箱规-长(cm)': 'Ambalaj Boyutu - Uzunluk (cm)',
    '箱规-宽(cm)': 'Ambalaj Boyutu - Genişlik (cm)',
    '箱规-高(cm)': 'Ambalaj Boyutu - Yükseklik (cm)',
    '箱规-装箱量': 'Ambalaj Boyutu - Ambalaj Miktarı',
    '箱规-净重(kg)': 'Ambalaj Boyutu - Net Ağırlık (kg)',
    '箱规-毛重(kg)': 'Ambalaj Boyutu - Brüt Ağırlık (kg)',
    '箱规-体积(m³)': 'Ambalaj Boyutu - Hacim (m³)',
    '重量(kg)': 'Ağırlık (kg)',
    '单个-长(cm)': 'Tekil Ürün - Uzunluk (cm)',
    '单个-宽(cm)': 'Tekil Ürün - Genişlik (cm)',
    '单个-高(cm)': 'Tekil Ürün - Yükseklik (cm)',
    '单个-体积(m³)': 'Tekil Ürün - Hacim (m³)',
    '单个-净重(kg)': 'Tekil Ürün - Net Ağırlık (kg)',
    '单个-毛重(kg)': 'Tekil Ürün - Brüt Ağırlık (kg)',
    证书: 'Sertifika',
    建议尺寸比例: 'Tavsiye Edilen Boyut Oranı 1*1',
    重量: 'Ağırlık',
    体积: 'Hacim',
    分类: 'Kategori',
    '体积(m³)': 'Hacim (m³)',
    描述: 'Açıklama',
    请输入描述: 'Lütfen Açıklama Girin',
    图集: 'Resim Koleksiyonu',
    实施服务: 'Uygulama Hizmeti',
    请选择实施服务: 'Lütfen Uygulama Hizmeti Seçin',
    扩展信息: 'Genişletilmiş Bilgi',
    请选择供应商: 'Lütfen Tedarikçi Seçin',
    图片信息: 'Resim Bilgisi',
    请选择仓库: 'Lütfen Depo Seçin',
    请选择产品: 'Lütfen Ürün Seçin',
    入库: 'Depo Girişi',
    产品图片: 'Ürün Resmi',
    我方编码: 'Kendi Kodumuz',
    对方编码: 'Karşı Taraf Kodu',
    历史最低: 'Tarihsel En Düşük',
    近期价格: 'Son Dönem Fiyatları',
    历史最高: 'Tarihsel En Yüksek',
    联系人: 'İletişim Kişisi',
    详细地址: 'Ayrıntılı Adres',
    请选择车型品牌: 'Lütfen Araç Modeli Markası Seçin',
    请选择配置: 'Lütfen Yapılandırmayı Seçin',
    货源: 'Tedarikçi',
    产品概览: 'Ürün Genel Bakışı',
    配套产品: 'Eşleştirilmiş Ürünler',
    配套产品详情: 'Eşleştirilmiş Ürün Ayrıntıları',
    平替产品: 'Eş Değiştirme Ürünleri',
    价格策略: 'Fiyat Stratejisi',
    策略条件: 'Strateji Koşulları',
    数量大于等于: 'Miktar Büyük veya Eşit',
    单价为: 'Birim Fiyatı',
    类型: 'Tür',
    策略方式: 'Strateji Yöntemi',
    策略类型: 'Strateji Türü',
    请选择策略类型: 'Lütfen Strateji Türü Seçin',
    库存提示: 'Geçerli Stok Miktarı (Toplam Stok/Uyarı Stok)',
    包含产品: 'Ürünü İçerir',
    配置: 'Yapılandırma',
    导出原图: 'Orijinal Resmi Dışa Aktar',
    视频信息: 'Video Bilgisi',
    视频: 'Video',
    目标市场: 'Hedef Pazar',
    请选择目标市场: 'Lütfen Hedef Pazarı Seçin',
    产品货源: 'Ürün Kaynağı',
    请选择产品货源: 'Lütfen Ürün Kaynağını Seçin',
    上下架状态: 'Yayın Durumu',
    请选择产品上下架状态: 'Lütfen Ürün Yayın Durumunu Seçin',
    需要以字母开头: 'Başlangıçta Harf Olmalı',
    显示名称: 'Görünen Ad',
    请输入显示名称: 'Lütfen Görünen Adı Girin',
    用于生成电商网站时显示的分类标题:
      'E-ticaret Web Sitesinde Gösterilen Kategori Başlığı',
    分类url: 'Kategori URL',
    请输入字母或数字: 'Lütfen Harf veya Sayı Girin',
    '请输入分类url,如lights': `Lütfen Kategori URL'sini Girin, Örneğin "ışıklar"`,
    用于生成电商网站的链接: 'E-ticaret Web Sitesi Oluşturmak İçin Bağlantı',
    分类描述: 'Kategori Açıklaması',
    用于生成电商网站时SEO: 'E-ticaret Web Sitesi Oluştururken SEO',
    分类关键词: 'Kategori Anahtar Kelimeler',
    请输入分类: 'Lütfen Kategori Girin',
    // ==================================== 销售模块 ==============================
    内容: 'İçerik',
    跟进人: 'Takipçi',
    跟进时间: 'Takip Zamanı',
    添加成员: 'Üye Ekle',
    删除成员: 'Üye Sil',
    '请选择成员(可多选)': 'Üyeleri Seçin (Çoklu Seçim)',
    客户: 'Müşteri',
    客户名称: 'Müşteri Adı',
    请输入客户名称: 'Lütfen Müşteri Adı Girin',
    客户编码: 'Müşteri Kodu',
    成交单数: 'Tamamlanan Sipariş Sayısı',
    成交金额: 'Tamamlanan Tutar',
    回款金额: 'Alınan Tutar',
    客户来源: 'Müşteri Kaynağı',
    请选择客户来源: 'Lütfen Müşteri Kaynağı Seçin',
    客户行业: 'Müşteri Endüstrisi',
    请选择客户行业: 'Lütfen Müşteri Endüstrisi Seçin',
    客户等级: 'Müşteri Derecesi',
    请选择客户等级: 'Lütfen Müşteri Derecesi Seçin',
    下次跟进时间: 'Sonraki Takip Zamanı',
    地区: 'Bölge',
    请选择地区: 'Lütfen Bölge Seçin',
    请输入客户手机号: 'Lütfen Müşteri Telefon Numarası Girin',
    请输入邮箱地址: 'Lütfen E-posta Adresi Girin',
    地址: 'Adres',
    请输入客户地址: 'Lütfen Müşteri Adresi Girin',
    是否成交: 'Anlaşma Durumu',
    请选择是否成交: 'Lütfen Anlaşma Durumunu Seçin',
    客户详情: 'Müşteri Detayları',
    最后跟进时间: 'Son Takip Zamanı',
    微信: 'WeChat',
    请输入微信: 'Lütfen WeChat Numarası Girin',
    商机: 'İş Fırsatı',
    范围: 'Kapsam',
    请选择数据范围: 'Lütfen Veri Kapsamını Seçin',
    客户地区: 'Müşteri Bölgesi',
    团队成员: 'Takım Üyeleri',
    发票信息: 'Fatura Bilgileri',
    客户分析: 'Müşteri Analizi',
    客户订单分析: 'Müşteri Sipariş Analizi',
    请选择开始日期: 'Lütfen Başlangıç Tarihi Seçin',
    开始日期: 'Başlangıç Tarihi',
    结束日期: 'Bitiş Tarihi',
    退货产品: 'İade Ürünü',
    结束时间: 'Bitiş Zamanı',
    开始时间: 'Başlangıç Zamanı',
    核心数据: 'Anahtar Veriler',
    成交趋势: 'Anlaşma Eğilimi',
    产品分布: 'Ürün Dağılımı',
    产品排行: 'Ürün Sıralaması',
    销售前20产品: 'Satışta İlk 20 Ürün',
    历史订单: 'Geçmiş Siparişler',
    订单金额: 'Sipariş Tutarı',
    订单总金额: 'Toplam Sipariş Tutarı',
    订单笔数: 'Sipariş Sayısı',
    下单数量: 'Sipariş Miktarı',
    实收金额: 'Toplam Tahsilat',
    '当前订单收款总和，扣除退款': 'Toplam Tahsilat (İadeler Düşüldü)',
    退款金额: 'İade Tutarı',
    当前订单退款金额: 'Geçerli Sipariş İade Tutarı',
    未收回款: 'Tahsil Edilmemiş Tutar',
    '订单金额-已收金额': 'Sipariş Tutarı - Tahsil Edilen Tutar',
    已开票金额: 'Faturalandırılan Tutar',
    订单已开票的金额: 'Faturalandırılan Sipariş Tutarı',
    平均单价: 'Ortalama Fiyat',
    每笔订单平均单价: 'Her Siparişin Ortalama Fiyatı',
    排名: 'Sıralama',
    渠道来源: 'Kanal Kaynağı',
    金额占比: 'Tutar Oranı',
    订单占比: 'Sipariş Oranı',
    公司名称: 'Şirket Adı',
    请输入公司名称: 'Lütfen Şirket Adı Girin',
    税号: 'Vergi Numarası',
    请输入公司税号: 'Lütfen Şirket Vergi Numarası Girin',
    开户行: 'Açık Hesap Bankası',
    银行账号: 'Banka Hesap Numarası',
    账户信息: 'Hesap Bilgileri',
    发票抬头: 'Fatura Ünvanı',
    关联客户: 'İlişkilendirilmiş Müşteri',
    请选择客户: 'Lütfen Müşteriyi Seçin',
    货币币种: 'Para Birimi',
    开户银行: 'Açık Hesap Bankası',
    请输入开户银行全称: 'Lütfen Açık Hesap Bankası Tam Adını Girin',
    银行卡号: 'Banka Kartı Numarası',
    请输入银行卡号: 'Lütfen Banka Kartı Numarası Girin',
    请输入地址: 'Lütfen Adres Girin',
    退货商品为空表示只退款: 'İade Ürünü Boşsa Sadece İade Anlamına Gelir',
    请输入退货数量: 'Lütfen İade Miktarını Girin',
    产品明细: 'Ürün Detayları',
    请至少添加一个产品: 'Lütfen En Az Bir Ürün Ekleyin',
    // TODO: 2023-11-14 start
    商机名称: 'Fırsat Adı',
    请输入商机名称: 'Lütfen Fırsat Adı Girin',
    商机阶段: 'Fırsat Aşaması',
    请选择商机阶段: 'Lütfen Fırsat Aşamasını Seçin',
    商机属性: 'Fırsat Özelliği',
    请选择商机属性: 'Lütfen Fırsat Özelliğini Seçin',
    商机状态: 'Fırsat Durumu',
    请选择商机状态: 'Lütfen Fırsat Durumunu Seçin',
    预计金额: 'Tahmini Tutar',
    请输入预计成交金额: 'Lütfen Tahmini Anlaşma Tutarını Girin',
    请选择货币: 'Lütfen Para Birimini Seçin',
    预计成交: 'Tahmini Anlaşma',
    请输入预计成交日期: 'Lütfen Tahmini Anlaşma Tarihini Girin',
    结束: 'Sonlandır',
    商机详情: 'Fırsat Detayları',
    预计成交金额: 'Tahmini Anlaşma Tutarı',
    预计成交时间: 'Tahmini Anlaşma Zamanı',
    // ==================================== 报价单模块 ==============================
    报价单: 'Teklif Formu',
    请选择报价单: 'Lütfen Teklif Formu Seçin',
    报价详情: 'Teklif Detayları',
    单号: 'Sipariş Numarası',
    复用价格: 'Fiyatı Kopyala',
    时间: 'Zaman',
    我的报价: 'Benim Tekliflerim',
    '标题/编号': 'Başlık/Numara',
    订单Id: 'Sipariş ID',
    客户名: 'Müşteri Adı',
    单价: 'Birim Fiyat',
    请选择出入库类型: 'Lütfen Giriş/Çıkış Türünü Seçin',
    所有客户: 'Tüm Müşteriler',
    当前客户: 'Geçerli Müşteri',
    时间范围: 'Zaman Aralığı',
    价格范围: 'Fiyat Aralığı',
    请选择状态: 'Lütfen Durumu Seçin',
    关联商机: 'Fırsatı İlişkilendir',
    请选择商机: 'Lütfen Fırsatı Seçin',
    请选择币种: 'Lütfen Para Birimini Seçin',
    生成订单: 'Sipariş Oluştur',
    交付日期: 'Teslimat Tarihi',
    '订单交付/发货日期': 'Sipariş Teslim/Teslimat Tarihi',
    请选择交付日期: 'Lütfen Teslimat Tarihini Seçin',
    报价单名称: 'Teklif Formu Adı',
    报价单编码: 'Teklif Formu Kodu',
    产品数量: 'Ürün Miktarı',
    订单货币: 'Sipariş Para Birimi',
    编号: 'Numara',
    金额: 'Tutar',
    销售金额: 'Satış Tutarı',
    销售订单: 'Satış Siparişi',
    订单数量: 'Sipariş Miktarı',
    产品列表: 'Ürün Listesi',
    订单详情: 'Sipariş Detayları',
    发货计划: 'Teslimat Planı',
    回款计划: 'Tahsilat Planı',
    回款明细: 'Tahsilat Detayları',
    出入库记录: 'Stok Giriş/Çıkış Kayıtları',
    服务明细: 'Hizmet Detayları',
    绩效明细: 'Performans Detayları',
    开票计划: 'Fatura Planı',
    '退/换货': 'İade/Değişim',
    合同: 'Sözleşme',
    应收款: 'Tahsil Edilecek Tutar',
    未收款: 'Tahsil Edilmemiş Tutar',
    已收金额: 'Tahsil Edilen Tutar',
    '当前订单收款总和，不扣除退款':
      'Geçerli Siparişin Toplam Tahsilatı (İade Düşülmeden)',
    已退金额: 'İade Edilen Tutar',
    实收回款: 'Gerçekleşen Tahsilat',
    退款中金额: 'İade Edilmeyi Bekleyen Tutar',
    订单退款审批中金额: 'Sipariş İade Onay Bekleyen Tutar',
    '金额(应收/实收)': 'Tutar (Tahsil Edilecek/Gerçekleşen)',
    下单时间: 'Sipariş Tarihi',
    发货时间: 'Teslimat Tarihi',
    请选择发货时间: 'Lütfen Teslimat Tarihini Seçin',
    订单: 'Sipariş',
    签单类型: 'Anlaşma Türü',
    生成任务时的开始日期: 'Görev Oluşturulduğunda Başlangıç Tarihi',
    单据日期: 'Belge Tarihi',
    订单成交时日期: 'Siparişin Tamamlanma Tarihi',
    '订单退/换货': 'Sipariş İade/Değişim',
    请输入退款金额: 'Lütfen İade Tutarını Girin',
    退款金额为0表示只退货:
      'İade Tutarı 0 İse Sadece Ürün İade Edildi Anlamına Gelir',
    退款方式: 'İade Yöntemi',
    请选择退款方式: 'Lütfen İade Yöntemi Seçin',
    退款日期: 'İade Tarihi',
    请选择退款日期: 'Lütfen İade Tarihini Seçin',
    补差金额: 'Eksik Tutar',
    请输入补差金额: 'Lütfen Eksik Tutarı Girin',
    补差金额为0表示只换货:
      'Eksik Tutarı 0 İse Sadece Ürün Değiştirildi Anlamına Gelir',
    补差方式: 'Eksik Tutar Yöntemi',
    请选择补差方式: 'Lütfen Eksik Tutar Yöntemi Seçin',
    补差日期: 'Eksik Tutar Tarihi',
    请选择补差计划日期: 'Lütfen Eksik Tutar Planı Tarihini Seçin',
    换货商品为空表示只补差金额:
      'Değişim Ürünü Boşsa Sadece Eksik Tutar Anlamına Gelir',
    '退/换货备注': 'İade/Değişim Notu',
    请输入退货备注: 'Lütfen İade Notunu Girin',
    订单名称: 'Sipariş Adı',
    订单编码: 'Sipariş Kodu',
    发货日期: 'Teslimat Tarihi',
    包装要求: 'Paketleme Gereksinimleri',
    规格说明: 'Teknik Özellikler',
    价格条款: 'Fiyat Koşulları',
    订单进度: 'Sipariş İlerlemesi',
    // ==================================== 仓库模块 ==============================
    备货中: 'Stok Hazırlanıyor',
    备货完成: 'Stok Hazır',
    业务员: 'Satış Temsilcisi',
    计划时间: 'Planlanan Zaman',
    备货状态: 'Stok Durumu',
    发货计划详情: 'Sevkiyat Planı Detayları',
    发货进度: 'Sevkiyat İlerlemesi',
    计划日期: 'Planlanan Tarih',
    采购计划: 'Satın Alma Planı',
    箱单: 'Kutu Listesi',
    发货单: 'Sevkiyat Siparişi',
    请选择销售订单: 'Satış Siparişi Seçiniz',
    交货日期: 'Teslimat Tarihi',
    采购状态: 'Satın Alma Durumu',
    请选择采购状态: 'Satın Alma Durumu Seçiniz',
    添加采购计划: 'Satın Alma Planı Ekle',
    请输入采购数量: 'Satın Alma Miktarını Giriniz',
    添加到采购单: 'Satın Alma Siparişine Ekle',
    换货产品: 'Değiştirme Ürünleri',
    换货商品为空表示只补差额:
      'Değiştirme Ürünü Boşsa Sadece Farkı Karşıla Anlamına Gelir',
    出入库: 'Stok Giriş/Çıkış',
    出库: 'Stok Çıkışı',
    日期: 'Tarih',
    入库类型: 'Stok Giriş Türü',
    出库类型: 'Stok Çıkış Türü',
    出入库类型: 'Stok Giriş/Çıkış Türü',
    供应商名称: 'Tedarikçi Adı',
    '供应商/客户': 'Tedarikçi/Müşteri',
    盘点状态: 'Stok Sayım Durumu',
    '未作废数据删除，库存将不会恢复是否删除':
      'İptal Edilmemiş Veriler Silinirse, Stok Geri Yüklenmeyecektir. Silmek İstediğinize Emin Misiniz?',
    '此操作将会永久删除数据，是否继续':
      'Bu İşlem Verileri Kalıcı Olarak Silecek, Devam Etmek İstiyor Musunuz?',
    您确定要作废当前数据:
      'Şu Anki Veriyi İptal Etmek İstediğinizden Emin Misiniz?',
    // TODO: 2023-11-15 start
    '金额(应付/实付)': 'Tutar (Ödenmesi Gereken/Gerçekleşen)',
    实付金额: 'Gerçekleşen Tutar',
    '当前订单付款总和，扣除退款':
      'Geçerli Siparişin Toplam Ödemesi (İade Düşülmeden)',
    未付金额: 'Ödenmemiş Tutar',
    采购: 'Satın Alma',
    采购单详情: 'Satın Alma Siparişi Detayları',
    采购进度: 'Satın Alma İlerlemesi',
    付款计划: 'Ödeme Planı',
    付款明细: 'Ödeme Detayları',
    采购数量: 'Satın Alma Miktarı',
    // ==================================== 供应商模块 ==============================
    供应商详情: 'Tedarikçi Detayları',
    '确认删除？': 'Silme işlemini onaylayın?',
    消息: 'Mesaj',
    暂无评论: 'Henüz yorum yok',
    暂无信息: 'Henüz bilgi yok',
    素材选择: 'Malzeme Seçimi',
    '文件已存在下载队列中！': 'Dosya indirme sırasında zaten var!',
    新增故事: 'Yeni Hikaye Ekle',
    请输入内容: 'Lütfen içerik girin',
    只能选择一张: 'Yalnızca bir tane seçebilirsiniz',
    请选择邮件模板: 'Lütfen e-posta şablonunu seçin',
    '正在生成中...': 'Oluşturuluyor...',
    '该附件格式不支持预览，请下载后查看':
      'Bu ek formatı önizlemeyi desteklemiyor, lütfen indirdikten sonra görüntüleyin',
    设备: 'Cihaz',
    总数: 'Toplam',
    在线: 'Çevrimiçi',
    离线: 'Çevrimdışı',
    故障: 'Arızalı',
    在线率: 'Çevrimiçi Oranı',
    故障率: 'Arıza Oranı',
    '确认要离开本页面吗？': 'Bu sayfadan ayrılmak istediğinizden emin misiniz?',
    历史报价: 'Geçmiş Teklifler',
    '产品名称/编码': 'Ürün Adı/Kodu',
    '智慧商贸-ERP': 'Akıllı Ticaret-ERP',
    '正在加载中...': 'Yükleniyor...',
    简体中文: '简体中文',
    繁體中文: '繁體中文',
    已创建: 'Oluşturuldu',
    进行中: 'Devam Ediyor',
    已完成: 'Tamamlandı',
    折线图: 'Çizgi Grafiği',
    柱状图: 'Sütun Grafiği',
    周: 'Hafta',
    已作废: 'İptal Edildi',
    已过期: 'Süresi Dolmuş',
    编辑中: 'Düzenleniyor',
    待支付: 'Ödeme Bekleniyor',
    已付定金: 'Peşinat Ödendi',
    已支付: 'Ödendi',
    已发货: 'Gönderildi',
    已签收: 'Teslim Alındı',
    '报价单-出口': 'Teklif Formu - İhracat',
    '报价单-内销': 'Teklif Formu - İç Satış',
    '报价单-门市': 'Teklif Formu - Mağaza',
    '报价单-淘宝': 'Teklif Formu - Taobao',
    '报价单-云工厂': 'Teklif Formu - Cloud Factory',
    '报价单-智能工厂': 'Teklif Formu - Akıllı Fabrika',
    禁用: 'Devre Dışı',
    启用: 'Etkin',
    隐藏: 'Gizle',
    显示: 'Göster',
    未知: 'Bilinmiyor',
    抖音: 'TikTok',
    快手: 'Kwai',
    待确定: 'Onay Bekliyor',
    有效: 'Geçerli',
    无效: 'Geçersiz',
    推广微信公众号: 'WeChat Hesabını Tanıt',
    推广抖音账号: 'TikTok Hesabını Tanıt',
    推广抖音视频: 'TikTok Videosunu Tanıt',
    推广快手账号: 'Kwai Hesabını Tanıt',
    推广快手视频: 'Kwai Videosunu Tanıt',
    销售收入: 'Satış Geliri',
    押金收入: 'Teminat Geliri',
    租赁收入: 'Kiralama Geliri',
    购买支出: 'Satın Alma Harcamaları',
    押金退还: 'Teminat İadesi',
    男: 'Erkek',
    女: 'Kadın',
    保密: 'Gizli',
    待处理: 'İşlem Bekliyor',
    处理中: 'İşlemde',
    已处理: 'İşlendi',
    文本框: 'Metin Kutusu',
    多行文本框: 'Çoklu Satır Metin Kutusu',
    数字文本框: 'Sayısal Metin Kutusu',
    日期选择框: 'Tarih Seçim Kutusu',
    状态选择: 'Durum Seçimi',
    单选框: 'Tekli Seçenek Kutusu',
    多选框: 'Çoklu Seçenek Kutusu',
    下拉单选择: 'Açılır Tekli Seçim',
    下拉多选择: 'Açılır Çoklu Seçim',
    单图片: 'Tekli Resim',
    多图片: 'Çoklu Resim',
    日期选择: 'Tarih Seçimi',
    未读: 'Okunmamış',
    已读: 'Okunmuş',
    待审核: 'Onay Bekliyor',
    私有: 'Özel',
    公海: 'Ortak Sahil',
    无: 'Yok',
    低: 'Düşük',
    高: 'Yüksek',
    离职: 'Ayrıldı',
    在职: 'Görevde',
    销售: 'Satış',
    按数量区间设置: 'Miktar Aralığına Göre Ayarla',
    '按客户/供应商设置': 'Müşteri/Tedarikçiye Göre Ayarla',
    待接受: 'Kabul Bekliyor',
    已接受: 'Kabul Edildi',
    不接受: 'Kabul Edilmedi',
    公司: 'Şirket',
    银行账户: 'Banka Hesabı',
    单位地址: 'Birim Adresi',
    '千美元)': 'Bin Amerikan Doları)',
    宽松默认: 'Varsayılan Gevşek',
    严格模式: 'Katı Mod',
    '支持jpg、jpeg、png格式，单次可最多选择':
      'jpg, jpeg, png Formatını Destekler, Tek Seferde En Fazla Seçebilirsiniz',
    '张图片，每张不可大于': 'resim, her biri büyük olmamalıdır',
    如果大于: 'Büyükse',
    会自动为您过滤: 'Otomatik olarak filtreler',
    查看大图: 'Büyük Resmi Görüntüle',
    '正在上传中...': 'Yükleniyor...',
    当前上传成功数: 'Şu Anda Başarıyla Yüklenen',
    张: 'resim',
    当前上传失败数: 'Şu Anda Başarısız Yüklenen',
    开始上传: 'Yüklemeye Başla',
    '上传完成!': 'Yükleme Tamamlandı!',
    共上传: 'Toplam Yükleme',
    张图片: 'resim',
    '上传失败,文件大小为': 'Yükleme Başarısız, Dosya Boyutu',
    当前限制选择: 'Şu Anda Seçim Sınırı',
    '个文件，本次选择了': 'Dosya, bu sefer seçildi',
    个文件: 'dosya',
    密码不能少于: 'Şifre En Az Olmalıdır',
    位: 'karakter',
    销售前: 'Satış Öncesi',
    更新日志: 'Güncelleme Günlüğü',
    用户管理: 'Kullanıcı Yönetimi',
    角色管理: 'Rol Yönetimi',
    部门管理: 'Departman Yönetimi',
    菜单管理: 'Menü Yönetimi',
    系统日志: 'Sistem Günlüğü',
    组件: 'Bileşenler',
    其他: 'Diğer',
    角色权限: 'Rol İzinleri',
    外链: 'Harici Bağlantı',
    常规图标: 'Normal İkonlar',
    小清新图标: 'Yeni Temiz İkonlar',
    综合表格: 'Genel Tablo',
    行内编辑表格: 'Satır İçi Düzenleme Tablosu',
    自定义表格: 'Özel Tablo',
    表单: 'Form',
    综合表单: 'Genel Form',
    分步表单: 'Adım Adım Form',
    按钮: 'Düğme',
    文字链接: 'Metin Bağlantısı',
    输入框: 'Giriş Kutusu',
    计数器: 'Sayıcı',
    选择器: 'Seçici',
    开关: 'Anahtar',
    滑块: 'Kaydırıcı',
    时间选择器: 'Zaman Seçici',
    日期选择器: 'Tarih Seçici',
    日期时间选择器: 'Tarih ve Zaman Seçici',
    评分: 'Puan Verme',
    工作流: 'İş Akışı',
    图表: 'Grafikler',
    打印: 'Yazdır',
    手机预览: 'Mobil Önizleme',
    时间线: 'Zaman Çizgisi',
    数字自增长: 'Sayısal Artış',
    多标签: 'Çoklu Etiketler',
    动态Meta: 'Dinamik Meta',
    动态路径参数: 'Dinamik Yol Parametreleri',
    列表: 'Liste',
    多级路由缓存: 'Çoklu Düzeyli Yol Önbelleği',
    多级路由: 'Çoklu Düzeyli Yollar',
    拖拽: 'Sürükle ve Bırak',
    卡片拖拽: 'Kart Sürükle ve Bırak',
    加载: 'Yükleme',
    视频播放器: 'Video Oynatıcı',
    编辑器: 'Editör',
    富文本编辑器: 'Zengin Metin Editörü',
    错误日志模拟: 'Hata Günlüğü Simülasyonu',
    导出Excel: 'Excel Dışa Aktar',
    导出选中行Excel: "Seçili Satırları Excel'e Aktar",
    导出合并Excel: "Birleştirilmiş Excel'i Aktar",
    动画: 'Animasyonlar',
    第三方登录: 'Üçüncü Taraf Girişi',
    物料源: 'Malzeme Kaynağı',
    物料市场: 'Malzeme Pazarı',
    清空消息: 'Mesajları Temizle',
    关闭其他: 'Diğerlerini Kapat',
    关闭左侧: 'Sol Tarafı Kapat',
    关闭右侧: 'Sağ Tarafı Kapat',
    关闭全部: 'Tümünü Kapat',
    主题配置: 'Tema Ayarları',
    常用设置: 'Genel Ayarlar',
    其它设置: 'Diğer Ayarlar',
    分栏布局时生效: 'Sütun Düzeni Kullanıldığında Geçerlidir',
    标签开启时生效: 'Etiketler Açık Olduğunda Geçerlidir',
    '布局配置仅在电脑视窗下生效，手机视窗时将默认锁定为纵向布局':
      'Düzen Ayarları Yalnızca Bilgisayar Ekranında Geçerlidir, Telefon Ekranında Otomatik Olarak Dikey Düzen Olarak Kilitlenir',
    默认: 'Varsayılan',
    海洋之心: 'Deniz Kalbi',
    海洋之心sss: 'Deniz Kalbi SSS',
    绿荫草场: 'Yeşil Çayır',
    碰触纯白: 'Saf Beyaz',
    月上重火: 'Ayın Üstünde Ateş',
    蓝黑: 'Mavi Siyah',
    蓝白: 'Mavi Beyaz',
    绿黑: 'Yeşil Siyah',
    绿白: 'Yeşil Beyaz',
    红黑: 'Kırmızı Siyah',
    红白: 'Kırmızı Beyaz',
    渐变: 'Gradyan',
    布局: 'Düzen',
    分栏: 'Sütunlar',
    纵向: 'Dikey',
    横向: 'Yatay',
    综合: 'Genel',
    常规: 'Standart',
    浮动: 'Sürekli',
    菜单背景: 'Menü Arkaplanı',
    分栏风格: 'Sütun Stili',
    箭头: 'Oklar',
    头部固定: 'Üst Sabit',
    固定: 'Sabit',
    不固定: 'Sabit Değil',
    标签: 'Etiketler',
    标签风格: 'Etiket Stili',
    标签图标: 'Etiket İkonları',
    卡片: 'Kartlar',
    灵动: 'Canlı',
    圆滑: 'Yumuşak',
    进度条: 'İlerleme Çubuğu',
    随机换肤: 'Rastgele Tema Değiştirme',
    购买源码: 'Kaynak Kodu Satın Al',
    拷贝源码: 'Kaynak Kodunu Kopyala',
    清理缓存: 'Önbelleği Temizle',
    恢复默认: 'Varsayılana Geri Dön',
    '检测到新版本，正在下载中，请稍后...':
      'Yeni bir sürüm bulundu, indiriliyor, lütfen bekleyin...',
    温馨提示: 'Dikkat',
    更新版本完成: 'Güncelleme Tamamlandı',
    后刷新项目: 'Proje Sonra Yeniden Yüklenecektir',
    我的待办: 'Bekleyen İşlerim',
    已办事项: 'Tamamlanan İşler',
    经营分析: 'İşletme Analizi',
    决策辅助: 'Karar Destek',
    采购订单: 'Satın Alma Siparişleri',
    供应管理: 'Tedarik Yönetimi',
    客户管理: 'Müşteri Yönetimi',
    商机管理: 'Fırsat Yönetimi',
    对外报价: 'Dışa Fiyatlandırma',
    财务: 'Finans',
    仓库管理: 'Depo Yönetimi',
    收款计划: 'Tahsilat Planı',
    收款明细: 'Tahsilat Detayları',
    开票详情: 'Fatura Detayları',
    库存盘点: 'Stok Sayımı',
    库存报表: 'Stok Raporları',
    库存余额: 'Stok Bakiyesi',
    收发明细: 'Alım ve Gönderim Detayları',
    收发汇总: 'Alım ve Gönderim Toplamı',
    单据列表: 'Belge Listesi',
    产品入库: 'Ürün Girişi',
    产品出库: 'Ürün Çıkışı',
    产品调拨: 'Ürün Transferi',
    产品组装: 'Ürün Montajı',
    产品拆卸: 'Ürün Demontajı',
    绩效: 'Performans',
    我的绩效: 'Benim Performansım',
    团队绩效: 'Takım Performansı',
    绩效核定: 'Performans Onayı',
    绩效规则: 'Performans Kuralları',
    任务: 'Görevler',
    任务列表: 'Görev Listesi',
    电商: 'E-Ticaret',
    首页设置: 'Ana Sayfa Ayarları',
    商品: 'Ürünler',
    轮播图: 'Slider',
    文章管理: 'Makale Yönetimi',
    设置: 'Ayarlar',
    公司信息: 'Şirket Bilgileri',
    销售配置: 'Satış Ayarları',
    产品配置: 'Ürün Ayarları',
    产品素材: 'Ürün Materyali',
    模版管理: 'Şablon Yönetimi',
    扩展字段: 'Genişletilmiş Alanlar',
    系统设置: 'Sistem Ayarları',
    操作日志: 'İşlem Kayıtları',
    公司列表: 'Şirket Listesi',
    用户列表: 'Kullanıcı Listesi',
    权限管理: 'İzin Yönetimi',
    行业管理: 'Sektör Yönetimi',
    资源: 'Kaynaklar',
    店铺选址: 'Mağaza Seçimi',
    教程管理: 'Eğitim Yönetimi',
    超级管理员: 'Süper Yönetici',
    '没有菜单权限！': 'Menü Yetkiniz Yok!',
    '路由格式返回有误！': 'Rota Formatı Yanlış Döndü!',
    运行中: 'Çalışıyor',
    已下线: 'Çevrimdışı',
    游客: 'Ziyaretçi',
    '未开启登录拦截)': 'Giriş Engellemesi Açılmadı)',
    早上好: 'Günaydın',
    上午好: 'İyi sabahlar',
    中午好: 'İyi öğlenler',
    下午好: 'İyi günler',
    晚上好: 'İyi akşamlar',
    欢迎登录: 'Hoş geldiniz',
    '登录接口异常，未正确返回': 'Giriş Arayüzü Anormal, Doğru Dönüş Yapmadı',
    '核心接口异常，请检查返回JSON格式是否正确，是否正确返回':
      'Çekirdek Arayüz Anormal, JSON Formatı Doğru Mu Kontrol Edin, Doğru Mu Dönüş Yaptı',
    '核心接口异常，请检查返回JSON格式是否正确':
      'Çekirdek Arayüz Anormal, JSON Formatı Doğru Mu Kontrol Edin',
    复制: 'Kopyala',
    成功: 'Başarılı',
    失败: 'Başarısız',
    '重量/毛重': 'Ağırlık/Brüt Ağırlık',
    产品证书: 'Ürün Sertifikası',
    推荐价格: 'Tavsiye Edilen Fiyat',
    邮编: 'Posta Kodu',
    传真: 'Faks',
    官网: 'Resmi Web Sitesi',
    企业状态: 'Şirket Durumu',
    营收: 'Gelir',
    员工人数: 'Çalışan Sayısı',
    公司类型: 'Şirket Türü',
    所属国家: 'Ülke',
    所属城市: 'Şehir',
    简介: 'Hakkında',
    产品服务: 'Ürün Hizmetleri',
    请输入: 'Lütfen girin',
    产品价格策略: 'Ürün Fiyatlandırma Stratejisi',
    起始价格: 'Başlangıç Fiyatı',
    分类logo: 'Kategori Logosu',
    建议尺寸: 'Önerilen Boyut',
    分类banner: 'Kategori Bannerı',
    请输入分类描述: 'Kategori Açıklamasını Girin',
    退款金额为: 'İade Tutarı',
    表示只退货: 'yalnızca ürün iadesi',
    补差金额为: 'Düzeltme Tutarı',
    表示只换货: 'yalnızca ürün değişimi',
    请输入客户编码: 'Müşteri Kodunu Girin',
    请输入联系人: 'Lütfen kişiyi girin',
    请输入客户Whats: "Müşteri Whats'i girin",
    规则名称: 'Kurallar Adı',
    请输入规则名称: 'Kurallar Adını Girin',
    绩效类型: 'Performans Türü',
    请选择绩效类型: 'Performans Türünü Seçin',
    优先级: 'Öncelik',
    请输入优先级: 'Önceliği Girin',
    请输入编码: 'Kodu Girin',
    请选择分类: 'Kategoriyi Seçin',
    请输入详细地址: 'Detaylı Adresi Girin',
    固定电话: 'Sabit Telefon',
    请输入固定电话: 'Sabit Telefonu Girin',
    请输入邮箱: 'Lütfen e-postayı girin',
    请输入QQ: "Lütfen QQ'yu girin",
    网址: 'Web Sitesi',
    请输入网址: 'Web Sitesini Girin',
    添加到采购计划: 'Satın Alma Planına Ekle',
    请输入数量: 'Lütfen miktarı girin',
    选择负责人: 'Sorumlu kişiyi seçin',
    服务年限: 'Hizmet Süresi',
    '请输入服务年限(报告年限)': 'Hizmet süresini girin (rapor süresi)',
    任务日期: 'Görev Tarihi',
    请选择任务日期: 'Görev tarihini seçin',
    请输入任务金额: 'Görev tutarını girin',
    请选择关联销售订单: 'İlgili satış siparişini seçin',
    请输入回款金额: 'Ödeme miktarını girin',
    请选择回款日期: 'Ödeme tarihini seçin',
    批量生成回款计划: 'Toplu ödeme planı oluştur',
    首次回款日期: 'İlk ödeme tarihini seçin',
    请选择首次回款日期: 'İlk ödeme tarihini seçin',
    回款间隔时间: 'Ödeme aralığı süresi',
    请输入回款间隔时间: 'Ödeme aralığı süresini girin',
    总回款期数: 'Toplam ödeme dönemi sayısı',
    请输入总回款期数: 'Toplam ödeme dönemi sayısını girin',
    请选择关联回款计划: 'İlgili ödeme planını seçin',
    渠道: 'Kanal',
    请选择渠道: 'Kanalı seçin',
    凭证: 'Belge',
    请选择采购订单: 'Satın alma siparişini seçin',
    请选择关联采购订单: 'İlgili satın alma siparişini seçin',
    付款金额: 'Ödeme tutarı',
    请输入付款金额: 'Ödeme tutarını girin',
    请选择付款日期: 'Ödeme tarihini seçin',
    批量生成付款计划: 'Toplu ödeme planı oluştur',
    首次付款日期: 'İlk ödeme tarihini seçin',
    请选择首次付款日期: 'İlk ödeme tarihini seçin',
    付款间隔时间: 'Ödeme aralığı süresi',
    请输入付款间隔时间: 'Ödeme aralığı süresini girin',
    总付款期数: 'Toplam ödeme dönemi sayısı',
    请输入总付款期数: 'Toplam ödeme dönemi sayısını girin',
    请选择关联付款计划: 'İlgili ödeme planını seçin',
    请选择发票抬头: 'Fatura başlığını seçin',
    开票金额: 'Fatura tutarı',
    请输入开票金额: 'Fatura tutarını girin',
    含税金额: 'Vergi dahil tutar',
    商品名称: 'Ürün adı',
    请输入商品名称: 'Ürün adını girin',
    商品编号: 'Ürün numarası',
    请输入商品编号: 'Ürün numarasını girin',
    规格型号: 'Ürün özellikleri ve modeli',
    请输入商品规格型号: 'Ürün özellikleri ve modelini girin',
    商品单位: 'Ürün birimi',
    请输入商品单位: 'Ürün birimini girin',
    发票类型: 'Fatura türü',
    请选择发票类型: 'Fatura türünü seçin',
    税率: 'Vergi oranı',
    请输入税率: 'Vergi oranını girin',
    商品数量: 'Ürün miktarı',
    请输入商品数量: 'Ürün miktarını girin',
    开票日期: 'Fatura tarihi',
    请选择开票日期: 'Fatura tarihini seçin',
    开票明细: 'Fatura detayları',
    员工离职交接: 'Personel istifası devir teslimi',
    交接人: 'Devralan kişi',
    请选择交接人: 'Devralan kişiyi seçin',
    单据时间: 'Belge tarihi',
    请选择单据时间: 'Belge tarihini seçin',
    箱数: 'Koli sayısı',
    请输入预估箱数: 'Tahmini koli sayısını girin',
    装箱预估数量: 'Tahmini ambalaj miktarı',
    出库单: 'Çıkış belgesi',
    请选择出库单: 'Çıkış belgesini seçin',
    正: 'Düz',
    侧: 'Yan',
    唛信息: 'Marka bilgisi',
    目的地: 'Varış yeri',
    请输入收货目的地: 'Teslimat yerini girin',
    箱号标识: 'Koli numarası işareti',
    '如M、B': 'Örneğin M, B',
    产地: 'Menşe',
    请输入产地: 'Menşe bilgisini girin',
    订单号: 'Sipariş numarası',
    将自动填充: 'Otomatik doldurulacak',
    净重: 'Net ağırlık',
    毛重: 'Brüt ağırlık',
    产品盘点: 'Ürün envanteri',
    请选择单据日期: 'Belge tarihini seçin',
    组装: 'Montaj',
    拆卸: 'Sökme',
    请输选择: 'Lütfen seçin',
    入库仓库: 'Giriş deposu',
    出库仓库: 'Çıkış deposu',
    费用: 'Maliyet',
    存为模版: 'Şablona kaydet',
    拆卸产品: 'Sökülen ürün',
    请选择拆卸产品: 'Sökülen ürünü seçin',
    图片名称: 'Resim adı',
    请输入图片: 'Resim adını girin',
    链接地址: 'Bağlantı adresi',
    请输入图片链接地址: 'Resim bağlantı adresini girin',
    文章: 'Makale',
    文章标题: 'Makale başlığı',
    请输入文章标题: 'Makale başlığını girin',
    文章类型: 'Makale türü',
    请选择文章类型: 'Makale türünü seçin',
    文章内容: 'Makale içeriği',
    请输入文章内容: 'Makale içeriğini girin',
    提单详情: 'Taşıma detayı',
    采购商: 'Alıcı',
    产品信息: 'Ürün Bilgisi',
    总金额: 'Toplam Tutar',
    产品描述: 'Ürün Açıklaması',
    货运信息: 'Nakliye Bilgisi',
    原产国: 'Menşe Ülke',
    目的国: 'Varış Ülke',
    运输方式: 'Nakliye Yolu',
    数据来源: 'Veri Kaynağı',
    请输入姓名: 'Lütfen adınızı girin',
    请输入部门: 'Lütfen bölümünüzü girin',
    请输入职务: 'Lütfen görevinizi girin',
    绩效月份: 'Performans Ayı',
    请选择绩效月份: 'Performans ayını seçin',
    计提人: 'Hesap Hesaplayan',
    请选计提人: 'Hesap hesaplayanı seçin',
    请选择调出仓库: 'Çıkış depoyu seçin',
    请选择调入仓库: 'Giriş depoyu seçin',
    回款类型: 'Ödeme Türü',
    请选择回款类型: 'Ödeme türünü seçin',
    退款: 'İade',
    回款: 'Ödeme',
    付款类型: 'Ödeme Türü',
    请选择付款类型: 'Ödeme türünü seçin',
    请选择优先级: 'Önceliği seçin',
    关键词: 'Anahtar Kelime',
    请选择上下架状态: 'Yayın durumunu seçin',
    只允许输入数字和字母: 'Yalnızca rakam ve harf girişi izin verilir',
    请输入产品关键词: 'Ürün anahtar kelimesini girin',
    请输入HS编码: 'HS kodunu girin',
    请输入供应商名称: 'Tedarikçi adını girin',
    请输入采购商名称: 'Alıcı adını girin',
    请选择原产国: 'Menşe ülkesini seçin',
    请选择目的国: 'Varış ülkesini seçin',
    起始时间: 'Başlangıç ​​Zamanı',
    请输入关键词搜索: 'Anahtar kelime araması yapın',
    请输入公司名称搜索: 'Şirket adı araması yapın',
    请输入产品名称搜索: 'Ürün adı araması yapın',
    请选择国家ISO编码: 'Ülke ISO kodunu seçin',
    请选择公司经营状态: 'Şirket işletme durumunu seçin',
    请选择公司营收范围: 'Şirket gelir aralığını seçin',
    请选择公司人数: 'Şirket çalışan sayısını seçin',
    一: 'Bir',
    二: 'İki',
    三: 'Üç',
    四: 'Dört',
    五: 'Beş',
    六: 'Altı',
    刚刚: 'Şimdi',
    分钟前: 'Dakika önce',
    小时前: 'Saat önce',
    天前: 'Gün önce',
    时: 'saat',
    分: 'dakika',
    是一个函数: 'Bir işlevdir',
    服务器成功返回请求数据: 'Sunucu isteği başarıyla veri döndürdü',
    新建或修改数据成功: 'Yeni oluşturulan veya güncellenen veriler başarıyla',
    '一个请求已经进入后台排队(异步任务)':
      'Bir istek zaten arka planda sıraya girdi (asyon görevi)',
    删除数据成功: 'Veri başarıyla silindi',
    发出信息有误: 'Bilgi yanlış gönderildi',
    '用户没有权限(令牌失效、用户名、密码错误、登录过期)':
      'Kullanıcının izni yok (jeton geçersiz, kullanıcı adı, şifre yanlış, oturum süresi doldu)',
    令牌过期: 'Jeton süresi doldu',
    '用户得到授权，但是访问是被禁止的':
      'Kullanıcı yetkilendirildi ancak erişim yasaklandı',
    访问资源不存在: 'Erişilen kaynak mevcut değil',
    请求格式不可得: 'İstek biçimi alınamaz',
    '请求资源被永久删除，且不会被看到':
      'İstek kaynağı kalıcı olarak silindi ve görüntülenmeyecek',
    服务器发生错误: 'Sunucuda bir hata oluştu',
    网关错误: 'Ağ geçidi hatası',
    '服务不可用，服务器暂时过载或维护':
      'Hizmet kullanılamaz, sunucu geçici olarak yük altında veya bakımda',
    网关超时: 'Ağ geçidi zaman aşımına uğradı',
    '无网络！,请连接网络！！': 'Ağ yok! Lütfen ağı bağlayın!',
    '网络不给力！,请检查网络！！': 'Ağ güçsüz! Lütfen ağı kontrol edin!',
    '服务端正在升级中，请稍后再试':
      'Sunucu şu anda güncelleniyor, lütfen daha sonra tekrar deneyin',
    提审并通过: 'İnceleme ve onayla',
    转: 'Devret',
    切换公司主体: 'Şirket anahtarını değiştir',
    '确定解绑企业微信?':
      'WeChat Enterprise bağlantısını çözmek istediğinizden emin misiniz?',
    主体未设置企业微信: 'Ana konu WeChat Enterprise ayarlanmadı',
    扫描二维码联系工作人员:
      'Personel ile iletişim kurmak için QR kodunu tarayın',
    正在导出的文件: 'Dışa aktarılan dosya',
    '版本)': 'Sürüm)',
    '异常捕获(温馨提示：错误必须解决)':
      'İstisna yakalanıyor (Unutmayın: Hata çözülmelidir)',
    报错路由: 'Hata Yolu',
    错误信息: 'Hata Mesajı',
    错误详情: 'Hata Detayı',
    暂不显示: 'Şu an gösterilmiyor',
    百度搜索: 'Baidu Arama',
    谷歌搜索: 'Google Arama',
    最近访问: 'Son Ziyaret',
    总览: 'Genel Bakış',
    开启全屏失败: 'Tam ekran açma başarısız oldu',
    服务将于: 'Hizmet sona erecek',
    天后到期: 'gün sonra sona erecek',
    服务永不到期: 'Hizmet hiç bitmez',
    站内信: 'İç Mesajlar',
    全部已读: 'Hepsini okundu olarak işaretle',
    消息状态: 'Mesaj Durumu',
    请选择消息类型: 'Mesaj türünü seçin',
    标记已读: 'Okundu olarak işaretle',
    没有更多了: 'Daha fazla yok',
    清空消息成功: 'Mesajları temizleme başarılı',
    自有产品: 'Kendi Ürünler',
    '已在当前产品！请换一个试试！':
      'Zaten mevcut bir üründür! Lütfen başka bir tane deneyin!',
    电商网站: 'E-Ticaret Web Sitesi',
    '支持纵向布局、分栏布局、综合布局、常规布局，不支持横向布局、浮动布局':
      'Dikey düzen, sütun düzeni, karma düzen ve normal düzeni destekler, yatay düzen ve kaydırma düzenini desteklemez',
    '请输入密码(密码在购买时获得，跳转后需登录购买时绑定的github账号)':
      'Lütfen şifrenizi girin (şifre, satın alırken alındı ve devam etmek için satın alma sırasında bağlı olan GitHub hesabına giriş yapmanız gerekiyor)',
    '秘钥不正确！': 'Anahtar geçersiz!',
    错误拦截: 'Hata Engellemesi',
    '检测到您当前浏览器使用的是IE内核，自':
      'Şu anda kullandığınız tarayıcının IE çekirdeğini kullandığınız tespit edildi,',
    '月起，微软已宣布弃用IE，且不再对IE提供任何更新维护，请':
      "Microsoft IE'yi terk etti ve IE'ye herhangi bir güncelleme veya bakım sunmayacak, lütfen",
    '基于admin-plus构建': 'admin-plus tabanlı oluşturulmuş',
    '抱歉!': 'Üzgünüz!',
    '您没有操作角色...': 'Şu anda bir işlem rolünüz yok...',
    '当前帐号没有操作角色,请联系管理员。':
      'Mevcut hesabınızda işlem rolü yok, lütfen yönetici ile iletişime geçin.',
    '当前页面不存在...': 'Mevcut sayfa mevcut değil...',
    '请检查您输入的网址是否正确，或点击下面的按钮返回首页。':
      'Lütfen girdiğiniz web adresini kontrol edin veya ana sayfaya dönmek için aşağıdaki düğmeye tıklayın.',
    返回首页: 'Ana sayfaya dön',
    '重量(KG)': 'Ağırlık (KG)',
    交易次数: 'İşlem Sayısı',
    交易重量: 'İşlem Ağırlığı',
    交易金额: 'İşlem Tutarı',
    出口: 'İhracat',
    期间采购共计: 'Dönemde Toplam Satın Alma',
    次: 'defa',
    采购次数最高: 'En Yüksek Satın Alma Sayısı',
    采购次数最低: 'En Düşük Satın Alma Sayısı',
    采购商数量: 'Alıcı Sayısı',
    供应商数量: 'Tedarikçi Sayısı',
    月度趋势: 'Aylık Trend',
    已添加为客户: 'Müşteri olarak eklendi',
    添加客户: 'Müşteri Ekle',
    进口详单: 'İthalat Detayları',
    出口详单: 'İhracat Detayları',
    贸易总览: 'Ticaret Genel Bakış',
    更新数据: 'Veriyi Güncelle',
    区域分布: 'Bölge Dağılımı',
    编码分布: 'Kod Dağılımı',
    货运历史: 'Nakliye Geçmişi',
    进口: 'İthalat',
    贸易伙伴: 'Ticaret Ortağı',
    搜索时间: 'Arama Zamanı',
    页码: 'Sayfa Numarası',
    查看数据: 'Veriyi Görüntüle',
    无搜索结果: 'Arama sonucu bulunamadı',
    国家: 'Ülke',
    经营状态: 'İşletme Durumu',
    营收范围: 'Gelir Aralığı',
    公司人数: 'Çalışan Sayısı',
    搜索历史: 'Arama Geçmişi',
    历史搜索: 'Geçmiş Aramalar',
    公司本地名称: 'Şirket Yerel Adı',
    城市: 'Şehir',
    已解锁: 'Kilit açıldı',
    未解锁: 'Kilitli',
    详情: 'Detaylar',
    '您确定要解锁当前客户数据?':
      'Mevcut müşteri verilerini kilitlemek istediğinizden emin misiniz?',
    产品搜索: 'Ürün Arama',
    公司搜索: 'Şirket Arama',
    交易分析: 'İşlem Analizi',
    分析报告: 'Analiz Raporu',
    回款详情: 'Ödeme Detayları',
    '您确定要对当前数据进行提审？':
      'Mevcut verileri incelemek istediğinizden emin misiniz?',
    '您确定要对当前数据进行提审并通过？':
      'Mevcut verileri incelemek ve onaylamak istediğinizden emin misiniz?',
    回款时间: 'Ödeme Tarihi',
    审核人: 'Denetçi',
    审核时间: 'Denetim Zamanı',
    回款计划详情: 'Ödeme Planı Detayları',
    '您确定要对当前数据生成发货单？':
      'Mevcut veriler için gönderim belgesi oluşturmak istediğinizden emin misiniz?',
    计划回款金额: 'Planlanan Ödeme Tutarı',
    付款详情: 'Ödeme Detayları',
    付款时间: 'Ödeme Tarihi',
    开票计划详情: 'Fatura Planı Detayları',
    开票公司: 'Fatura Şirketi',
    计划开票金额: 'Planlanan Fatura Tutarı',
    计划开票时间: 'Planlanan Fatura Tarihi',
    开票商品名称: 'Fatura Ürün Adı',
    开票商品编号: 'Fatura Ürün Kodu',
    商品规格型号: 'Ürün Özellik ve Modeli',
    开票商品单位: 'Fatura Ürün Birimi',
    开票税率: 'Fatura Vergi Oranı',
    开票商品数量: 'Fatura Ürün Miktarı',
    付款计划详情: 'Ödeme Planı Detayları',
    计划付款金额: 'Planlanan Ödeme Tutarı',
    需要数量: 'Gereken Miktar',
    仓库名称: 'Depo Adı',
    剩余数量: 'Kalan Miktar',
    分配库存: 'Stok Dağıtımı',
    关联订单: 'İlgili Siparişler',
    开票公司名称: 'Fatura Şirketi Adı',
    一键复制: 'Hızlı Kopyala',
    计划: 'Plan',
    计划开票占比: 'Planlanan Fatura Oranı',
    开票时间: 'Fatura Tarihi',
    付款编号: 'Ödeme Numarası',
    关联采购单: 'İlgili Satın Alma Siparişleri',
    计划编号: 'Plan Numarası',
    期数: 'Dönem',
    第: 'Bölüm',
    期: 'Bölüm',
    计划付款占比: 'Plan Ödeme Oranı',
    采购金额: 'Satın Alma Tutarı',
    已付款金额占比: 'Ödenen Tutar Oranı',
    '当前期数/总期数': 'Mevcut Dönem/Toplam Dönem',
    '您确定当前数据快速付款？':
      'Mevcut veriyi hızlı ödemek istediğinizden emin misiniz?',
    计划回款占比: 'Plan Geri Ödeme Oranı',
    '已回款金额/占比': 'Ödenen Tutar Oranı',
    '您确定当前数据快速回款？':
      'Mevcut veriyi hızlı geri almak istediğinizden emin misiniz?',
    回款编号: 'Geri Ödeme Numarası',
    客户排行: 'Müşteri Sıralaması',
    毛利分析: 'Kar Analizi',
    销量最高: 'En Yüksek Satış',
    毛利最高: 'En Yüksek Kar Marjı',
    采购数量最大: 'En Yüksek Satın Alma Miktarı',
    采购利润最高: 'En Yüksek Satın Alma Karı',
    采购额: 'Satın Alma Tutarı',
    销售分析: 'Satış Analizi',
    成交最多的销售: 'En Fazla İşlem Yapan Satış',
    销量最高的产品: 'En Yüksek Satışlı Ürün',
    毛利最多的销售: 'En Yüksek Kar Marjına Sahip Satış',
    毛利最高的产品: 'En Yüksek Kar Marjına Sahip Ürün',
    最近爆发的销售: 'Son Zamanlarda Yükselen Satışlar',
    上月增长最高的产品: 'Geçen Ay En Fazla Büyüyen Ürün',
    最近沉默的销售: 'Son Zamanlarda Düşen Satışlar',
    上月下降最多的产品: 'Geçen Ay En Fazla Düşen Ürün',
    销售额: 'Satış Tutarı',
    产品分析: 'Ürün Analizi',
    最畅销的产品: 'En Çok Satılan Ürünler',
    最赚钱的产品: 'En Karlı Ürünler',
    最近爆发产品: 'Son Zamanlarda Yükselen Ürünler',
    最近沉默产品: 'Son Zamanlarda Düşen Ürünler',
    产品销售量: 'Ürün Satış Miktarı',
    商机漏斗: 'Fırsat Hunisi',
    漏斗图: 'Huni Grafiği',
    销售排行: 'Satış Sıralaması',
    数据简报: 'Veri Özeti',
    环比: 'Dönemsel Değişim',
    新增客户: 'Yeni Müşteriler',
    新增商机: 'Yeni Fırsatlar',
    新增订单: 'Yeni Siparişler',
    累计回款: 'Toplam Geri Ödeme',
    累计退款: 'Toplam İade',
    前天: 'Önceki Gün',
    前周: 'Önceki Hafta',
    前月: 'Önceki Ay',
    前年: 'Önceki Yıl',
    用户趋势: 'Kullanıcı Trendleri',
    用户数量: 'Kullanıcı Sayısı',
    趋势: 'Trend',
    客户跟进: 'Müşteri Takibi',
    需跟进的客户: 'Takip Edilmesi Gereken Müşteriler',
    商机跟进: 'Fırsat Takibi',
    订单跟进: 'Sipariş Takibi',
    待办任务: 'Yapılacak İşler',
    任务名称: 'Görev Adı',
    计划完成时间: 'Tamamlanma Zamanı',
    占位符: 'Yer Tutucu',
    图形验证码: 'Grafik Doğrulama Kodu',
    账号登录: 'Hesap Girişi',
    快捷登录: 'Hızlı Giriş',
    扫码登录: 'QR Kod İle Giriş',
    '企业微信扫码登录失败，请先确认您的企业微信账号确认属于该企业':
      'QR Kod ile WeChat Girişi başarısız, lütfen WeChat hesabınızın ilgili şirkete ait olduğundan emin olun',
    验证码不能空: 'Doğrulama kodu boş olamaz',
    事项信息: 'Görev Bilgisi',
    事项标题: 'Görev Başlığı',
    事项类型: 'Görev Türü',
    所属目标: 'Hedef',
    重要程度: 'Önem Derecesi',
    事项参与人员: 'Görev Katılımcıları',
    请选择参与人员: 'Katılımcıları Seçin',
    创建者: 'Oluşturan',
    参与人员: 'Katılımcılar',
    事项: 'Görev',
    请输入事项标题: 'Görev Başlığı Girin',
    请输入重要程度: 'Önem Derecesi Girin',
    请选择紧急程度: 'Aciliyet Seviyesini Seçin',
    目标开始时间: 'Hedef Başlangıç Tarihi',
    目标结束时间: 'Hedef Bitiş Tarihi',
    目标时间: 'Hedef Zamanı',
    请输入所属目标: 'Hedefi Girin',
    请选择所属目标: 'Hedefi Seçin',
    数据已存在: 'Veri Zaten Mevcut',
    还有: 'Hala',
    '项...': ' Maddeler...',
    系统创建: 'Sistem Tarafından Oluşturuldu',
    事件已结束: 'Olay Tamamlandı',
    新建日程: 'Yeni Takvim Olayı',
    上一年: 'Geçen Yıl',
    上一月: 'Geçen Ay',
    今天: 'Bugün',
    下一月: 'Gelecek Ay',
    下一年: 'Gelecek Yıl',
    日程主题: 'Takvim Başlığı',
    请输入日程主题: 'Takvim Başlığı Girin',
    日程周期: 'Takvim Dönemi',
    日程描述: 'Takvim Açıklaması',
    请输入日程描述: 'Takvim Açıklaması Girin',
    产品英文名: 'Ürün İngilizce Adı',
    请输入产品英文名: 'Ürün İngilizce Adı Girin',
    产品主图: 'Ürün Ana Görseli',
    产品轮播图: 'Ürün Dönüş Görseli',
    请输入产品描述: 'Ürün açıklamasını girin',
    计量单位: 'Ölçü Birimi',
    请输入产品计量单位: 'Ürün ölçü birimini girin',
    产品库存: 'Ürün Stoğu',
    产品销量: 'Ürün Satışları',
    产品成本价: 'Ürün Maliyet Fiyatı',
    产品排序值: 'Ürün Sıralama Değeri',
    产品重量: 'Ürün Ağırlığı',
    采购建议: 'Satın Alma Önerisi',
    请输入采购建议: 'Satın alma önerisini girin',
    于: 'tarafından',
    创建者创建时间: 'Oluşturan Oluşturma Zamanı',
    最近操作时间: 'Son İşlem Zamanı',
    故事: 'Hikaye',
    数据周期: 'Veri Döngüsü',
    '请输入属性名：库存': 'Özellik adını girin: Stok',
    '属性名：库存': 'Özellik adı: Stok',
    请选择数据周期: 'Veri döngüsünü seçin',
    数据类型: 'Veri Türü',
    请选择数据类型: 'Veri türünü seçin',
    定时任务: 'Zamanlanmış Görev',
    请选择定时任务: 'Zamanlanmış görevi seçin',
    目标组名称: 'Hedef Grubu Adı',
    '开始时间-结束时间': 'Başlangıç Zamanı-Bitiş Zamanı',
    目标标题: 'Hedef Başlığı',
    指标标题: 'Gösterge Başlığı',
    图表类型: 'Grafik Türü',
    目标组: 'Hedef Grubu',
    目标组标题: 'Hedef Grubu Başlığı',
    请输入目标组标题: 'Hedef grup başlığını girin',
    目标组开始时间: 'Hedef grubu başlangıç zamanı',
    目标组结束时间: 'Hedef grubu bitiş zamanı',
    目标组时间: 'Hedef grubu zamanı',
    目标: 'Hedef',
    请输入目标标题: 'Hedef başlığını girin',
    所属目标组: 'Hedef grubuna ait',
    请选择所属目标组: 'Hedef grubunu seçin',
    指标: 'Gösterge',
    请输入指标标题: 'Gösterge başlığını girin',
    数据源: 'Veri Kaynağı',
    请选择数据源: 'Veri kaynağını seçin',
    选择出数据源: 'Veri kaynağını seçin',
    手动: 'Manuel',
    自动: 'Otomatik',
    指标数据: 'Gösterge Verileri',
    重要不紧急: 'Önemli Değil, Acil Değil',
    重要紧急: 'Önemli ve Acil',
    不重要不紧急: 'Önemli Değil, Acil Değil',
    不重要紧急: 'Önemli ve Acil Değil',
    所属指标: 'Göstergeye Ait',
    横坐标: 'X Ekseni',
    数值: 'Değer',
    显示近一周: 'Son Bir Hafta Göster',
    显示近一月: 'Son Bir Ay Göster',
    显示近一年: 'Son Bir Yıl Göster',
    显示全部: 'Tümünü Göster',
    个人: 'Bireysel',
    团队: 'Ekip',
    预计提成: 'Beklenen Komisyon',
    元: 'Yuan',
    '预计提成：团队比例': 'Beklenen Komisyon: Ekip Yüzdesi',
    '计提人(团队)': 'Komisyon Alan Kişi (Ekip)',
    当期金额: 'Mevcut Tutar',
    实际提成: 'Gerçek Komisyon',
    订单编号: 'Sipariş Numarası',
    团队提成: 'Ekip Komisyonu',
    服务金额: 'Hizmet Tutarı',
    合计: 'Toplam',
    条件: 'Koşul',
    符合以下条件时按本规则计提:
      'Aşağıdaki koşullar sağlandığında bu kurala göre komisyon hesapla',
    添加条件: 'Koşul Ekle',
    '元）': 'Yuan)',
    新建规则: 'Yeni Kural Oluştur',
    '规则ID、规则名称': 'Kural Kimliği, Kural Adı',
    编辑规则: 'Kuralı Düzenle',
    '负责人/提计人': 'Sorumlu Kişi / Komisyon Alan Kişi',
    产品分类下的扩展属性: 'Ürün Kategorisi Altındaki Genişletilmiş Özellikler',
    产品属性: 'Ürün Özellikleri',
    设置方式: 'Ayarları Yapın',
    销售价格: 'Satış Fiyatı',
    采购价格: 'Satın Alma Fiyatı',
    按客户设置: 'Müşteriye Göre Ayarla',
    价格为: 'Fiyatı:',
    价格币种: 'Para Birimi',
    标准单价: 'Standart Birim Fiyat',
    按客户类别设置: 'Müşteri Kategorisine Göre Ayarla',
    默认调价比例: 'Varsayılan Fiyat Ayarı Oranı',
    实际调价比例: 'Gerçek Fiyat Ayarı Oranı',
    起始年份: 'Başlangıç Yılı',
    截止年份: 'Bitiş Yılı',
    补充年份: 'Ek Yıl',
    已上传: 'Yüklendi',
    上传图片: 'Resim Yükle',
    共: 'Toplam',
    综述信息: 'Genel Bakış Bilgileri',
    跟进信息: 'Takip Bilgileri',
    详细跟进: 'Detaylı Takip',
    请填写跟进内容: 'Takip içeriğini girin',
    发布: 'Yayınla',
    下次跟进: 'Sonraki Takip',
    绩效比例: 'Performans Oranı',
    '个人绩效相对团队绩效占比，剩余部分归负责人':
      'Bireysel performans, takım performansına göre oranlanır, geriye kalan sorumluya aittir',
    最新价格: 'Son Fiyat',
    历史近期: 'Son Dönem',
    供应: 'Tedarik',
    已付金额: 'Ödenen Tutar',
    '当前订单付款总和，不扣除退款':
      'Şu anki siparişlerin toplam ödemesi, iade edilen tutarlar çıkarılmaz',
    '您确定要对当前数据生成入库单？':
      'Bu veri için giriş belgesi oluşturmak istediğinizden emin misiniz?',
    批量添加: 'Toplu Ekle',
    请输入企业名称: 'Lütfen firma adını girin',
    '您确定要对当前数据进行作废？':
      'Bu veriyi iptal etmek istediğinizden emin misiniz?',
    请选择组装拆卸产品明细: 'Montaj/Demontaj ürün detaylarını seçin',
    请选择组装拆卸产品: 'Montaj/Demontaj ürünü seçin',
    箱单详情: 'Kasa Detayları',
    '您确定要生成发货单？':
      'Teslimat belgesi oluşturmak istediğinizden emin misiniz?',
    装箱数: 'Kutu Sayısı',
    '未作废数据删除，库存将不会恢复是否删除？':
      'İptal edilmemiş veriler silinirse, stok geri yüklenmez, silmek istediğinizden emin misiniz?',
    '您确定要作废当前数据？':
      'Bu veriyi iptal etmek istediğinizden emin misiniz?',
    箱单数量: 'Kasa Sayısı',
    请输入预估所需箱单数: 'Tahmini kasa sayısını girin',
    拆分数量: 'Bölünmüş Miktar',
    装货箱编号: 'Yükleme Kutu Numarası',
    码: 'Kod',
    包装数量: 'Ambalaj Miktarı',
    包装的数量: 'Paketlenen Miktar',
    '单个重量(w/pc)': 'Tek Parça Ağırlığı (adet başına)',
    包装的重量: 'Paketlenen Ağırlık',
    '单个体积(v/pc)': 'Tek Parça Hacmi (adet başına)',
    包装的体积: 'Paketlenen Hacim',
    总重量: 'Toplam Ağırlık',
    总体积: 'Toplam Hacim',
    所属箱号: 'Ait Olduğu Kasa Numarası',
    盘点详情: 'Stok Sayım Detayları',
    系统库存: 'Sistem Stoku',
    系统统计当前仓库的数量: 'Sistem, mevcut depo stokunu hesaplar',
    盘点数量: 'Stok Sayım Miktarı',
    盘亏盘盈: 'Stok Zarar/Kazanç',
    添加后请到出入库单列表审核:
      'Ekledikten sonra giriş/çıkış belgeleri listesine gidip onaylayın',
    '剩余数量（冻结库存数量)': 'Kalan Miktar (Donmuş Stok Miktarı)',
    操作员: 'Operatör',
    出入库单详情: 'Giriş/Çıkış Belgesi Detayları',
    '您确定要对当前数据生成出入库单？':
      'Bu veri için giriş/çıkış belgesi oluşturmak istediğinizden emin misiniz?',
    出入库进度: 'Giriş/Çıkış İlerlemesi',
    备注说明: 'Açıklama Notu',
    产品调拨详情: 'Ürün Transfer Detayları',
    组合件名称: 'Birleşik Ürün Adı',
    单位成本: 'Birim Maliyet',
    组合成本: 'Birleşik Maliyet',
    操作时间: 'İşlem Zamanı',
    操作人: 'İşlem Yapan',
    业务类型: 'İş Türü',
    入库数量: 'Depo Giriş Miktarı',
    出库数量: 'Depo Çıkış Miktarı',
    结存数量: 'Kalan Miktar',
    库存低于预警库存: 'Stok Uyarı Stok Altında',
    各仓库数量: 'Tüm Depo Miktarları',
    总库存: 'Toplam Stok',
    盘点时间: 'Envanter Zamanı',
    盘点产品量: 'Envanter Ürün Sayısı',
    盘点人: 'Envanter Yapan Kişi',
    中文: 'Çince',
    父级: 'Üst Düzey',
    请选择父级: 'Üst Düzeyi Seçin',
    记录: 'Kayıt',
    租金: 'Kira',
    人流量: 'İnsan Trafiği',
    是否转让: 'Devredilir mi?',
    转让价格: 'Devir Fiyatı',
    流水: 'Hareket',
    利润: 'Kar',
    推荐星级: 'Önerilen Yıldız Sayısı',
    星: 'Yıldız',
    联系方式: 'İletişim Bilgileri',
    商家: 'Satıcı',
    是否显示: 'Görünür mü?',
    请输入店铺名称: 'Dükkan Adını Girin',
    选址类型: 'Lokasyon Türü',
    请选择选址类型: 'Lokasyon Türünü Seçin',
    请输入店铺地址: 'Dükkan Adresini Girin',
    经度: 'Boylam',
    请输入经度: 'Boylamı Girin',
    纬度: 'Enlem',
    请输入纬度: 'Enlemi Girin',
    '租金(月)': 'Kira (Aylık)',
    请输入租金: 'Kira Miktarını Girin',
    请输入人流量: 'İnsan Trafiğini Girin',
    请输入流水: 'Hareketi Girin',
    请输入利润: 'Karı Girin',
    请输入推荐星级: 'Önerilen Yıldız Sayısını Girin',
    请输入转让价格: 'Devir Fiyatını Girin',
    请输入联系方式: 'İletişim Bilgilerini Girin',
    竞品情况: 'Rakip Durumu',
    请输入竞品情况: 'Rakip Durumunu Girin',
    请输入教程名称: 'Eğitim Adını Girin',
    教程类型: 'Eğitim Türü',
    请选择教程类型: 'Eğitim Türünü Seçin',
    教程: 'Eğitim',
    教程名称: 'Eğitim Adı',
    前: 'Önce',
    小时内: 'Saat İçinde',
    分钟内: 'Dakika İçinde',
    销售趋势: 'Satış Eğilimi',
    销售数量: 'Satış Miktarı',
    客户最新报价: 'Müşteri Son Teklifi',
    头像: 'Profil Fotoğrafı',
    昵称: 'Takma Ad',
    真实姓名: 'Gerçek Adı',
    手机号码: 'Telefon Numarası',
    最后登录时间: 'Son Giriş Zamanı',
    电话号码: 'Telefon Numarası',
    请选择角色: 'Rolü Seçin',
    请选择公司: 'Şirketi Seçin',
    请选择昵称: 'Takma Adı Seçin',
    人员: 'Personel',
    公司简称: 'Şirket Kısaltması',
    请输入公司简称: 'Şirket Kısaltmasını Girin',
    统一社会信用代码: 'Kurumsal Kredi Kimlik Numarası',
    请输入统一社会信用代码: 'Kurumsal Kredi Kimlik Numarasını Girin',
    企业法人: 'Kurumsal Sorumlu',
    请输入企业法人: 'Kurumsal Sorumlusunu Girin',
    注册地址: 'Kayıt Adresi',
    请输入注册地址: 'Kayıt Adresini Girin',
    注册日期: 'Kayıt Tarihi',
    请输入注册日期: 'Kayıt Tarihini Girin',
    请选择注册日期: 'Kayıt Tarihini Seçin',
    联系电话: 'İletişim Telefonu',
    请输入联系电话: 'İletişim Telefonunu Girin',
    联系邮箱: 'İletişim E-Postası',
    请输入联系邮箱: 'İletişim E-Postasını Girin',
    站点域名: 'Site Alan Adı',
    请输入站点域名: 'Site Alan Adını Girin',
    请输入ICP: "ICP'yi Girin",
    公司代号: 'Şirket Kodu',
    请输入公司代号: 'Şirket Kodunu Girin',
    公司简介: 'Şirket Tanıtımı',
    请输入公司简介: 'Şirket Tanıtımını Girin',
    公司LOGO: 'Şirket Logosu',
    站点LOGO: 'Site Logosu',
    站点ICO: 'Site ICO',
    登录页背景图: 'Giriş Sayfası Arka Plan Resmi',
    部门名称: 'Bölüm Adı',
    手机: 'Cep Telefonu',
    请输入部门名称: 'Bölüm Adını Girin',
    部门人员: 'Bölüm Personeli',
    员工: 'Çalışan',
    请选择员工: 'Çalışanı Seçin',
    职位: 'Pozisyon',
    '您确定要对当前员工进行禁用？':
      'Şu anki çalışanı devre dışı bırakmak istediğinizden emin misiniz?',
    '您确定要对当前员工进行解除禁用？':
      'Şu anki çalışanın devre dışı bırakılmasını kaldırmak istediğinizden emin misiniz?',
    '您确定要对当前员工进行离职处理？':
      'Şu anki çalışanı işten çıkarmak istediğinizden emin misiniz?',
    员工状态: 'Çalışan Durumu',
    权限字段: 'İzin Alanı',
    编辑角色: 'Rolü Düzenle',
    添加角色: 'Rol Ekle',
    角色名称: 'Rol Adı',
    请输入角色名称: 'Rol Adını Girin',
    角色描述: 'Rol Açıklaması',
    数据权限: 'Veri İzni',
    模块权限: 'Modül İzni',
    字段权限: 'Alan İzni',
    请输入角色名: 'Rol Adını Girin',
    组织架构: 'Organizasyon Şeması',
    员工管理: 'Personel Yönetimi',
    标识: 'Kimlik',
    成员限制: 'Üye Sınırlaması',
    成员数量: 'Üye Sayısı',
    到期时间: 'Son Kullanma Tarihi',
    站点: 'Site',
    行业: 'Sektör',
    请输入标识: 'Kimlik Girin',
    管理员手机号: 'Yönetici Telefon Numarası',
    请输入管理员手机号: 'Yönetici Telefon Numarasını Girin',
    管理员姓名: 'Yönetici Adı',
    请输入管理员姓名: 'Yönetici Adını Girin',
    公司行业: 'Şirket Sektörü',
    请选择公司行业: 'Şirket Sektörünü Seçin',
    请选择到期时间: 'Son Kullanma Tarihini Seçin',
    键: 'Anahtar',
    必填: 'Zorunlu',
    默认值: 'Varsayılan Değer',
    占比: 'Oran',
    请输入正确key: 'Doğru anahtar girin',
    字段: 'Alan',
    只能是英文数字下划线的组合且以英文或者下划线开头:
      'Sadece İngilizce harf, rakam ve alt çizgi kombinasyonu, İngilizce veya alt çizgi ile başlamalıdır',
    请输入键: 'Anahtarı Girin',
    请输入默认值: 'Varsayılan Değeri Girin',
    输入提示: 'Giriş İpucu',
    请输入输入提示: 'Giriş İpucusunu Girin',
    客户类型: 'Müşteri Türü',
    请输入客户类型名: 'Müşteri Türü Adını Girin',
    请输入客户类型: 'Müşteri Türünü Girin',
    客户配置: 'Müşteri Ayarları',
    行业字段: 'Sektör Alanı',
    行业名称: 'Sektör Adı',
    行业权限: 'Sektör İzni',
    所属菜单: 'Menü Sahibi',
    字段名称: 'Alan Adı',
    字段标识: 'Alan Kimliği',
    列表宽度: 'Liste Genişliği',
    父级菜单: 'Ana Menü',
    请选择父级菜单: 'Lütfen Ana Menü Seçin',
    请输入字段名称: 'Lütfen Alan Adını Girin',
    请输入字段标识: 'Lütfen Alan Kimliğini Girin',
    请输入列表宽度: 'Lütfen Liste Genişliğini Girin',
    字段排序: 'Alan Sıralaması',
    请输入字段排序: 'Lütfen Alan Sıralamasını Girin',
    菜单名称: 'Menü Adı',
    菜单: 'Menü',
    请输入菜单名称: 'Lütfen Menü Adını Girin',
    菜单地址: 'Menü Adresi',
    请输入菜单地址: 'Lütfen Menü Adresini Girin',
    关联菜单: 'İlgili Menü',
    请选择关联菜单: 'Lütfen İlgili Menüyü Seçin',
    菜单图标: 'Menü İkonu',
    请输入菜单图标: 'Lütfen Menü İkonunu Girin',
    菜单排序: 'Menü Sıralaması',
    请输入菜单排序: 'Lütfen Menü Sıralamasını Girin',
    操作名称: 'İşlem Adı',
    操作代码: 'İşlem Kodu',
    操作地址: 'İşlem Adresi',
    表头操作: 'Tablo İşlemi',
    列表操作: 'Liste İşlemi',
    选项卡操作: 'Sekme İşlemi',
    请输入操作名称: 'Lütfen İşlem Adını Girin',
    不输入则与操作名称相同: 'İşlem Adı ile aynı ise boş bırakın',
    请输入操作代码: 'Lütfen İşlem Kodunu Girin',
    操作图标: 'İşlem İkonu',
    请输入操作图标: 'Lütfen İşlem İkonunu Girin',
    请输入操作地址: 'Lütfen İşlem Adresini Girin',
    操作排序: 'İşlem Sıralaması',
    请输入操作排序: 'Lütfen İşlem Sıralamasını Girin',
    显示在表头: 'Tabloda Göster',
    显示在列表: 'Listede Göster',
    显示在选项卡: 'Sekmelerde Göster',
    所属企业: 'Şirket Sahibi',
    企业: 'Şirket',
    选择企业: 'Şirket Seçin',
    操作管理: 'İşlem Yönetimi',
    字段管理: 'Alan Yönetimi',
    设备调试: 'Cihaz Hata Ayıklama',
    门锁状态: 'Kilit Durumu',
    物品状态: 'Nesne Durumu',
    门锁编号: 'Kilit Numarası',
    开锁: 'Aç',
    检测: 'Kontrol Et',
    通电: 'Enerji Ver',
    断电: 'Enerji Kes',
    门锁操作: 'Kilit İşlemi',
    门锁打开: 'Kapı Açık',
    门锁已开启: 'Kapı Açık',
    门锁关闭: 'Kapı Kapalı',
    门锁已关闭: 'Kapı Kapalı',
    发信昵称: 'Gönderen İsmi',
    邮箱服务商: 'E-posta Sağlayıcı',
    默认发信邮箱: 'Varsayılan Gönderen E-posta',
    请输入发信昵称: 'Lütfen Gönderen İsmini Girin',
    请选择邮箱服务商: 'Lütfen E-posta Sağlayıcısını Seçin',
    密码: 'Şifre',
    语种: 'Dil',
    请选择语种: 'Lütfen Dil Seçin',
    '内容-头部': 'Başlık İçeriği',
    '内容-尾部': 'Altbilgi İçeriği',
    用户名: 'Kullanıcı Adı',
    性别: 'Cinsiyet',
    个人简介: 'Kişisel Tanıtım',
    我的邮箱: 'E-posta Adresim',
    重置密码: 'Şifre Sıfırla',
    短信验证码: 'SMS Doğrulama Kodu',
    新密码: 'Yeni Şifre',
    供应商分类: 'Tedarikçi Kategorisi',
    车型配置: 'Araç Modeli Yapılandırma',
    部件配置: 'Parça Yapılandırma',
    行业模板: 'Endüstri Şablonu',
    '请选择行业模板(非必填)': 'Lütfen Endüstri Şablonunu Seçin (Zorunlu Değil)',
    分类图片: 'Kategori Resmi',
    英文名称: 'İngilizce İsim',
    顶级分类: 'Üst Kategori',
    请输入搜索内容: 'Lütfen Arama İçeriğini Girin',
    父级分类: 'Üst Kategori',
    请选择父级分类: 'Lütfen Üst Kategoriyi Seçin',
    '分类名称（英文）': 'Kategori Adı (İngilizce)',
    '请输入分类名称（英文）': 'Lütfen Kategori Adını Girin (İngilizce)',
    分类排序: 'Kategori Sıralaması',
    类型标题: 'Tür Başlığı',
    类型名称: 'Tür Adı',
    请输入类型名称: 'Lütfen Tür Adını Girin',
    仓库设置: 'Depo Ayarları',
    图片数量: 'Resim Sayısı',
    宽度: 'Genişlik',
    高度: 'Yükseklik',
    素材名称: 'Malzeme Adı',
    分类标题: 'Kategori Başlığı',
    事项分类: 'Olay Kategorisi',
    故事分类: 'Hikaye Kategorisi',
    汇率设置: 'Döviz Kuru Ayarları',
    人民币: 'Çin Yuanı',
    前缀: 'Ön Ek',
    请选择中间规则: 'Lütfen Orta Kuralı Seçin',
    请选择后缀规则: 'Lütfen Son Ek Kuralını Seçin',
    产品编号规则: 'Ürün Numarası Kuralı',
    '前缀如CP，类型代码需要在类型信息里面增加':
      'Ön ek olarak CP gibi, tür kodu Tür Bilgileri içinde eklenmelidir',
    空: 'Boş',
    类型id: 'Tür Kimliği',
    类型代码: 'Tür Kodu',
    自增ID: 'Otomatik Artan Kimlik',
    客户编号规则: 'Müşteri Numarası Kuralı',
    前缀如KH: 'Ön ek olarak KH gibi',
    国家ID: 'Ülke Kimliği',
    国家代码: 'Ülke Kodu',
    销售单名称规则: 'Satış Faturası Adı Kuralı',
    前缀如XSDD: 'Ön ek olarak XSDD gibi',
    客户ID: 'Müşteri Kimliği',
    年月日: 'Yıl Ay Gün',
    采购单名称规则: 'Satın Alma Siparişi Adı Kuralı',
    前缀如CGD: 'Ön ek olarak CGD gibi',
    供应商ID: 'Tedarikçi Kimliği',
    销售报价权限: 'Satış Teklifleri İzni',
    '严格模式下，报价低于产品最低售价不可提交，宽松模式下可以提交，会给出明显警告':
      'Sıkı Modda, teklif ürünün en düşük satış fiyatının altındaysa gönderilemez, Gevşek Modda gönderilebilir, ancak açık bir uyarı alacaksınız',
    宽松模式: 'Gevşek Mod',
    采购报价权限: 'Satın Alma Teklifleri İzni',
    '严格模式下，采购高于供应商报价不可提交，宽松模式下可以提交，会给出明显警告':
      'Sıkı Modda, satın alma teklifi tedarikçi teklifinden yüksekse gönderilemez, Gevşek Modda gönderilebilir, ancak açık bir uyarı alacaksınız',
    基本配置: 'Temel Ayarlar',
    '用户ID/用户名': 'Kullanıcı Kimliği/Kullanıcı Adı',
    路径: 'Yol',
    请求ID: 'İstek Kimliği',
    规则: 'Kural',
    执行类: 'Yürütme Sınıfı',
    执行方法: 'Yürütme Metodu',
    是否启用: 'Etkinleştirilsin mi',
    任务标题: 'Görev Başlığı',
    请输入任务标题: 'Lütfen Görev Başlığını Girin',
    任务规则: 'Görev Kuralı',
    请输入任务规则: 'Lütfen Görev Kuralını Girin',
    如: 'Örneğin',
    则代表每: 'şu anlama gelir: her',
    分钟执行一次: 'dakika aralıklarla çalıştır',
    请输入执行类: 'Lütfen Yürütme Sınıfını Girin',
    请输入执行方法: 'Lütfen Yürütme Metodunu Girin',
    任务类型: 'Görev Türü',
    请选择任务类型: 'Lütfen Görev Türünü Seçin',
    参数格式: 'Parametre Biçimi',
    '请输入参数格式(必须为json格式),可不填写':
      'Lütfen Parametre Biçimini Girin (Zorunlu olarak JSON biçiminde olmalıdır), boş bırakabilirsiniz',
    数据组类型: 'Veri Grubu Türü',
    请选择数据组类型: 'Lütfen Veri Grubu Türünü Seçin',
    属性: 'Özellik',
    '请输入属性key(唯一)：name':
      'Lütfen Benzersiz Özellik Anahtarını Girin: name',
    '属性key(唯一)：name': 'Ad özelliği (benzersiz): ad',
    属性类型: 'Özellik türü',
    排序值: 'Sıralama değeri',
    请填写选项配置值: 'Seçenek yapılandırma değerini doldurun',
    参数方式例如: 'Örnek parametre',
    白色: 'Beyaz',
    红色: 'Kırmızı',
    黑色: 'Siyah',
    添加属性: 'Özellik ekle',
    数据组名称: 'Veri grubu adı',
    数据组描述: 'Veri grubu açıklaması',
    请输入关键字: 'Anahtar kelime girin',
    扩展属性: 'Genişletilmiş özellikler',
    请输入数据组名称: 'Veri grubu adını girin',
    请输入数据组描述: 'Veri grubu açıklamasını girin',
    请上传: 'Yükle',
    主体名称: 'Ana başlık',
    域名: 'Alan adı',
    站点标题: 'Site başlığı',
    团队名称: 'Takım adı',
    主体: 'Sahip',
    所属: 'Sahip',
    请输入所属: 'Sahip girin',
    请输入主体名称: 'Ana başlık girin',
    请输入税号: 'Vergi numarasını girin',
    法人: 'Yasal temsilci',
    请输入法人: 'Yasal temsilci girin',
    请输入站点标题: 'Site başlığını girin',
    主体简介: 'Alan adı özeti',
    请输入主体简介: 'Alan adı özetini girin',
    主体LOGO: 'Alan adı logosu',
    站点背景: 'Site arka planı',
    数据配置: 'Veri yapılandırması',
    主体管理: 'Ana başlık yönetimi',
    账号: 'Hesap',
    请输入账号: 'Hesap girin',
    周期: 'Döngü',
    日志类型: 'Günlük türü',
    执行结果: 'Yürütme sonucu',
    登录成功: 'Giriş başarılı',
    访问时间: 'Erişim zamanı',
    登录IP: 'Giriş IP',
    下载模版: 'Şablon indir',
    枚举变量: 'Numaralandırma değişkeni',
    模版文件: 'Şablon dosyası',
    仅支持Xlsx: 'Yalnızca Xlsx desteklenir',
    若为Xls文件请先在Excel中另存为Xlsx: `Xls dosyasıysa lütfen önce Excel'de Xlsx olarak kaydedin`,
    '添加完成后，请点击字段集编辑完善模版填充配置信息':
      'Eklemeyi tamamladıktan sonra, şablon doldurma yapılandırması bilgilerini düzenlemek için alan kümesini tıklayın',
    变量: 'Değişken',
    为单一数据占位: 'Tek veri için yer tutucu oluştur',
    为列数据占位: 'Sütun verisi için yer tutucu oluştur',
    字段集: 'Alan kümesi',
    '文件名称(点击预览)': 'Dosya adı (önizlemek için tıklayın)',
    文件大小: 'Dosya boyutu',
    数据填充起始行: 'Veri doldurma başlangıç satırı',
    模板选择: 'Şablon seçimi',
    无模板导出: 'Şablon olmadan dışa aktar',
    模板导出: 'Şablon dışa aktar',
    无模板打印: 'Şablon olmadan yazdır',
    模板打印: 'Şablon yazdır',
    请选择模板: 'Bir şablon seçin',
    '正在导出中...': 'Dışa aktarılıyor...',
    '正在打印中...': 'Yazdırılıyor...',
    单元格: 'Hücre',
    多行项: 'Çoklu satır öğesi',
    是否求和: 'Toplamı hesapla',
    是否图片: 'Resim mi?',
    是否合并: 'Birleştirme mi?',
    图片宽度: 'Resim genişliği',
    图片高度: 'Resim yüksekliği',
    关联合并: 'Bağlantı birleştirme',
    请选择字段: 'Bir alan seçin',
    链接: 'Bağlantı',
    轮播图设置: 'Slayt gösterisi ayarları',
    首页分类商品设置: 'Ana sayfa kategori ürün ayarları',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页f分类商品中。':
      'Bu içerik ürün kategorisine bağlıdır: Ürünler> Ürün kategorisi, göstermek istediğiniz kategorileri işaretleyebilirsiniz, işaretledikten sonra kategoriler ana sayfa kategori ürünlerinde görüntülenecektir.',
    首页分类导航设置: 'Ana sayfa kategori gezinme ayarları',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页导航栏中。':
      'Bu içerik ürün kategorisine bağlıdır: Ürünler> Ürün kategorisi, göstermek istediğiniz kategorileri işaretleyebilirsiniz, işaretledikten sonra kategoriler ana sayfa gezinme çubuğunda görüntülenecektir.',
    导航设置: 'Gezinme ayarları',
    站点名称: 'Site adı',
    请输入站点名称: 'Site adınızı girin',
    '对SEO很重要,不要堆砌关键字':
      'SEO için önemlidir, anahtar kelimeleri yığınlamayın',
    站点描述: 'Site açıklaması',
    请输入站点描述: 'Site açıklamanızı girin',
    '站点的描述，用于展示在搜素结果':
      'Site açıklamanızı girin, arama sonuçlarında görüntülenecektir',
    站点关键词: 'Site anahtar kelimeleri',
    请输入站点关键词: 'Site anahtar kelimelerini girin',
    '搜索时会匹配对应的关键词，不要重复':
      'Arama sırasında ilgili anahtar kelimeleri eşleştirir, tekrarlamayın',
    请输入公司地址: 'Şirket adresinizi girin',
    社媒设置: 'Sosyal medya ayarları',
    联系我们: 'Bize ulaşın',
    请输入正确的网址信息: 'Lütfen doğru web sitesi bilgilerini girin',
    请输入facebook主页地址: 'Facebook ana sayfa adresinizi girin',
    请输入twitter主页地址: 'Twitter ana sayfa adresinizi girin',
    请输入youtube主页地址: 'YouTube ana sayfa adresinizi girin',
    请输入linkedin主页地址: 'LinkedIn ana sayfa adresinizi girin',
    请输入instagram主页地址: 'Instagram ana sayfa adresinizi girin',
    页尾设置: 'Altbilgi ayarları',
    '您确定要作废当前数据?':
      'Geçerli verileri iptal etmek istediğinizden emin misiniz?',
    实施明细: 'Uygulama ayrıntıları',
    任务状态: 'Görev durumu',
    参与人: 'Katılımcılar',
    未开始: 'Başlamadı',
    任务详情: 'Görev detayları',
    任务概况: 'Görev özeti',
    完成时间: 'Tamamlama zamanı',
    '您确定要作废此任务？':
      'Bu görevi iptal etmek istediğinizden emin misiniz?',
    '您确定已完成此任务？': 'Bu görevi tamamladığınızdan emin misiniz?',
    请选择团队成员: 'Bir takım üyesi seçin',
    请填写比列: 'Oranı doldurun',
    请填写分成比列: 'Paylaşım oranını doldurun',
    进度: 'İlerleme',
    分成比例不能低于: 'Bölüm oranı en az olmamalıdır',
    或高于: 'veya daha yüksek',
    钱包金额: 'Cüzdan tutarı',
    用户角色: 'Kullanıcı rolü',
    注册时间: 'Kayıt zamanı',
    用户: 'Kullanıcı',
    请输入真实姓名: 'Gerçek adınızı girin',
    用户邮箱: 'Kullanıcı e-postası',
    请输入用户邮箱: 'Kullanıcı e-postasını girin',
    请输入正确的用户邮箱地址: 'Lütfen doğru kullanıcı e-posta adresini girin',
    性别选择: 'Cinsiyet seçimi',
    所属团队: 'Ait olduğunuz takım',
    请选择团队: 'Bir takım seçin',
    所属角色: 'Ait olduğunuz rol',
    用户密码: 'Kullanıcı şifresi',
    请输入用户密码: 'Kullanıcı şifresini girin',
    用户头像: 'Kullanıcı profil resmi',
    用户昵称: 'Kullanıcı takma adı',
    回复: 'Yanıtla',
    反馈: 'Geribildirim',
    请输入回复: 'Yanıtınızı girin',
    启用状态: 'Etkinlik durumu',
    用户来源: 'Kullanıcı kaynağı',
    积分: 'Puan',
    请输入用户昵称: 'Kullanıcı takma adınızı girin',
    请选择用户角色: 'Kullanıcı rolünü seçin',
    未知功能: 'Bilinmeyen işlev',
    成员头像: 'Üye profil resmi',
    成员名称: 'Üye adı',
    成员角色: 'Üye rolü',
    管理产品: 'Ürün yönetimi',
    请输入团队名称: 'Takım adınızı girin',
    设备区域: 'Cihaz bölgesi',
    请选择设备区域: 'Cihaz bölgesini seçin',
    团队简介: 'Takım özeti',
    请输入团队简介: 'Takım özetinizi girin',
    团队头像: 'Takım profil resmi',
    HS编码: 'HS Kodu',
    // TODO: 2023-11-21
    '产品组成：产品A由B/C/D组成,组合的产品A在销售和库存环节跟其他产品一样。在箱单处理环节可以自动拆分':
      'Ürün bileşimi: Ürün A, B/C/D tarafından oluşturulur ve birleştirilen Ürün A, satış ve envanter süreçlerinde diğer ürünlerle aynı şekilde işlenir. Paketleme sürecinde otomatik olarak ayrılabilir.',
    M会自动为您过滤: 'M otomatik olarak sizin için filtreleyecektir.',
    S后刷新项目: 'S saniye sonra proje yenilenecektir.',
    客户投诉: 'Müşteri şikayeti',
    配置项: 'Yapılandırma öğesi',
    login核心接口异常: 'Giriş ana arabirim istisnası',
    '请检查返回JSON格式是否正确，是否正确返回':
      'Lütfen dönen JSON formatının doğru olup olmadığını ve doğru bir şekilde dönerse kontrol edin.',
    getUserInfo核心接口异常: 'getUserInfo ana arabirim istisnası',
    请检查返回JSON格式是否正确:
      'Lütfen dönen JSON formatının doğru olup olmadığını kontrol edin.',
    不含税: 'Vergisiz',
    产品质量: 'Ürün kalitesi',
    发货速度: 'Sevkiyat hızı',
    售后服务: 'Satış sonrası hizmet',
    客诉: 'Müşteri şikayeti',
    客诉标题: 'Müşteri şikayeti başlığı',
    请输入客诉标题: 'Lütfen müşteri şikayeti başlığını girin',
    客诉类型: 'Müşteri şikayeti türü',
    关联信息: 'İlgili bilgi',
    请选择关联信息: 'Lütfen ilişkili bilgiyi seçin',
    客诉原因: 'Müşteri şikayet nedeni',
    请输入客诉原因: 'Lütfen müşteri şikayet nedenini girin',
    valFun是一个函数: 'valFun bir işlemdir',
    产品组成: 'Ürün bileşimi',
    最近销售时间: 'Son satış zamanı',
    EXW价格: 'EXW fiyatı',
    FOB价格: 'FOB fiyatı',
    厂商税率: 'Üretici vergi oranı',
    最近采购时间: 'Son satın alma zamanı',
    采购次数: 'Satın alma sıklığı',
    产品供应商分布: 'Ürün tedarikçi dağılımı',
    OEM码: 'OEM kodu',
    附件信息: 'Ek bilgi',
    原因: 'Neden',
    URL地址: 'URL adresi',
    // TODO: 2023-11-22
    含税: 'Vergi dahil',
    请输入采购税率: 'Lütfen satın alma vergi oranını girin',
    是否含税: 'Vergili mi?',
    交货方式: 'Nakliye ücreti',
    请选择客诉类型: 'Lütfen şikayet türünü seçin',
    客诉信息: 'Şikayet bilgisi',
    请输入客户WhatsApp: 'Lütfen müşteriye WhatsApp girin',
    '仅支持Xlsx,若为Xls文件请先在Excel中另存为Xlsx':
      "Sadece Xlsx destekleniyor. Eğer Xls dosyasıysa, lütfen önce Excel'de Xlsx olarak kaydet",
    // TODO: 2023-11-24
    设为主图: 'Ana resim olarak ayarla',
    包邮: 'Ücretsiz kargo',
    不包邮: 'Kargo ücretsiz değil',
    邮费: 'Kargo ücreti',
    减少: 'Azalt',
    增加: 'Artır',
    产品图文: 'Ürün resim ve metin',
    图文列表: 'Resim ve metin listesi',
    图文生成: 'Resim ve metin oluşturma',
    金豆记录: 'Altın fasulye kaydı',
    是否包邮: 'Ücretsiz kargo olup olmadığı',
    抠图图集: 'Kesme resim koleksiyonu',
    金豆变更: 'Altın fasulye değişikliği',
    选择产品型号: 'Ürün modeli seç',
    预览图文: 'Resim ve metni önizle',
    生成PDF: 'PDF oluştur',
    '当前只可选择生成三级分类产品，若需生成完整产品图文，请先完善三级分类':
      'Şu anda sadece üçüncü seviye kategorili ürünler seçilebilir, tam ürün resim ve metni oluşturmak için önce üçüncü seviye kategoriyi tamamlayın',
    生成请求已提交: 'Oluşturma isteği gönderildi',
    可前往产品图文列表页查看进度:
      'İlerlemeyi görmek için ürün resim ve metin listesi sayfasına gidin',
    返回上页: 'Önceki sayfaya dön',
    开始生成: 'Oluşturmaya başla',
    重新生成: 'Yeniden oluştur',
    前往列表页: 'Liste sayfasına git',
    金豆剩余: 'Kalan altın fasulye',
    消费类型: 'Harcama türü',
    消费金豆: 'Altın fasulye harca',
    消费前: 'Harcamadan önce',
    消费后: 'Harcamadan sonra',
    消费时间: 'Harcama zamanı',
    请选择消费类型: 'Harcama türünü seçiniz',
    金豆使用规则: 'Golden Bean Usage Rules',
    // TODO: 2024-05-27
    长: 'Uzunluk',
    厘米: 'Santimetre',
    宽: 'Genişlik',
    不能为空: 'Boş olamaz',
    购买数量: 'Satın alma miktarı',
    '预览（可根据买家采购的不同数量设置不同价格）':
      'Önizleme (alıcıların farklı satın alma miktarlarına göre farklı fiyatlar ayarlanabilir)',
    可售数量: 'Satılabilir miktar',
    单品货号: 'Ürün kodu',
    是否上架: 'Yayında mı',
    上架店铺: 'Yayınlanacak mağaza',
    请选择店铺: 'Lütfen mağaza seçin',
    商品类目: 'Ürün kategorisi',
    上一步: 'Önceki',
    提交: 'Gönder',
    下一步: 'Sonraki',
    选择类目: 'Kategori seç',
    新增产品: 'Ürün ekle',
    修改产品: 'Ürünü düzenle',
    使用运费模版: 'Kargo şablonu kullan',
    运费指导模版: 'Kargo rehber şablonu',
    卖家承担运费: 'Kargo ücreti satıcı tarafından karşılanır',
    库存详情: 'Stok detayları',
    国内仓: 'Yurtiçi depo',
    荔枝角: 'Lai Chi Kok',
    深水埗: 'Sham Shui Po',
    '产品报价低于最低售价不可提交,请调整!':
      'Ürün teklifi en düşük satış fiyatının altında, gönderilemez; lütfen ayarlayın!',
    '产品报价低于最低售价!': 'Ürün teklifi en düşük satış fiyatının altında!',
    '产品报价高于最低采购价不可提交,请调整!':
      'Ürün teklifi en düşük satın alma fiyatından yüksek, gönderilemez; lütfen ayarlayın!',
    '产品报价高于最低采购价!':
      'Ürün teklifi en düşük satın alma fiyatından yüksek!',
    工单: 'İş emri',
    工序名称: 'Proses adı',
    加工时长: 'İşleme süresi',
    默认仓库: 'Varsayılan depo',
    '尺寸/规格': 'Boyut/Spesifikasyon',
    所述仓库: 'Belirtilen depo',
    绑定: 'Bağla',
    选择: 'Seç',
    运费: 'Kargo ücreti',
    '已更换产品，需重新打印标签贴标':
      'Ürün değiştirildi, etiketi yeniden yazdırıp etiketleyin',
    规格材质: 'Malzeme spesifikasyonu',
    '蓝色字体表示建议售价，绿色字体表示历史成交报价':
      'Mavi yazı önerilen satış fiyatını, yeşil yazı geçmiş işlem teklifini gösterir',
    建议采购价: 'Önerilen satın alma fiyatı',
    智能选择供应商: 'Akıllı tedarikçi seçimi',
    品规: 'Spesifikasyon',
    '体积/净重/长-宽-高': 'Hacim/Net ağırlık/Uzunluk-Genişlik-Yükseklik',
    盒规: 'Kutu spesifikasyonu',
    '您确定要对当前数据进行一键采购？':
      'Mevcut veriler için tek tıkla satın alma yapmak istediğinize emin misiniz?',
    '您确定要对当前数据进行一键备货？':
      'Mevcut veriler için tek tıkla stok hazırlamak istediğinize emin misiniz?',
    '当前产品明细数据有未关联的产品请关联产品?':
      'Mevcut ürün detaylarında ilişkilendirilmemiş ürünler var, lütfen ilişkilendirin?',
    '您当前报价低于最低售价的价格，请修改！':
      'Mevcut teklifiniz en düşük satış fiyatının altında, lütfen düzeltin!',
    箱单信息: 'Koli bilgileri',
    混装: 'Karışık paketleme',
    添加箱子: 'Kutu ekle',
    请选择箱规: 'Lütfen kutu spesifikasyonu seçin',
    请选择箱号: 'Lütfen kutu numarası seçin',
    '支持产品名称/OEM码/编码搜索': 'Ürün adı/OEM kodu/kod aramayı destekler',
    降序: 'Azalan',
    升序: 'Artan',
    月结: 'Aylık faturalama',
    寄付: 'Gönderici öder',
    到付: 'Alıcı öder',
    明天: 'Yarın',
    后天: 'Öbür gün',
    深水涉: 'Shenshuishe',
    待入库: 'Depoya girmeyi bekliyor',
    在仓: 'Depoda',
    上车: 'Araca yüklendi',
    取消派件: 'Teslimatı iptal et',
    发往客户: 'Müşteriye gönder',
    已送达: 'Teslim edildi',
    元天屯: 'Yuantiantun',
    九龍: 'Kowloon',
    新界: 'Yeni Bölgeler',
    港島: 'Hong Kong Adası',
    '離島/偏遠': 'Ada/uzak bölge',
    九東: 'Kowloon Doğu',
    港東: 'Hong Kong Adası Doğu',
    客户账单: 'Müşteri faturası',
    供应商账单: 'Tedarikçi faturası',
    运营报表: 'Operasyon raporları',
    产品面板: 'Ürün paneli',
    电商产品: 'E-ticaret ürünleri',
    报价单表: 'Teklif formu',
    产品图册: 'Ürün albümü',
    产品箱规: 'Ürün kutu spesifikasyonları',
    私有线索: 'Özel lead',
    公海线索: 'Genel lead havuzu',
    销售面板: 'Satış paneli',
    抖音订单: 'Douyin siparişleri',
    营销: 'Pazarlama',
    我方渠道: 'Kendi kanallarımız',
    竞对渠道: 'Rakip kanallar',
    我方店铺: 'Kendi mağazalarımız',
    竞对店铺: 'Rakip mağazalar',
    渠道类型: 'Kanal türü',
    对账列表: 'Mutabakat listesi',
    账单明细: 'Fatura detayları',
    '发货单(家具)': 'Sevkiyat belgesi (Mobilya)',
    '派货行程(家具)': 'Dağıtım rotası (Mobilya)',
    今日计划: 'Bugünün planı',
    收货单: 'Teslim alma fişi',
    商品代发: 'Ürün dropshipping',
    商品退货: 'Ürün iadesi',
    商品索赔: 'Ürün tazminatı',
    '库存余额(家具)': 'Stok bakiyesi (Mobilya)',
    快递寄件: 'Kargo gönderimi',
    收费标准: 'Ücretlendirme standardı',
    工厂: 'Fabrika',
    生产计划: 'Üretim planı',
    生产工单: 'Üretim iş emri',
    委外管理: 'Dış kaynak yönetimi',
    委外订单: 'Dış kaynak siparişi',
    整单委外: 'Tüm siparişi dış kaynak',
    工序委外: 'Proses dış kaynak',
    生产执行: 'Üretim yürütme',
    生产工序: 'Üretim süreçleri',
    报工单: 'Üretim raporu',
    物料管理: 'Malzeme yönetimi',
    领料单: 'Malzeme çıkış fişi',
    退料单: 'Malzeme iade fişi',
    质量管理: 'Kalite yönetimi',
    工序质检: 'Proses kalite kontrol',
    委外质检: 'Dış kaynak kalite kontrol',
    BOM管理: 'BOM yönetimi',
    产品BOM: 'Ürün BOM',
    BOM清单: 'BOM listesi',
    工序工艺: 'Proses teknolojisi',
    工艺: 'İşlem',
    工序: 'Proses',
    设备列表: 'Ekipman listesi',
    设备类型: 'Ekipman türü',
    三方应用: 'Üçüncü taraf uygulamalar',
    硬件配置: 'Donanım yapılandırması',
    费用记录: 'Masraf kayıtları',
    仓储体积: 'Depolama hacmi',
    导出记录: 'Dışa aktarma kayıtları',
    是否KP: 'KP mi',
    起订量: 'Asgari sipariş miktarı',
    部件备注: 'Parça notu',
    原产地: 'Menşe ülke',
    产品评分: 'Ürün puanı',
    供应链评分: 'Tedarik zinciri puanı',
    账期客户: 'Vadeli müşteri',
    感兴趣产品: 'İlgilenilen ürünler',
    客户折扣: 'Müşteri indirimi',
    采购类型: 'Satın alma türü',
    线索名称: 'Lead adı',
    线索来源: 'Lead kaynağı',
    线索阶段: 'Lead aşaması',
    线索编码: 'Lead kodu',
    客户地址: 'Müşteri adresi',
    客户区域: 'Müşteri bölgesi',
    产品类别: 'Ürün kategorisi',
    订单备注: 'Sipariş notu',
    后台备注: 'Yönetici notu',
    送货日期: 'Teslimat tarihi',
    选择日期: 'Tarih seç',
    是否账期: 'Vadeli mi',
    关联订单号: 'Bağlı sipariş no',
    订单支付状态: 'Sipariş ödeme durumu',
    配送方式: 'Teslimat yöntemi',
    收件电话: 'Alıcının telefonu',
    收件地址: 'Alıcının adresi',
    快递单号: 'Kargo takip numarası',
    收货人信息: 'Alıcı bilgileri',
    所在州: 'Eyalet',
    运输保险: 'Taşıma sigortası',
    货品价值: 'Mal bedeli',
    签收选项: 'Teslim alma seçenekleri',
    寄件人信息: 'Gönderen bilgileri',
    商品体积: 'Ürün hacmi',
    商品重量: 'Ürün ağırlığı',
    商品货值: 'Ürün değeri',
    快递费用: 'Kargo ücreti',
    包裹信息: 'Paket bilgileri',
    '长(in)': 'Uzunluk (in)',
    '宽(in)': 'Genişlik (in)',
    '高(in)': 'Yükseklik (in)',
    '重量(lb)': 'Ağırlık (lb)',
    计算费用: 'Ücreti hesapla',
    快递公司: 'Kargo şirketi',
    快递面签: 'Yüz yüze onay',
    预约日期: 'Randevu tarihi',
    预约时间: 'Randevu saati',
    退货照片: 'İade fotoğrafları',
    外观照片: 'Dış görünüş fotoğrafı',
    拆开照片: 'Açılmış fotoğrafı',
    处理方式: 'İşleme yöntemi',
    退货进度: 'İade ilerlemesi',
    索赔结果: 'Tazminat sonucu',
    订单截图: 'Sipariş ekran görüntüsü',
    证明图片: 'Kanıt resmi',
    适用产品: 'Uygulanabilir ürünler',
    版本号: 'Sürüm numarası',
    计划单号: 'Plan numarası',
    生产类型: 'Üretim türü',
    计划生产数量: 'Planlanan üretim miktarı',
    计划开工日期: 'Planlanan başlangıç tarihi',
    计划完工日期: 'Planlanan bitiş tarihi',
    生产产品: 'Üretim ürünü',
    生产批次号: 'Üretim parti numarası',
    生产单号: 'Üretim sipariş numarası',
    生产状态: 'Üretim durumu',
    延期情况: 'Gecikme durumu',
    委外状态: 'Dış kaynak durumu',
    入库日期: 'Depoya giriş tarihi',
    排产人: 'Planlayıcı',
    生产完成率: 'Üretim tamamlama oranı',
    已完工数量: 'Tamamlanan miktar',
    待入库数量: 'Depoya girmeyi bekleyen miktar',
    已入库数量: 'Depoya giren miktar',
    工序计划数量: 'Proses plan miktarı',
    工序完工数量: 'Proses tamamlanan miktar',
    报废数: 'Hurda sayısı',
    返工数: 'Yeniden işleme sayısı',
    总生产成本: 'Toplam üretim maliyeti',
    加工成本: 'İşleme maliyeti',
    物料成本: 'Malzeme maliyeti',
    委外编号: 'Dış kaynak numarası',
    委外供应商: 'Dış kaynak tedarikçisi',
    委外类型: 'Dış kaynak türü',
    委外产品: 'Dış kaynak ürünü',
    委外数量: 'Dış kaynak miktarı',
    委外单价: 'Dış kaynak birim fiyatı',
    委外日期: 'Dış kaynak tarihi',
    委外总额: 'Dış kaynak toplamı',
    委外应付总额: 'Dış kaynağa ödenecek toplam',
    委外已付总额: 'Dış kaynağa ödenen toplam',
    已退货数量: 'İade edilen miktar',
    质检不合格数量: 'Kalite kontrol uygunsuz miktar',
    质检合格率: 'Kalite uygunluk oranı',
    工序编号: 'Proses numarası',
    工序状态: 'Proses durumu',
    执行工序: 'Uygulanan proses',
    工艺路线: 'İş akışı',
    工序执行人: 'Proses uygulayıcısı',
    工序计划生产数: 'Proses plan üretim miktarı',
    实际完工日期: 'Gerçek tamamlanma tarihi',
    待完工数量: 'Tamamlanmayı bekleyen miktar',
    完工良品数: 'Tamamlanan iyi ürün sayısı',
    完工良品率: 'Tamamlanan iyi ürün oranı',
    工序完成率: 'İşlem tamamlanma oranı',
    返工数量: 'Yeniden işleme miktarı',
    返工率: 'Yeniden işleme oranı',
    报废数量: 'Hurda miktarı',
    报废率: 'Hurda oranı',
    报工单编号: 'İş bildirimi numarası',
    生产数量: 'Üretim miktarı',
    生产人员: 'Üretim personeli',
    报工日期: 'İş bildirimi tarihi',
    质检状态: 'Kalite kontrol durumu',
    良品数量: 'İyi ürün sayısı',
    生产工资: 'Üretim ücreti',
    工序单价: 'İşlem birim fiyatı',
    问题描述: 'Sorun açıklaması',
    问题图片: 'Sorun resmi',
    物料申请单号: 'Malzeme talep formu numarası',
    审批状态: 'Onay durumu',
    申请人: 'Başvuru sahibi',
    申请时间: 'Başvuru zamanı',
    委外工单: 'Dış kaynak iş emri',
    设备名称: 'Ekipman adı',
    设备编码: 'Ekipman kodu',
    设备型号: 'Ekipman modeli',
    外观尺寸: 'Görünüm boyutları',
    设备用途: 'Ekipman kullanımı',
    管理负责人: 'Yönetim sorumlusu',
    投产日期: 'Üretime başlama tarihi',
    采购日期: 'Satın alma tarihi',
    生产日期: 'Üretim tarihi',
    生产厂家: 'Üretici firma',
    用途: 'Kullanım amacı',
    设备图集: 'Ekipman resim koleksiyonu',
    请输入OEM码多个: 'Lütfen birden fazla OEM kodu girin',
    分割: 'Bölme',
    请选择产品类别: 'Lütfen ürün kategorisini seçin',
    是否关键产品: 'Kritik ürün mü',
    请选择原产地: 'Lütfen menşei seçin',
    请输入部件备注: 'Lütfen parça notunu girin',
    箱规信息已移至详情页面添加编辑:
      'Kutu spesifikasyon bilgisi detay sayfasına taşındı, ekleme ve düzenleme orada yapılabilir',
    产品规格: 'Ürün spesifikasyonları',
    复制产品: 'Ürünü kopyala',
    图片设计: 'Resim tasarımı',
    箱规类型: 'Kutu spesifikasyon türü',
    请选择箱规类型: 'Lütfen kutu spesifikasyon türünü seçin',
    请输入产品数量: 'Lütfen ürün miktarını girin',
    可以容纳的产品个数: 'Barındırılabilecek ürün sayısı',
    默认箱规: 'Varsayılan kutu spesifikasyonu',
    费用箱规: 'Ücret kutu spesifikasyonu',
    计算货品体积费用时的箱规:
      'Ürün hacim ücreti hesaplanırken kullanılan kutu spesifikasyonu',
    '长(cm)': 'Uzunluk (cm)',
    请输入箱规长: 'Lütfen kutu spesifikasyon uzunluğunu girin',
    '宽(cm)': 'Genişlik (cm)',
    请输入箱规宽: 'Lütfen kutu spesifikasyon genişliğini girin',
    '高(cm)': 'Yükseklik (cm)',
    请输入箱规高: 'Lütfen kutu spesifikasyon yüksekliğini girin',
    请输入箱规重量: 'Lütfen kutu spesifikasyon ağırlığını girin',
    请输入箱规体积: 'Lütfen kutu spesifikasyon hacmini girin',
    所属分类: 'Ait olduğu kategori',
    请选择所属分类: 'Lütfen ait olduğu kategoriyi seçin',
    '用于生成电商网站的链接,可不填写':
      'E-ticaret sitesi bağlantıları oluşturmak için kullanılır, doldurulması isteğe bağlıdır',
    图册: 'Fotoğraf albümü',
    文件请到附件中上传: 'Dosyaları lütfen eklerde yükleyin',
    产品id: 'Ürün ID',
    渠道名称: 'Kanal adı',
    请选择渠道名称: 'Lütfen kanal adını seçin',
    请输入链接地址: 'Lütfen bağlantı adresini girin',
    请输入销售价格: 'Lütfen satış fiyatını girin',
    售出产品数: 'Satılan ürün sayısı',
    请输入售出产品数量: 'Lütfen satılan ürün miktarını girin',
    拉取三方店铺商品: 'Üçüncü taraf mağaza ürünlerini çek',
    拉取三方店铺订单: 'Üçüncü taraf mağaza siparişlerini çek',
    三方店铺: 'Üçüncü taraf mağaza',
    请选择三方店铺: 'Lütfen üçüncü taraf mağazayı seçin',
    拉取: 'Çek',
    当前快递单号为: 'Mevcut kargo takip numarası',
    下单成功: 'Sipariş başarıyla verildi',
    保存并打印: 'Kaydet ve yazdır',
    请输入订单号: 'Lütfen sipariş numarasını girin',
    客户信息: 'Müşteri bilgileri',
    智能填写: 'Akıllı doldurma',
    '粘贴收货信息到此处，将自动识别姓名/电话/地址':
      'Teslimat bilgilerini buraya yapıştırın, ad/telefon/adres otomatik olarak tanınacaktır',
    客户电话: 'Müşteri telefonu',
    请输入客户电话: 'Lütfen müşteri telefonunu girin',
    已存在客户: 'Mevcut müşteri',
    '是否使用当前客户信息？': 'Mevcut müşteri bilgileri kullanılsın mı?',
    客户姓名: 'Müşteri adı',
    请输入客户姓名: 'Lütfen müşteri adını girin',
    收货地址: 'Teslimat adresi',
    请输入收货地址: 'Lütfen teslimat adresini girin',
    销售点: 'Satış noktası',
    请选择销售点: 'Lütfen satış noktasını seçin',
    付款信息: 'Ödeme bilgileri',
    是否已付款: 'Ödeme yapıldı mı',
    '您的报价产品中有低于最低售价的价格，请检查！':
      'Teklif ettiğiniz ürünlerde minimum satış fiyatının altında fiyatlar var, lütfen kontrol edin!',
    线索: 'Fırsat',
    国家地区: 'Ülke bölge',
    请输入客户感兴趣产品: 'Lütfen müşterinin ilgilendiği ürünleri girin',
    是否KA: 'KA mı',
    请输入客户网址: 'Lütfen müşteri web sitesini girin',
    请输入客户地区: 'Lütfen müşteri bölgesini girin',
    请输入客户折扣百分比: 'Lütfen müşteri indirim yüzdesini girin',
    请输入比分比: 'Lütfen oranları girin',
    请选择线索阶段: 'Lütfen fırsat aşamasını seçin',
    请输入收件人: 'Lütfen alıcıyı girin',
    请输入收件电话: 'Lütfen alıcı telefonunu girin',
    请输入收件地址: 'Lütfen alıcı adresini girin',
    请选择渠道类型: 'Lütfen kanal türünü seçin',
    渠道分类: 'Kanal sınıflandırması',
    请选择渠道分类: 'Lütfen kanal kategorisini seçin',
    快递账号: 'Kargo hesabı',
    请选择快递账号: 'Lütfen kargo hesabını seçin',
    系统配置: 'Sistem yapılandırması',
    快递账号配置: 'Kargo hesabı yapılandırması',
    中添加: 'ekle',
    请输入采购单单号: 'Lütfen satın alma siparişi numarasını girin',
    账期: 'Vade',
    添加付款明细: 'Ödeme detayı ekle',
    请输入昵称: 'Lütfen takma adı girin',
    密码为手机号后六位: 'Şifre telefon numarasının son 6 hanesidir',
    请选择部门: 'Lütfen departmanı seçin',
    供应商账号: 'Tedarikçi hesabı',
    关联供应商: 'İlişkili tedarikçi',
    入库预报: 'Depoya giriş tahmini',
    请选择配送方式: 'Lütfen teslimat yöntemini seçin',
    交货时间: 'Teslimat zamanı',
    收货人姓名: 'Alıcı adı',
    请输入收货人姓名: 'Lütfen alıcı adını girin',
    收货人电话: 'Alıcı telefonu',
    请输入收货人电话: 'Lütfen alıcı telefonunu girin',
    收货人邮箱: 'Alıcı e-posta',
    请输入收货人邮箱: 'Lütfen alıcı e-postasını girin',
    收货人地址: 'Alıcı adresi',
    请输入收货人地址: 'Lütfen alıcı adresini girin',
    请输入城市: 'Lütfen şehri girin',
    州: 'Eyalet',
    请输入州: 'Lütfen eyaleti girin',
    请选择国家: 'Lütfen ülkeyi seçin',
    请输入邮编: 'Lütfen posta kodunu girin',
    请输入包装要求: 'Lütfen ambalaj talebini girin',
    寄件人: 'Gönderen',
    请选择寄件人信息: 'Lütfen gönderen bilgilerini seçin',
    请选择签收选项: 'Lütfen teslim alma seçeneğini seçin',
    请选择运输保险: 'Lütfen nakliye sigortasını seçin',
    商品代发单: 'Ürün gönderim formu',
    快递索赔单: 'Kargo talep formu',
    商品退货单: 'Ürün iade formu',
    请输入快递单号: 'Lütfen kargo takip numarasını girin',
    请选择处理方式: 'Lütfen işlem yöntemini seçin',
    将收取一定的费用: 'Belirli bir ücret alınacaktır',
    请输入备注信息: 'Lütfen not bilgisini girin',
    '退货拍照(拆开)': 'İade fotoğrafı (açılmış)',
    '退货拍照(外观)': 'İade fotoğrafı (dış görünüm)',
    提交后将会通知供货商: 'Gönderimden sonra tedarikçi bilgilendirilecektir',
    选择处理方式: 'İşlem yöntemi seç',
    处理费用: 'İşlem ücreti',
    请输入处理费用: 'Lütfen işlem ücretini girin',
    商品快递索赔: 'Ürün kargo talebi',
    请输入货品价值: 'Lütfen ürün değerini girin',
    请输入索赔原因: 'Lütfen talep nedenini girin',
    结果: 'Sonuç',
    请选择结果: 'Lütfen sonucu seçin',
    请输入费用: 'Lütfen ücreti girin',
    三方发货: 'Üçüncü taraf gönderim',
    多个用英文逗号隔开: 'Birden fazla ise İngilizce virgülle ayırın',
    等: 'vb.',
    件产品: 'ürün',
    请选择发货计划: 'Lütfen gönderim planını seçin',
    收件人信息: 'Alıcı bilgileri',
    收件人姓名: 'Alıcı adı',
    请输入收件人姓名: 'Lütfen alıcı adını girin',
    收件人手机号: 'Alıcı telefon numarası',
    请输入收件人手机号: 'Lütfen alıcı telefon numarasını girin',
    收件人地址: 'Alıcı adresi',
    请输入收件人地址: 'Lütfen alıcı adresini girin',
    省市区县街道: 'İl/ilçe/semt mahalle',
    快捷选择寄件人信息: 'Hızlı gönderen bilgisi seçimi',
    更多快捷寄件人信息请到: 'Daha fazla hızlı gönderen bilgisi için',
    发货地址: 'Gönderim adresi',
    寄件人姓名: 'Gönderen adı',
    请输入寄件人姓名: 'Lütfen gönderen adını girin',
    寄件人手机号: 'Gönderen telefon numarası',
    请输入寄件人手机号: 'Lütfen gönderen telefon numarasını girin',
    寄件人地址: 'Gönderen adresi',
    请输入寄件人地址: 'Lütfen gönderen adresini girin',
    快递信息: 'Kargo bilgileri',
    请选择快递公司: 'Lütfen kargo firmasını seçin',
    物品名称: 'Ürün adı',
    请输入物品名称: 'Lütfen ürün adını girin',
    支付方式: 'Ödeme yöntemi',
    请选择支付方式: 'Lütfen ödeme yöntemini seçin',
    '物品总重量(Kg)': 'Ürün toplam ağırlığı (Kg)',
    请输入物品总重量: 'Lütfen ürün toplam ağırlığını girin',
    无需单位: 'Birim gerekmez',
    寄件: 'Gönder',
    '下单中...': 'Sipariş veriliyor...',
    立即打印面单: 'Hemen etiketi yazdır',
    打印机: 'Yazıcı',
    请选择打印机: 'Lütfen yazıcıyı seçin',
    快递配置: 'Kargo yapılandırması',
    请选择快递配置: 'Lütfen kargo yapılandırmasını seçin',
    请选择委外订单: 'Lütfen dış kaynak siparişini seçin',
    请输入产品名: 'Lütfen ürün adını girin',
    名片: 'Kartvizit',
    是否固定: 'Sabit mi',
    默认排序: 'Varsayılan sıralama',
    排序方式: 'Sıralama yöntemi',
    设置默认排序字段: 'Varsayılan sıralama alanını ayarla',
    请输入HSCODE: 'Lütfen HSCODE girin',
    别名: 'Takma ad',
    '请输入别名,多个用英文逗号隔开':
      'Lütfen takma ad girin, birden fazla ise İngilizce virgülle ayırın',
    销售渠道: 'Satış kanalları',
    推广渠道: 'Tanıtım kanalları',
    关联店铺: 'İlişkili mağaza',
    请选择关联店铺: 'Lütfen ilişkili mağazayı seçin',
    请输入渠道名称: 'Lütfen kanal adını girin',
    快速调价: 'Hızlı fiyat ayarlama',
    当前修改影响: 'Mevcut değişiklik etkisi',
    '条数据,总价': 'veri satırı, toplam fiyat',
    '是否继续修改?': 'Değişikliğe devam edilsin mi?',
    新购产品按建议价格: 'Yeni satın alınan ürünler önerilen fiyata göre',
    请输入倍率: 'Lütfen kat sayısını girin',
    倍调价: 'Kat fiyat ayarlama',
    复购产品按历史底价:
      'Tekrar satın alınan ürünler geçmiş en düşük fiyata göre',
    所有产品按当前价格: 'Tüm ürünler mevcut fiyata göre',
    打印模版: 'Yazdırma şablonu',
    硬件设备: 'Donanım ekipmanları',
    购买打印机: 'Yazıcı satın al',
    飞鹅云标签打印机: 'Fei E Cloud etiket yazıcısı',
    佳博云标签打印机: 'Gabo Cloud etiket yazıcısı',
    SN编码: 'SN kodu',
    请输入SN编码: 'Lütfen SN kodunu girin',
    是否默认: 'Varsayılan mı',
    '标签纸长(mm)': 'Etiket kağıdı uzunluğu (mm)',
    请输入标签纸长度: 'Lütfen etiket kağıdı uzunluğunu girin',
    '标签纸宽(mm)': 'Etiket kağıdı genişliği (mm)',
    请输入标签纸宽度: 'Lütfen etiket kağıdı genişliğini girin',
    模本内容: 'Şablon içeriği',
    请输入模本内容: 'Lütfen şablon içeriğini girin',
    缩略图: 'Küçük resim',
    最大打印宽度: 'Maksimum yazdırma genişliği',
    购买: 'Satın al',
    打印标签: 'Etiket yazdır',
    请选择设备: 'Lütfen ekipmanı seçin',
    请选择打印模版: 'Lütfen yazdırma şablonunu seçin',
    请输入打印数量: 'Lütfen yazdırma miktarını girin',
    请输入寄件人: 'Lütfen göndereni girin',
    寄件人电话: 'Gönderen telefonu',
    请输入寄件人电话: 'Lütfen gönderen telefonunu girin',
    寄件人邮箱: 'Gönderen e-posta',
    请输入寄件人邮箱: 'Lütfen gönderen e-postasını girin',
    寄件地址: 'Gönderim adresi',
    请输入寄件地址: 'Lütfen gönderim adresini girin',
    默认地址: 'Varsayılan adres',
    费用变更: 'Ücret değişikliği',
    费用方式: 'Ücret yöntemi',
    费用类型: 'Ücret türü',
    请选择费用类型: 'Lütfen ücret türünü seçin',
    请输入金额: 'Lütfen tutarı girin',
    请输入文件名称: 'Lütfen dosya adını girin',
    来源链接: 'Kaynak bağlantı',
    请输入网页来源链接: 'Lütfen web sayfası kaynak bağlantısını girin',
    更换产品: 'Ürün değiştir',
    更换的产品: 'Değiştirilen ürünler',
    名称备注: 'Ad notu',
    请输入菜单名称备注: 'Lütfen menü adı notunu girin',
    是否显示PC: "PC'de göster",
    是否显示移动端: 'Mobilde göster',
    请输入token: 'Lütfen token girin',
    征收比例: 'Tahsilat oranı',
    快递费用征收比例: 'Kargo ücreti tahsilat oranı',
    请输入比例: 'Lütfen oranı girin',
    请选择版本号: 'Lütfen sürüm numarasını seçin',
    用量: 'Kullanım miktarı',
    请输入用量: 'Lütfen kullanım miktarını girin',
    损耗率: 'Fire oranı',
    请输入损耗率: 'Lütfen fire oranını girin',
    物料BOM: 'Malzeme BOM',
    请选择物料BOM: "Lütfen malzeme BOM'unu seçin",
    请输入单位: 'Lütfen birimi girin',
    请输入单价: 'Lütfen birim fiyatı girin',
    时长: 'Süre',
    请输入加工时长: 'Lütfen işleme süresini girin',
    是否质检: 'Kalite kontrol yapılacak mı',
    请输入工序描述: 'Lütfen işlem açıklamasını girin',
    请选择生产类型: 'Lütfen üretim türünü seçin',
    请选择订单: 'Lütfen siparişi seçin',
    请选择产品BOM: "Lütfen ürün BOM'unu seçin",
    请选择生产优先级: 'Lütfen üretim önceliğini seçin',
    请输入交货日期: 'Lütfen teslimat tarihini girin',
    请输入计划开工日期: 'Lütfen planlanan başlangıç tarihini girin',
    请输入计划完工日期: 'Lütfen planlanan bitiş tarihini girin',
    请输入生产批次号: 'Lütfen üretim partisi numarasını girin',
    委外工序: 'Dış kaynak işlemi',
    请选择生产状态: 'Lütfen üretim durumunu seçin',
    请选择生产计划: 'Lütfen üretim planını seçin',
    生产订单: 'Üretim siparişi',
    请选择生产订单: 'Lütfen üretim siparişini seçin',
    请选择执行工序: 'Lütfen yürütülecek işlemi seçin',
    请选择委外工序: 'Lütfen dış kaynak işlemini seçin',
    生产需求: 'Üretim talebi',
    请选择生产需求: 'Lütfen üretim talebini seçin',
    请选择产品工艺: 'Lütfen ürün prosesini seçin',
    请输入委外数量: 'Lütfen dış kaynak miktarını girin',
    请输入计划生产数量: 'Lütfen planlanan üretim miktarını girin',
    请输入委外单价: 'Lütfen dış kaynak birim fiyatını girin',
    请选择计划开工日期: 'Lütfen planlanan başlangıç tarihini seçin',
    请选择委外日期: 'Lütfen dış kaynak tarihini seçin',
    请选择计划完工日期: 'Lütfen planlanan bitiş tarihini seçin',
    '请搜索/选择负责人': 'Lütfen sorumlu ara/seç',
    请选择生产工单: 'Lütfen üretim iş emrini seçin',
    产品工艺: 'Ürün prosesi',
    请选择工序执行人: 'Lütfen işlem uygulayıcısını seçin',
    '请搜索/选择工序执行人': 'Lütfen işlem uygulayıcısını ara/seç',
    请输入生产数量: 'Lütfen üretim miktarını girin',
    请选择生产人员: 'Lütfen üretim personelini seçin',
    '请搜索/选择生产人员': 'Lütfen üretim personelini ara/seç',
    请选择报工日期: 'Lütfen iş bildirimi tarihini seçin',
    质检数量: 'Kalite kontrol miktarı',
    请输入质检数量: 'Lütfen kalite kontrol miktarını girin',
    请输入入库数量: 'Lütfen depoya giriş miktarını girin',
    质检: 'Kalite kontrol',
    请输入报废数量: 'Lütfen hurda miktarını girin',
    请输入返工数量: 'Lütfen yeniden işleme miktarını girin',
    请输入良品数量: 'Lütfen iyi ürün miktarını girin',
    请输入问题描述: 'Lütfen sorun açıklamasını girin',
    类别: 'Kategori',
    请选择申请人: 'Lütfen başvuranı seçin',
    请选择关联领料单: 'Lütfen ilişkili malzeme çekme formunu seçin',
    服务商: 'Servis sağlayıcı',
    请选择快递服务商: 'Lütfen kargo servis sağlayıcısını seçin',
    月结号: 'Aylık hesap numarası',
    请输入月结号: 'Lütfen aylık hesap numarasını girin',
    添加快递信息: 'Kargo bilgisi ekle',
    选择香港仓库: 'Hong Kong deposunu seç',
    选择仓库: 'Depo seç',
    选择发货时间及司机: 'Gönderim zamanı ve sürücü seç',
    司机: 'Sürücü',
    请选择司机: 'Lütfen sürücüyü seçin',
    '请搜索/选择司机': 'Lütfen sürücüyü ara/seç',
    请选择发货日期: 'Lütfen gönderim tarihini seçin',
    上门时间: 'Ziyaret zamanı',
    截止时间: 'Bitiş zamanı',
    更改区域: 'Bölge değiştir',
    区域: 'Bölge',
    请选择区域: 'Lütfen bölgeyi seçin',
    shopify店铺: 'Shopify mağazası',
    店铺名: 'Mağaza adı',
    请输入shopify店铺名: 'Lütfen Shopify mağaza adını girin',
    请输入店铺名: 'Lütfen mağaza adını girin',
    请输入access: 'Lütfen access girin',
    请输入app: 'Lütfen app girin',
    对账明细: 'Hesap özeti detayları',
    请输入日期: 'Lütfen tarihi girin',
    生产设备: 'Üretim ekipmanları',
    请输入设备名称: 'Lütfen ekipman adını girin',
    请选择设备类型: 'Lütfen ekipman türünü seçin',
    请输入设备编码SN: "Lütfen ekipman kodu SN'sini girin",
    请输入设备型号: 'Lütfen ekipman modelini girin',
    请输入长度: 'Lütfen uzunluğu girin',
    请输入宽度: 'Lütfen genişliği girin',
    请输入高度: 'Lütfen yüksekliği girin',
    请选择采购日期: 'Lütfen satın alma tarihini seçin',
    请选择投产日期: 'Lütfen üretime başlama tarihini seçin',
    请输入采购价格: 'Lütfen satın alma fiyatını girin',
    采购币种: 'Satın alma para birimi',
    请输入生产厂家: 'Lütfen üretici firmayı girin',
    请选择生产日期: 'Lütfen üretim tarihini seçin',
    请输入用途: 'Lütfen kullanımı girin',
    发货: 'Gönderim',
    同步发货状态: 'Gönderim durumunu senkronize et',
    行: 'Satır',
    请输入行: 'Lütfen satırı girin',
    请输入子仓库行数: 'Lütfen alt depo satır sayısını girin',
    列: 'Sütun',
    请输入列: 'Lütfen sütunu girin',
    请输入子仓库列数: 'Lütfen alt depo sütun sayısını girin',
    子仓库数量不能超过: 'Alt depo sayısı şu kadarı geçemez',
    个: 'adet',
    新增仓库: 'Yeni depo ekle',
    '请搜索/选择产品': 'Lütfen ürün ara/seç',
    '请搜索/选择创建人': 'Lütfen oluşturanı ara/seç',
    编辑人: 'Düzenleyen',
    '请搜索/选择最后编辑人': 'Lütfen son düzenleyeni ara/seç',
    '请搜索/选择供应商': 'Lütfen tedarikçiyi ara/seç',
    请输入价格: 'Lütfen fiyatı girin',
    请选择委外状态: 'Lütfen dış kaynak durumunu seçin',
    请选择工序状态: 'Lütfen işlem durumunu seçin',
    店铺: 'Mağaza',
    关联状态: 'İlişki durumu',
    请选择关联状态: 'Lütfen ilişki durumunu seçin',
    未关联: 'İlişkilendirilmemiş',
    已关联: 'İlişkilendirilmiş',
    面单模板: 'Etiket şablonu',
    请选择电子面单模板: 'Lütfen elektronik etiket şablonunu seçin',
    打印类型: 'Yazdırma türü',
    请选择打印类型: 'Lütfen yazdırma türünü seçin',
    只下单不打印: 'Sadece sipariş ver, yazdırma',
    生成图片短链: 'Resim kısa bağlantısı oluştur',
    快递: 'Kargo',
    云打印机: 'Bulut yazıcı',
    生成html短链: 'HTML kısa bağlantısı oluştur',
    '请搜索/选择客户来源': 'Lütfen müşteri kaynağını ara/seç',
    '请搜索/选择销售点': 'Lütfen satış noktasını ara/seç',
    货物状态: 'Ürün durumu',
    请选择货物状态: 'Lütfen ürün durumunu seçin',
    '请搜索/选择客户': 'Lütfen müşteriyi ara/seç',
    请选择账期日期: 'Lütfen vade tarihini seçin',
    账期类型: 'Vade türü',
    请选择账期类型: 'Lütfen vade türünü seçin',
    '产品编码/名称关键字': 'Ürün kodu/ad anahtar kelimesi',
    '輸入產品/單號/手機': 'Ürün/sipariş numarası/telefon girin',
    请选择数据权限: 'Lütfen veri izinlerini seçin',
    '请搜索/选择渠道名称': 'Lütfen kanal adını ara/seç',
    '请搜索/选择产品分类': 'Lütfen ürün kategorisini ara/seç',
    '请搜索/选择部件': 'Lütfen parçayı ara/seç',
    '请搜索/选择产品货源': 'Lütfen ürün kaynağını ara/seç',
    '请搜索/选择产品上下架状态': 'Lütfen ürün raflama durumunu ara/seç',
    请选择客户类型: 'Lütfen müşteri türünü seçin',
    '请搜索/选择客户等级': 'Lütfen müşteri seviyesini ara/seç',
    '请搜索/选择客户行业': 'Lütfen müşteri sektörünü ara/seç',
    请输入感兴趣的产品: 'Lütfen ilgilendiğiniz ürünleri girin',
    线索状态: 'Fırsat durumu',
    请选择线索状态: 'Lütfen fırsat durumunu seçin',
    '名称/单号/关键词': 'Ad/sipariş numarası/anahtar kelime',
    请选择计划日期: 'Lütfen plan tarihini seçin',
    '请搜索/选择业务员': 'Lütfen satış temsilcisini ara/seç',
    退货状态: 'İade durumu',
    请选择退货状态: 'Lütfen iade durumunu seçin',
    '请搜索/选择渠道': 'Lütfen kanalı ara/seç',
    '请搜索/选择渠道类型': 'Lütfen kanal türünü ara/seç',
    图册名称: 'Fotoğraf albümü adı',
    请选择图册名称: 'Lütfen fotoğraf albümü adını seçin',
    '请输入编码/选择产品': 'Lütfen kod girin/ürün seçin',
    请选择在仓状态: 'Lütfen depo durumunu seçin',
    服务器正在升级中: 'Sunucu yükseltme işlemi sürüyor',
    '响应超时，请稍后再试':
      'Yanıt zaman aşımı, lütfen daha sonra tekrar deneyin',
    线索详情: 'Fırsat detayları',
    导出明细: 'Detayları dışa aktar',
    客户产品: 'Müşteri ürünleri',
    线索等级: 'Fırsat seviyesi',
    '您确定要将当前线索转化为客户吗？':
      'Mevcut fırsatı müşteriye dönüştürmek istediğinizden emin misiniz?',
    '您确定要将当前线索释放发到公海吗？':
      'Mevcut fırsatı ortak havuza bırakmak istediğinizden emin misiniz?',
    '您确定要领取当前线索？':
      'Mevcut fırsatı almak istediğinizden emin misiniz?',
    分配线索: 'Fırsat ata',
    是否为负责人: 'Sorumlu mu',
    天成交单数: 'Günlük işlem sayısı',
    天成交金额: 'Günlük işlem tutarı',
    客户评分: 'Müşteri puanı',
    感兴趣的产品: 'İlgi duyulan ürünler',
    折扣: 'İndirim',
    最后下单时间: 'Son sipariş zamanı',
    生成账单: 'Fatura oluştur',
    设备详情: 'Ekipman detayları',
    充值记录: 'Yükleme kayıtları',
    充值成功: 'Yükleme başarılı',
    充值失败: 'Yükleme başarısız',
    充值金额: 'Yükleme tutarı',
    充值状态: 'Yükleme durumu',
    充值账户: 'Yükleme hesabı',
    充值时间: 'Yükleme zamanı',
    物料: 'Malzeme',
    可用库存: 'Kullanılabilir stok',
    所属BOM: 'Ait olduğu BOM',
    BOM详情: 'BOM detayları',
    清单明细: 'Liste detayları',
    委外详情: 'Dış kaynak detayları',
    生成领料单: 'Malzeme çekme formu oluştur',
    退料单详情: 'Malzeme iade formu detayları',
    领料单详情: 'Malzeme çekme formu detayları',
    物料明细: 'Malzeme detayları',
    实际库存: 'Gerçek stok',
    申请数量: 'Talep miktarı',
    入库单: 'Depoya giriş formu',
    物料类型: 'Malzeme türü',
    分析结果: 'Analiz sonucu',
    已生成采购计划: 'Satın alma planı oluşturuldu',
    未生成采购计划: 'Satın alma planı oluşturulmadı',
    所需用量: 'Gerekli kullanım miktarı',
    净需求: 'Net talep',
    待采购数量: 'Satın almayı bekleyen miktar',
    已采购入库数量: 'Satın alınıp depoya giren miktar',
    待申请物料数量: 'Malzeme talebini bekleyen miktar',
    已领料出库数量: 'Çekilen malzeme çıkış miktarı',
    已退料数量: 'İade edilen malzeme miktarı',
    待安排生产: 'Üretim için bekleyen',
    已安排生产: 'Üretim planlandı',
    待安排委外: 'Dış kaynak için bekleyen',
    已生产数量: 'Üretilen miktar',
    '您确定要对当前数据生成采购计划？':
      'Mevcut veriler için satın alma planı oluşturmak istediğinizden emin misiniz?',
    生产工单详情: 'Üretim iş emri detayları',
    '您确定要对当前数据预生成工序？':
      'Mevcut veriler için işlem ön oluşturmak istediğinizden emin misiniz?',
    '您确定要对当前数据预生成入库单？':
      'Mevcut veriler için depoya giriş formu ön oluşturmak istediğinizden emin misiniz?',
    需求物料: 'Talep edilen malzeme',
    生产计划详情: 'Üretim planı detayları',
    '您确定要生成物料需求清单？':
      'Malzeme talep listesi oluşturmak istediğinizden emin misiniz?',
    生产概览: 'Üretim genel bakış',
    生产工序详情: 'Üretim işlem detayları',
    报工单详情: 'İş bildirimi detayları',
    工序号: 'İşlem numarası',
    完工数量: 'Tamamlanan miktar',
    请先选择工序执行人: 'Lütfen önce işlem uygulayıcısını seçin',
    '您确定要开始当前工序？':
      'Mevcut işlemi başlatmak istediğinizden emin misiniz?',
    分配执行人: 'Uygulayıcı ata',
    委外生产: 'Dış kaynak üretim',
    质检详情: 'Kalite kontrol detayları',
    质检明细: 'Kalite kontrol detayları',
    质检单号: 'Kalite kontrol numarası',
    质检类型: 'Kalite kontrol türü',
    质检申请人: 'Kalite kontrol başvurusu yapan',
    质检人: 'Kalite kontrol personeli',
    质检时间: 'Kalite kontrol zamanı',
    到货数量: 'Gelen miktar',
    工序详情: 'İşlem detayları',
    工艺详情: 'Proses detayları',
    工艺明细: 'Proses detayları',
    工序单位: 'İşlem birimi',
    工序负责人: 'İşlem sorumlusu',
    工序编码: 'İşlem kodu',
    回款渠道: 'Ödeme kanalı',
    对账单详情: 'Hesap özeti detayları',
    账期日期: 'Vade tarihi',
    当前欠款: 'Mevcut borç',
    账单产品明细: 'Fatura ürün detayları',
    总计回款: 'Toplam tahsilat',
    当前订单金额: 'Mevcut sipariş tutarı',
    当前已付金额: 'Mevcut ödenen tutar',
    '您确定要对当前数据重新生成对账单吗？':
      'Mevcut veriler için hesap özetini yeniden oluşturmak istediğinizden emin misiniz?',
    客户生成账单: 'Müşteri fatura oluştur',
    供应商生成账单: 'Tedarikçi fatura oluştur',
    已付款: 'Ödendi',
    未付款: 'Ödenmedi',
    已开票: 'Faturalandı',
    未开票: 'Faturalanmadı',
    客户数量: 'Müşteri sayısı',
    客户渠道: 'Müşteri kanalı',
    订单渠道: 'Sipariş kanalı',
    产品及供应链统计: 'Ürün ve tedarik zinciri istatistikleri',
    编辑产品: 'Ürün düzenle',
    新增供应链: 'Yeni tedarik zinciri ekle',
    KP资料不详细: 'KP bilgileri detaylı değil',
    周新增数据: 'Haftalık yeni veriler',
    客户数据统计: 'Müşteri veri istatistikleri',
    产品数据统计: 'Ürün veri istatistikleri',
    更新产品: 'Ürün güncelle',
    KP供应链不足: 'KP tedarik zinciri yetersiz',
    '请输入手机号/邮箱': 'Lütfen telefon numarası/e-posta girin',
    关联单号: 'İlişkili sipariş numarası',
    变更类型: 'Değişiklik türü',
    变更金额: 'Değişiklik tutarı',
    变更前: 'Değişiklikten önce',
    变更后: 'Değişiklikten sonra',
    变更时间: 'Değişiklik zamanı',
    导出模块: 'Dışa aktarma modülü',
    导出名称: 'Dışa aktarma adı',
    请选择导出模块: 'Lütfen dışa aktarma modülünü seçin',
    仓储体积详情: 'Depo hacmi detayları',
    客户数: 'Müşteri sayısı',
    订单数: 'Sipariş sayısı',
    渠道详情: 'Kanal detayları',
    关联产品: 'İlişkili ürünler',
    生成链接: 'Bağlantı oluştur',
    发布商品: 'Ürün yayımla',
    请输入关键词搜索分类: 'Lütfen kategori aramak için anahtar kelime girin',
    售价: 'Satış fiyatı',
    '您确定要对当前产品更新到阿里巴巴？':
      "Mevcut ürünü Alibaba'ya güncellemek istediğinizden emin misiniz?",
    '净品规格的默认箱规将作为品规在列表展示，外箱规格的默认箱规将作为箱规在列表展示':
      'Net ürün spesifikasyonunun varsayılan kutu spesifikasyonu listede ürün spesifikasyonu olarak, dış kutu spesifikasyonunun varsayılan kutu spesifikasyonu listede kutu spesifikasyonu olarak gösterilecektir',
    请输入箱规名称: 'Lütfen kutu spesifikasyon adını girin',
    请输入体积: 'Lütfen hacmi girin',
    非默认箱规: 'Varsayılan olmayan kutu spesifikasyonu',
    非费用箱规: 'Ücretli olmayan kutu spesifikasyonu',
    '体积/净重-毛重/长-宽-高':
      'Hacim/net ağırlık-brüt ağırlık/uzunluk-genişlik-yükseklik',
    图文详情: 'Grafik ve metin detayları',
    查看价格策略: 'Fiyat stratejisini görüntüle',
    查看历史成交: 'Geçmiş işlemleri görüntüle',
    渠道管理: 'Kanal yönetimi',
    箱规管理: 'Kutu spesifikasyon yönetimi',
    应用渠道: 'Uygulama kanalı',
    图片使用: 'Resim kullanımı',
    覆盖: 'Üzerine yaz',
    追加: 'Ekle',
    继续: 'Devam',
    选择应用渠道: 'Uygulama kanalı seç',
    图册搜索: 'Fotoğraf albümü arama',
    页: 'Sayfa',
    图册上传: 'Fotoğraf albümü yükleme',
    建议价格: 'Önerilen fiyat',
    天销量: 'Günlük satış',
    所属仓库: 'Ait olduğu depo',
    渠道数量: 'Kanal sayısı',
    选择客户: 'Müşteri seç',
    选择模板: 'Şablon seç',
    若选择客户则会导出该客户关联模版信息:
      'Müşteri seçilirse o müşteriyle ilişkili şablon bilgileri dışa aktarılacaktır',
    '为保证预览体验，当前仅展示最多':
      'Önizleme deneyimini sağlamak için şu anda en fazla',
    '条数据，点击': 'veri satırı gösterilmektedir, tıklayın',
    即可下载完整Excel数据: 'tam Excel verisini indirmek için',
    店铺类型: 'Mağaza türü',
    店铺名称: 'Mağaza adı',
    '您确定要发布当前产品?':
      'Mevcut ürünü yayınlamak istediğinizden emin misiniz?',
    绑定产品: 'Ürün bağla',
    照片: 'Fotoğraf',
    关键字: 'Anahtar kelime',
    网页: 'Web sayfası',
    页数: 'Sayfa sayısı',
    EXW币种: 'EXW para birimi',
    FOB币种: 'FOB para birimi',
    网站: 'Web sitesi',
    双击可编辑: 'Düzenlemek için çift tıklayın',
    自动上传: 'Otomatik yükleme',
    '部分产品报价高于采购单价，是否确定要审核通过？':
      'Bazı ürünlerin teklif fiyatları satın alma fiyatından yüksek, onaylamak istediğinizden emin misiniz?',
    请选择供货商: 'Lütfen tedarikçiyi seçin',
    请输入包件编码: 'Lütfen paket kodunu girin',
    请输入包件数量: 'Lütfen paket miktarını girin',
    请输入物流单号: 'Lütfen lojistik takip numarasını girin',
    厂商: 'Üretici',
    产品名: 'Ürün adı',
    '规格/材质': 'Spesifikasyon/malzeme',
    备货产品: 'Stok ürünleri',
    付款情况: 'Ödeme durumu',
    库存情况: 'Stok durumu',
    '您确定要对当前数据付款？操作后状态将会流转':
      'Mevcut veriler için ödeme yapmak istediğinizden emin misiniz? İşlem sonrası durum değişecektir',
    '您确定要对当前数据所有包裹确认收货？':
      'Mevcut verilerdeki tüm paketleri teslim almak istediğinizden emin misiniz?',
    '您确定要对当前数据发往香港仓？':
      'Mevcut verileri Hong Kong deposuna göndermek istediğinizden emin misiniz?',
    '确认所有包裹已上车？':
      'Tüm paketlerin araca yüklendiğini onaylıyor musunuz?',
    包件编码: 'Paket kodu',
    包件数量: 'Paket miktarı',
    物流单号: 'Lojistik takip numarası',
    包裹状态: 'Paket durumu',
    最近下单时间: 'Son sipariş zamanı',
    包含数量: 'İçerik miktarı',
    请选择地址: 'Lütfen adresi seçin',
    适用范围: 'Geçerlilik alanı',
    派送费用: 'Teslimat ücreti',
    基础运价: 'Temel nakliye ücreti',
    体积比: 'Hacim oranı',
    家庭地址费: 'Ev adresi ücreti',
    '目的地若为家庭地址，则收取该费用':
      'Hedef adres ev adresiyse bu ücret alınır',
    偏远地区费: 'Uzak bölge ücreti',
    '目的地邮编若在Fedex偏远地区清单中，则收取该费用':
      'Hedef posta kodu FedEx uzak bölge listesindeyse bu ücret alınır',
    特殊处理费: 'Özel işleme ücreti',
    产品实重: 'Ürün gerçek ağırlığı',
    磅: 'Pound',
    包装: 'Ambalaj',
    '满足以下任一条件，则收取该费用':
      'Aşağıdaki koşullardan biri sağlanırsa bu ücret alınır',
    产品没有完全由外包装箱包装起来:
      'Ürün tamamen dış ambalaj kutusuyla paketlenmemiş',
    外包装由缠绕膜外包: 'Dış ambalaj streç filmle paketlenmiş',
    未使用纸箱包装: 'Karton kutu kullanılmamış',
    包装箱外形不是方形的: 'Ambalaj kutusu kare şeklinde değil',
    尺寸: 'Boyutlar',
    最长边: 'En uzun kenar',
    英寸: 'İnç',
    次长边: 'İkinci en uzun kenar',
    '最短边）': 'En kısa kenar)',
    英寸且: 'İnç ve',
    超标费: 'Standart dışı ücret',
    '产生超标费后，基础运价按实际重量，体积重和':
      'Standart dışı ücret oluştuğunda, temel nakliye ücreti gerçek ağırlık, hacimsel ağırlık ve',
    磅三者中最大者计费: "pound'dan en yüksek olanına göre hesaplanır",
    用Fedex: 'FedEx kullanarak',
    Ground发货: 'Ground gönderim',
    '最短边）大于': 'En kısa kenar) büyük',
    英寸且小于等于: 'İnç ve küçük eşit',
    最长边大于: 'En uzun kenar büyük',
    Delivery发货: 'Delivery gönderim',
    未授权发货费: 'Yetkisiz gönderim ücreti',
    计价重大于: 'Ücretlendirme ağırlığı büyük',
    签收费: 'İmza ücreti',
    地址更正费: 'Adres düzeltme ücreti',
    '由于地址不正确，Fedex会设法寻找正确的地址以完成送货':
      'Adres yanlış olduğu için FedEx doğru adresi bulmaya çalışarak teslimatı tamamlayacaktır',
    '应发货方要求，更改送货地址':
      'Gönderenin talebi üzerine teslimat adresi değiştirildi',
    地址更改服务费: 'Adres değiştirme hizmet ücreti',
    '应发货方要求，更改地址或者召回货物服务费':
      'Gönderenin talebi üzerine adres değiştirme veya ürün geri çağırma hizmet ücreti',
    燃油附加费: 'Yakıt ek ücreti',
    '根据官方燃油附加费率，按百分比收取':
      'Resmi yakıt ek ücret oranına göre yüzde olarak alınır',
    适用于超大或超重件运输: 'Çok büyük veya çok ağır ürünler için geçerlidir',
    '每次发货前，可免费询价':
      'Her gönderimden önce ücretsiz fiyat sorgulaması yapılabilir',
    体积重: 'Hacimsel ağırlık',
    '高/体积比': 'Yükseklik/hacim oranı',
    计价重量为体积重和实际重量中数值较大者:
      'Ücretlendirme ağırlığı hacimsel ağırlık ve gerçek ağırlıktan yüksek olanıdır',
    '特殊处理费，超标费及未授权发货费三项，不重复收费，只收取最贵的一项':
      'Özel işleme ücreti, standart dışı ücret ve yetkisiz gönderim ücreti üçü birden değil, sadece en pahalı olanı alınır',
    '所有尺寸，重量均按英制计算':
      'Tüm boyutlar ve ağırlıklar İngiliz ölçü sistemine göre hesaplanır',
    千克: 'Kilogram',
    '所有尺寸，重量均向上取整': 'Tüm boyutlar ve ağırlıklar yukarı yuvarlanır',
    所有货币单位均为美元: 'Tüm para birimleri dolar cinsindendir',
    '如Fedex价格变动，报价将进行相应变动，我司将另行通知':
      'FedEx fiyatlarında değişiklik olursa teklif buna göre güncellenir, ayrı bildirim yapılacaktır',
    '此报价不含旺季附加费，旺季附加费按官网价收取':
      'Bu teklif sezonluk ek ücreti kapsamaz, sezonluk ek ücret resmi sitedeki fiyata göre alınır',
    旺季附加费收费时间段以Fedex官网收费时间段为准:
      'Sezonluk ek ücret tahsilat zaman dilimi FedEx resmi sitesindeki zaman dilimine göre belirlenir',
    收费重量尺寸以Fedex实际账单为准:
      'Ücretlendirme ağırlık ve boyutları FedEx gerçek faturasına göre belirlenir',
    计价重量计算方式: 'Ücretlendirme ağırlığı hesaplama yöntemi',
    见拣货费价格: 'Toplama ücreti fiyatına bakın',
    今日计划详情: 'Bugünkü plan detayları',
    快递详情: 'Kargo detayları',
    物流信息: 'Lojistik bilgileri',
    查看运费: 'Nakliye ücretini görüntüle',
    快递服务商: 'Kargo servis sağlayıcısı',
    个工作日: 'iş günü',
    含: 'içerir',
    免费追踪: 'Ücretsiz takip',
    选择快递: 'Kargo seç',
    请完善包裹信息: 'Lütfen paket bilgilerini tamamlayın',
    '您确定选择当前快递服务商并支付费用?':
      'Mevcut kargo servis sağlayıcısını seçip ücreti ödemek istediğinizden emin misiniz?',
    运费预估: 'Nakliye ücreti tahmini',
    关联发货计划: 'İlişkili gönderim planı',
    物品体积: 'Ürün hacmi',
    物品总重量: 'Ürün toplam ağırlığı',
    您确定要对当前数据进行寄件:
      'Mevcut veriler için gönderim yapmak istediğinizden emin misiniz',
    您确定要对当前数据进行取消寄件:
      'Mevcut veriler için gönderimi iptal etmek istediğinizden emin misiniz',
    选择面单: 'Etiket seç',
    选择打印机: 'Yazıcı seç',
    费用预估为: 'Tahmini ücret',
    费用预估: 'Ücret tahmini',
    '您确定要对当前产品发往香港仓？':
      'Mevcut ürünü Hong Kong deposuna göndermek istediğinizden emin misiniz?',
    发货单详情: 'Gönderim formu detayları',
    文本记录: 'Metin kayıtları',
    '规格/尺寸': 'Spesifikasyon/boyut',
    发货仓: 'Gönderim deposu',
    包件备注: 'Paket notu',
    行程安排: 'Seyahat planı',
    送货员: 'Teslimat personeli',
    '确认取消包裹派送？': 'Paket teslimatını iptal etmeyi onaylıyor musunuz?',
    '确认包裹客户已接收？': 'Paketin müşterince alındığını onaylıyor musunuz?',
    '确认包裹要回仓？': 'Paketin depoya geri döndüğünü onaylıyor musunuz?',
    未安排: 'Planlanmadı',
    库存状况: 'Stok durumu',
    采购情况: 'Satın alma durumu',
    确认收货: 'Teslim almayı onayla',
    发往香港仓: 'Hong Kong deposuna gönder',
    确认上车: 'Araca yükleme onayı',
    您确定对所选数据进行全部: 'Seçilen tüm veriler için',
    '操作吗？': 'işlem yapmak istediğinizden emin misiniz?',
    采购中: 'Satın alma sürecinde',
    已售待送: 'Satıldı, gönderim bekleniyor',
    收货单详情: 'Teslim alım formu detayları',
    '您确定要签收入库？': 'Depoya giriş yapmak istediğinizden emin misiniz?',
    供货商: 'Tedarikçi',
    到达时间: 'Varış zamanı',
    出入库单号: 'Giriş/çıkış formu numarası',
    仓位: 'Depo konumu',
    '总体积(m³)': 'Toplam hacim (m³)',
    添加行: 'Satır ekle',
    添加列: 'Sütun ekle',
    拆分为表格: 'Tabloya böl',
    当前共有: 'Şu anda toplam',
    '条数据，请输入要拆分的行数':
      'veri satırı var, lütfen bölünecek satır sayısını girin',
    拆分的行数: 'Bölünen satır sayısı',
    请输入要拆分的行数: 'Lütfen bölünecek satır sayısını girin',
    商品快递索赔详情: 'Ürün kargo talep detayları',
    请选择商品代发单: 'Lütfen ürün gönderim formunu seçin',
    商品退货详情: 'Ürün iade detayları',
    商品代发详情: 'Ürün gönderim detayları',
    '您确定要通知仓库发货？':
      'Depoya gönderim bildirimi yapmak istediğinizden emin misiniz?',
    请完善产品仓库信息: 'Lütfen ürün depo bilgilerini tamamlayın',
    入库预报详情: 'Depoya giriş tahmini detayları',
    '您确定要发货？': 'Gönderim yapmak istediğinizden emin misiniz?',
    索赔原因: 'Talep nedeni',
    '您确定要对当前数据进行退货处理?':
      'Mevcut veriler için iade işlemi yapmak istediğinizden emin misiniz?',
    发货模版: 'Gönderim şablonu',
    智能识别: 'Akıllı tanıma',
    您确定要对当前订单进行作废:
      'Mevcut siparişi iptal etmek istediğinizden emin misiniz',
    '部分产品报价低于最低售价确定要审核通过？':
      'Bazı ürünlerin teklif fiyatları minimum satış fiyatının altında, onaylamak istediğinizden emin misiniz?',
    预设报价: 'Ön tanımlı teklif',
    是否发货: 'Gönderilsin mi',
    '您确定要取消当前订单寄件？':
      'Mevcut sipariş gönderimini iptal etmek istediğinizden emin misiniz?',
    '您确定要清除当前订单的关联信息？清除后可以重新添加产品':
      'Mevcut siparişle ilişkili bilgileri silmek istediğinizden emin misiniz? Silindikten sonra ürünleri yeniden ekleyebilirsiniz',
    VIP类型: 'VIP türü',
    商店域名: 'Mağaza alan adı',
    请输入商店域名: 'Lütfen mağaza alan adını girin',
    请选择VIP类型: 'Lütfen VIP türünü seçin',
    选项值: 'Seçenek değeri',
    面单标题: 'Etiket başlığı',
    网点: 'Şube',
    快递员: 'Kurye',
    面单编码: 'Etiket kodu',
    面单模版: 'Etiket şablonu',
    绑定打印机: 'Yazıcıyı bağla',
    秘钥: 'Gizli anahtar',
    校验码: 'Doğrulama kodu',
    打印机类型: 'Yazıcı türü',
    在线状态: 'Çevrimiçi durum',
    模版图: 'Şablon resmi',
    模版标题: 'Şablon başlığı',
    '打印纸尺寸(mm)': 'Yazdırma kağıdı boyutu (mm)',
    快递面单模版: 'Kargo etiket şablonu',
    排序字段: 'Sıralama alanı',
    '您确定要对当前数据进行同步翻译？':
      'Mevcut veriler için senkron çeviri yapmak istediğinizden emin misiniz?',
    请输入code编码: 'Lütfen kodu girin',
    请输入汇率: 'Lütfen döviz kurunu girin',
    销售单号规则: 'Satış sipariş numarası kuralı',
    采购单号规则: 'Satın alma sipariş numarası kuralı',
    使用币种: 'Kullanılan para birimi',
    默认汇率: 'Varsayılan döviz kuru',
    开启供应商仓储报表: 'Tedarikçi depo raporunu aç',
    默认币种: 'Varsayılan para birimi',
    费用征收比例: 'Ücret tahsilat oranı',
    请输入merchant: 'Lütfen tüccarı girin',
    秘钥Key: 'Gizli Anahtar (Key)',
    请输入秘钥Key: 'Lütfen Gizli Anahtarı (Key) girin',
    不允许使用特殊符号: 'Özel sembollerin kullanılmasına izin verilmez',
    公钥Key: 'Genel Anahtar (Key)',
    请输入公钥Key: 'Lütfen Genel Anahtarı (Key) girin',
    字段控制: 'Alan kontrolü',
    stripe支付配置: 'Stripe ödeme yapılandırması',
    乐刷支付配置: 'Leshua ödeme yapılandırması',
    使用次数: 'Kullanım sayısı',
    已授权: 'Yetkilendirildi',
    未授权: 'Yetkilendirilmedi',
    扫码授权: 'QR kodla yetkilendir',
    授权状态: 'Yetkilendirme durumu',
    token过期时间: 'Token son kullanma zamanı',
    昨日销量: 'Dünkü satışlar',
    店铺扫码授权: 'Mağaza QR kod yetkilendirmesi',
    三方渠道: 'Üçüncü taraf kanal',
    '您确定生成全部任务？':
      'Tüm görevleri oluşturmak istediğinizden emin misiniz?',
    // TODO: 2025-08-18
    选择日期时间: 'Tarih ve saat seçin',
    分阶段付款: 'Aşamalı ödeme',
    请输入或选择颜色: 'Lütfen renk girin veya seçin',
    已选: 'Seçildi',
    '现货发货获取流量扶持，一档时效越短数量越多，流量扶持越多；买家下单数量超出一档或商品仅勾选定制视为定制交易':
      'Stoktan gönderim trafiği destekler, bir seviye ne kadar kısa süre ve fazla miktar ise o kadar fazla trafik desteği; alıcı sipariş miktarı bir seviyeyi aşarsa veya ürün sadece özelleştirme seçiliyse özelleştirme işlemi olarak kabul edilir',
    库存上限: 'Stok üst limiti',
    '预览（可根据买家购买的不同数量设置不同的发货时间）':
      'Önizleme (alıcıların farklı satın alma miktarlarına göre farklı gönderim süreleri ayarlanabilir)',
    以上: 'Üzeri',
    承诺: 'Taahhüt',
    属性已存在: 'Özellik zaten mevcut',
    图片选择: 'Resim seçimi',
    管理相册: 'Albüm yönetimi',
    要插入的图片: 'Eklenecek resimler',
    使用选中图片: 'Seçili resimleri kullan',
    请选择相册: 'Lütfen albüm seçin',
    图片选择超出最大数量: 'Resim seçimi maksimum miktarı aşıyor',
    规格图片: 'Spesifikasyon resimleri',
    '体积(cm³)': 'Hacim (cm³)',
    '重量(g)': 'Ağırlık (g)',
    按规格设置: 'Spesifikasyona göre ayarla',
    按商品设置: 'Ürüne göre ayarla',
    白色系: 'Beyaz tonları',
    乳白色: 'Süt beyazı',
    米白色: 'Bej',
    象牙白: 'Fildişi beyazı',
    灰色系: 'Gri tonları',
    灰色: 'Gri',
    浅灰色: 'Açık gri',
    深灰色: 'Koyu gri',
    银色: 'Gümüş',
    铅色: 'Kurşun rengi',
    奶奶灰: 'Dedemin gri',
    石板灰: 'Arduvaz gri',
    深空灰: 'Derin uzay gri',
    石墨色: 'Grafit rengi',
    银灰色: 'Gümüş gri',
    黑色系: 'Siyah tonları',
    红色系: 'Kırmızı tonları',
    桔红色: 'Turuncu kırmızı',
    粉红色: 'Pembe',
    玫红色: 'Fuşya',
    藕色: 'Nilüfer rengi',
    西瓜红: 'Karpuz kırmızısı',
    酒红色: 'Bordo',
    桃色: 'Şeftali rengi',
    深红色: 'Koyu kırmızı',
    砖红色: 'Tuğla kırmızısı',
    橙红色: 'Turuncu kırmızı',
    珊瑚色: 'Mercan rengi',
    洋红色: 'Magenta',
    亮粉: 'Parlak pembe',
    胭脂色: 'Ruj rengi',
    深粉红: 'Koyu pembe',
    蔷薇色: 'Gül rengi',
    猩红色: 'Kızıl',
    黄色系: 'Sarı tonları',
    黄色: 'Sarı',
    浅黄色: 'Açık sarı',
    柠檬黄: 'Limon sarısı',
    桔色: 'Turuncu',
    明黄色: 'Canlı sarı',
    金色: 'Altın',
    荧光黄: 'Florasan sarı',
    姜黄色: 'Zerdeçal rengi',
    香槟色: 'Şampanya rengi',
    杏色: 'Kayısı rengi',
    卡其色: 'Haki',
    土黄色: 'Toprak sarısı',
    橙色: 'Portakal',
    肤色: 'Ten rengi',
    小麦色: 'Buğday rengi',
    向日葵色: 'Ayçiçeği rengi',
    绿色系: 'Yeşil tonları',
    绿色: 'Yeşil',
    浅绿色: 'Açık yeşil',
    墨绿色: 'Koyu yeşil',
    军绿色: 'Ordu yeşili',
    翠绿色: 'Zümrüt yeşili',
    荧光绿: 'Florasan yeşil',
    青色: 'Camgöbeği',
    草绿色: 'Çimen yeşili',
    黄绿色: 'Sarımsı yeşil',
    碧绿: 'Turkuaz',
    绿宝石: 'Zümrüt',
    海洋绿: 'Deniz yeşili',
    橄榄色: 'Zeytin rengi',
    橄榄绿: 'Zeytin yeşili',
    抹茶色: 'Maça rengi',
    孔雀绿: 'Papağan yeşili',
    蓝色系: 'Mavi tonları',
    蓝色: 'Mavi',
    天蓝色: 'Gök mavisi',
    孔雀蓝: 'Papağan mavisi',
    宝蓝色: 'Lacivert',
    深蓝色: 'Koyu mavi',
    湖蓝色: 'Göl mavisi',
    浅蓝色: 'Açık mavi',
    藏青色: 'Lacivert',
    海蓝色: 'Deniz mavisi',
    蔚蓝色: 'Açık mavi',
    紫色系: 'Mor tonları',
    紫色: 'Mor',
    浅紫色: 'Açık mor',
    深紫色: 'Koyu mor',
    紫红色: 'Eflatun',
    紫罗兰: 'Menekşe',
    暗紫罗兰: 'Koyu menekşe',
    深洋红色: 'Koyu magenta',
    紫兰色: 'Orkide rengi',
    薰衣草紫: 'Lavanta rengi',
    棕色系: 'Kahverengi tonları',
    咖啡色: 'Kahverengi',
    深棕色: 'Koyu kahverengi',
    浅棕色: 'Açık kahverengi',
    栗色: 'Kestane rengi',
    深卡其布色: 'Koyu haki',
    巧克力色: 'Çikolata rengi',
    褐色: 'Kahverengi',
    驼色: 'Deve tüyü rengi',
    焦糖色: 'Karamel rengi',
    古铜色: 'Bronz',
    红褐色: 'Kızıl kahverengi',
    琥珀色: 'Amber',
    玫瑰金: 'Gül altın',
    透明系: 'Şeffaf tonlar',
    透明: 'Şeffaf',
    '7天包换Tips':
      'Satıcı, alıcı koruma hizmeti taahhüdü temelinde, alıcılara isteğe bağlı olarak "7 gün içinde değişim" hizmeti sunmayı taahhüt eder. Alıcılar "7 gün içinde değişim" hizmetini destekleyen ürünleri çevrimiçi sipariş ettikten sonra, satıcı alıcının ürünleri teslim almasından sonraki 7 gün içinde, insan kaynaklı olmayan hasarlar için değişim hizmeti sunar. Satıcı bu taahhüdü yerine getirmezse, alıcılar belirlenen süre içinde hak talebinde bulunabilir ve tazminat talep edebilir.',
    '7天无理由退Tips':
      'Satıcı, alıcının ürünleri teslim almasından sonraki 7 gün içinde, "ürün hasarsız" durumunda alıcıya iade hizmeti sunar.',
    材质保障Tips:
      "Satıcı, alıcı koruma hizmeti taahhüdü temelinde, alıcılara isteğe bağlı olarak koruma hizmeti sunar. Satıcı, bu ürünün alıcıyla önceden协商 edilen malzeme gereksinimlerine uyduğunu taahhüt eder, aksi takdirde ürün bedelinin %20'si (ancak en fazla 10.000 yuan) oranında alıcıya tazminat öder.",
    破损包赔Tips:
      'Satıcı, alıcı koruma hizmeti taahhüdü temelinde, alıcılara isteğe bağlı olarak "hasarlı ürün tazminatı" hizmeti sunar. Alıcılar satıcının ürünlerini çevrimiçi sipariş ettikten sonra ürün hasarlıysa, satıcı garanti süresi içinde ücretsiz olarak alıcıya bir kez yeniden gönderim yapar, yeniden gönderimden sonra alıcı hala sağlam bir ürün alamazsa, satıcı hasarlı ürün için iade ve geri ödeme hizmeti sunar.',
    少货必赔Tips:
      'Satıcı belirlenen süre içinde ilgili kanıt materyallerini sağlayamazsa veya ilgili kanıt materyalleri açıkça geçersizse, Alibaba alıcının tazminat talebini kabul eder, satıcı bu anlaşmaya göre alıcının uğradığı zararı tazmin etmeyi kabul eder, tazminat miktarı alıcının gerçekten ödediği eksik ürün bedelidir (sadece aksesuar eksikse bile tüm ürün bedeli ödenmelidir). Bu durumda Alibaba satıcının depozitosunu kullanma veya Alipay şirketine satıcının Alipay hesabından doğrudan ilgili miktarı düşerek alıcıya önceden ödeme yapma hakkına sahiptir.',
    坏单包赔Tips:
      'Alibaba alıcının tazminat talebini kabul eder, satıcı bu anlaşmaya göre alıcının uğradığı zararı tazmin etmeyi kabul eder, tazminat miktarı alıcının iddia ettiği bozuk sipariş miktarının ürün bedelidir. Bu durumda Alibaba satıcının depozitosunu kullanma veya Alipay şirketine satıcının Alipay hesabından doğrudan ilgili miktarı düşerek alıcıya önceden ödeme yapma hakkına sahiptir.',
    官方直送Tips:
      'Satıcı "resmi doğrudan teslimat" koruma hizmetini etkinleştirdikten sonra, alıcılara aynı zamanda "resmi doğrudan teslimat" koruma hizmetini sunmayı taahhüt eder. Ürün aşağıdaki koşulları karşılamalıdır, bu ürün "resmi doğrudan teslimat" koruma hizmeti etiketini gösterecektir: (1) Ürün üzerinde "resmi doğrudan teslimat" koruma hizmetini işaretlediniz; (2) Bu ürün "nakliye ücreti rehber şablonunu" kullanır; (3) Satıcının bu ürünü son 30 gün içindeki işlem siparişlerinde "resmi doğrudan teslimat" hizmeti gönderim oranı %90 ve üzeri (son 30 gün içindeki işlem sipariş miktarı 10 ve üzeri). Satıcı ürünün "nakliye ücreti rehber şablonunu" kullanmadığı veya son 30 gün içindeki işlem siparişlerinde "resmi doğrudan teslimat" hizmeti gönderim oranı %90 ve üzeri (son 30 gün içindeki işlem sipariş miktarı 10 ve üzeri) taahhüdünü yerine getirmezse, bu ürün kaldırılacaktır.',
    天包换: 'Gün değişim',
    天包换Tips: 'Gün değişim ipuçları',
    天无理由退: 'Gün neden yok iade',
    天无理由退Tips: 'Gün neden yok iade ipuçları',
    材质保障: 'Malzeme garantisi',
    破损包赔: 'Hasarlı ürün tazminatı',
    少货必赔: 'Eksik ürün tazminatı',
    坏单包赔: 'Bozuk sipariş tazminatı',
    官方直送: 'Resmi doğrudan teslimat',
    常用类目: 'Sık kullanılan kategoriler',
    您选择的类目: 'Seçtiğiniz kategori',
    主要下游平台: 'Ana akış platformları',
    速卖通: 'AliExpress',
    亚马逊: 'Amazon',
    独立站: 'Bağımsız site',
    主要销售地区: 'Ana satış bölgeleri',
    欧洲: 'Avrupa',
    北美: 'Kuzey Amerika',
    南美: 'Güney Amerika',
    东南亚: 'Güneydoğu Asya',
    东北亚: 'Kuzeydoğu Asya',
    中东: 'Orta Doğu',
    非洲: 'Afrika',
    请至少选择一项: 'Lütfen en az bir öğe seçin',
    '您已开通买保服务，当前保证金金额为':
      'Alıcı koruma hizmetini etkinleştirdiniz, mevcut depozito tutarı:',
    保障服务首页: 'Garanti hizmeti ana sayfası',
    申请开通: 'Etkinleştirme talep et',
    不支持: 'Desteklenmiyor',
    值: 'Değer',
    自产产品: 'Kendi üretimi ürünler',
    KP产品: 'KP ürünleri',
    有产品凭证: 'Ürün belgesi var',
    首次采购: 'İlk satın alma',
    '次采购,之前共采购': 'kez satın alındı, toplamda satın alındı',
    '产品数量低于最低起售数量不可提交,请调整!':
      'Ürün miktarı minimum satış miktarının altında olduğu için gönderilemez, lütfen ayarlayın!',
    产品数量低于最低起售数量: 'Ürün miktarı minimum satış miktarının altında',
    产品报价低于最低售价: 'Ürün teklifi minimum satış fiyatının altında',
    产品报价高于最低采购价: 'Ürün teklifi minimum satın alma fiyatının üstünde',
    三方仓库名: 'Üçüncü taraf depo adı',
    冻结数量: 'Dondurulmuş miktar',
    订单日期: 'Sipariş tarihi',
    流程名称: 'Süreç adı',
    货架: 'Raf',
    更新: 'Güncelle',
    暂无: 'Henüz yok',
    deliveryPlanNumTips:
      'Toplam miktar - Gönderim miktarı = Bekleyen miktar (birim)',
    stockNumTips: 'Stok - Dondurulmuş stok = Kullanılabilir stok (birim)',
    totalStockNumTips:
      'Stok (Toplam stok - Dondurulmuş stok = Kullanılabilir stok) (birim)',
    冻结库存: 'Dondurulmuş stok',
    '添加中...': 'Ekleniyor...',
    调价: 'Fiyat ayarla',
    不调价: 'Fiyat ayarlama',
    上次采购价: 'Son satın alma fiyatı',
    产品价格和数量一样: 'Ürün fiyatı ve miktarı aynı',
    请选择船号: 'Lütfen gemi numarasını seçin',
    请选择集装箱号: 'Lütfen konteyner numarasını seçin',
    '调出仓库(库存)': 'Çıkış deposu (stok)',
    '调入仓库(库存)': 'Giriş deposu (stok)',
    自项目实际完结日起: 'Proje gerçek tamamlanma tarihinden itibaren',
    当前产品的个仓位数量信息: 'Mevcut ürünün pozisyon miktar bilgileri',
    当前产品的冻结库存信息: 'Mevcut ürünün dondurulmuş stok bilgileri',
    在途库存: 'Yoldaki stok',
    默认仓位: 'Varsayılan pozisyon',
    已生成: 'Oluşturuldu',
    未生成: 'Oluşturulmadı',
    备货图: 'Stok hazırlama diyagramı',
    船号: 'Gemi numarası',
    集装箱号: 'Konteyner numarası',
    '您当前数量低于最小起订量，请修改！':
      'Mevcut miktarınız minimum sipariş miktarının altında, lütfen değiştirin!',
    导入数据: 'Veri içe aktar',
    下载模板: 'Şablon indir',
    请配置模块名称: 'Lütfen modül adını yapılandırın',
    聚合搜索: 'Toplu arama',
    产品标题: 'Ürün başlığı',
    全部产品: 'Tüm ürünler',
    按产品数量: 'Ürün miktarına göre',
    按产品种类: 'Ürün türüne göre',
    项目: 'Proje',
    出入库单: 'Giriş/çıkış formu',
    项目服务商: 'Proje servis sağlayıcısı',
    模具: 'Kalıp',
    我创建的: 'Oluşturduğum',
    我负责的: 'Sorumlu olduğum',
    我参与的: 'Katıldığım',
    元旦节: 'Yeni Yıl',
    情人节: 'Sevgililer Günü',
    劳动节: 'İşçi Bayramı',
    青年节: 'Gençlik Günü',
    儿童节: 'Çocuk Bayramı',
    教师节: 'Öğretmenler Günü',
    国庆节: 'Ulusal Gün',
    圣诞节: 'Noel',
    妇女节: 'Kadınlar Günü',
    植树节: 'Ağaç Dikme Günü',
    愚人节: '1 Nisan Şaka Günü',
    护士节: 'Hemşireler Günü',
    建党节: 'Parti Kuruluş Günü',
    建军节: 'Ordunun Kuruluş Günü',
    平安夜: 'Arife',
    除夕: 'Çin Yeni Yılı Arifesi',
    春节: 'Çin Yeni Yılı',
    元宵节: 'Lantern Festivali',
    龙抬头: 'Dragon Başını Kaldırma Günü',
    端午节: 'Dragon Botu Festivali',
    七夕节: 'Qixi Festivali',
    中元节: 'Hayalet Festivali',
    中秋节: 'Güz Ortası Festivali',
    重阳节: 'Çift Dokuzlar Festivali',
    寒衣节: 'Soğuk Giysi Festivali',
    下元节: 'Alt Ay Festivali',
    腊八节: 'Laba Festivali',
    北方小年: 'Kuzey Küçük Yeni Yıl',
    南方小年: 'Güney Küçük Yeni Yıl',
    打印失败: 'Yazdırma başarısız',
    今日: 'Bugün',
    昨日: 'Dün',
    本周: 'Bu hafta',
    上周: 'Geçen hafta',
    本月: 'Bu ay',
    上月: 'Geçen ay',
    最近三个月: 'Son 3 ay',
    最近半年: 'Son 6 ay',
    用时: 'Harcanan süre',
    天: 'Gün',
    逾期: 'Gecikmiş',
    剩余: 'Kalan',
    已完结: 'Tamamlanmış',
    公式必须是字符串类型: 'Formül string tipinde olmalıdır',
    变量必须是对象类型: 'Değişken object tipinde olmalıdır',
    无效的变量名: 'Geçersiz değişken adı',
    公式包含不允许的字符: 'Formül izin verilmeyen karakterler içeriyor',
    计算结果不是有效数字: 'Hesaplama sonucu geçerli bir sayı değil',
    计算失败: 'Hesaplama başarısız',
    零售适配: 'Perakende uyumu',
    相册: 'Albüm',
    生日: 'Doğum günü',
    宗教: 'Din',
    账单地址: 'Fatura adresi',
    订单来源: 'Sipariş kaynağı',
    审核备注: 'İnceleme notu',
    复核状态: 'Yeniden kontrol durumu',
    复核人: 'Yeniden kontrol eden',
    复核备注: 'Yeniden kontrol notu',
    备货进度: 'Stok hazırlama ilerlemesi',
    发货单据: 'Sevkiyat belgesi',
    请选择州: 'Lütfen eyalet seçin',
    计划金额: 'Planlanan tutar',
    回款状态: 'Geri ödeme durumu',
    次品数: 'Defolu ürün sayısı',
    不合格数量: 'Uygun olmayan miktar',
    次品数量: 'Defolu ürün miktarı',
    模具名称: 'Kalıp adı',
    模具编码: 'Kalıp kodu',
    模具类型: 'Kalıp türü',
    开发方: 'Geliştirici',
    维护方: 'Bakım sağlayıcı',
    加工方: 'İşleyen taraf',
    耗材: 'Sarf malzemesi',
    当前位置: 'Mevcut konum',
    模具成本: 'Kalıp maliyeti',
    成本描述: 'Maliyet açıklaması',
    产权描述: 'Mülkiyet açıklaması',
    模具图集: 'Kalıp resim koleksiyonu',
    模具描述: 'Kalıp açıklaması',
    研发成本: 'Araştırma ve geliştirme maliyeti',
    生产成本: 'Üretim maliyeti',
    预计售价: 'Tahmini satış fiyatı',
    回本数量: 'Kar noktası miktarı',
    样品状态: 'Numune durumu',
    启动时间: 'Başlatma zamanı',
    预计完结: 'Tahmini tamamlanma',
    实际完结: 'Gerçek tamamlanma',
    项目描述: 'Proje açıklaması',
    项目成本: 'Proje maliyeti',
    产品成本: 'Ürün maliyeti',
    项目复盘: 'Proje değerlendirmesi',
    关联模块: 'İlişkili modül',
    关联数据: 'İlişkili veri',
    任务描述: 'Görev açıklaması',
    完成图集: 'Tamamlanma resim koleksiyonu',
    完成视频: 'Tamamlanma videosu',
    完成反馈: 'Tamamlanma geri bildirimi',
    配送员: 'Dağıtım personeli',
    配送仓库: 'Dağıtım deposu',
    配送状态: 'Dağıtım durumu',
    批量审核: 'Toplu inceleme',
    零售价格: 'Perakende fiyatı',
    批发价: 'Ticari fiyat',
    基础信息: 'Temel bilgiler',
    请选择标签: 'Lütfen etiket seçin',
    销售信息: 'Satış bilgileri',
    仓储信息: 'Depolama bilgileri',
    分类信息: 'Sınıflandırma bilgileri',
    图片与视频: 'Resimler ve videolar',
    包装与箱规: 'Ambalaj ve kutu spesifikasyonları',
    描述与详情: 'Açıklama ve detaylar',
    拓展信息: 'Genişletilmiş bilgiler',
    '数据未保存是否保存数据？': 'Veri kaydedilmedi, veri kaydedilsin mi?',
    不保存: 'Kaydetme',
    按SKU: "SKU'ya göre",
    按产品分类: 'Ürün kategorisine göre',
    所有: 'Tümü',
    同步得物价格: 'Dewu fiyatını senkronize et',
    请输入具体的SKU: 'Lütfen spesifik SKU girin',
    同步: 'Senkronize et',
    同步得物商品: 'Dewu ürününü senkronize et',
    尺寸单位: 'Boyut birimi',
    请选择尺寸单位: 'Lütfen boyut birimini seçin',
    重量单位: 'Ağırlık birimi',
    请选择重量单位: 'Lütfen ağırlık birimini seçin',
    商品ID: 'Ürün ID',
    请输入Shopify商品页面链接中products后面跟的纯数字ID:
      "Lütfen Shopify ürün sayfası bağlantısında products'tan sonra gelen saf sayısal ID'yi girin",
    请选择订单来源: 'Lütfen sipariş kaynağını seçin',
    '您的报价产品中有低于最低售价或最小起订量的产品，请检查！':
      'Teklif ettiğiniz ürünlerde minimum satış fiyatı veya minimum sipariş miktarının altında ürünler var, lütfen kontrol edin!',
    请选择来源: 'Lütfen kaynağı seçin',
    请选择日期: 'Lütfen tarihi seçin',
    请输入宗教: 'Lütfen din girin',
    客户标签: 'Müşteri etiketi',
    供应商标签: 'Tedarikçi etiketi',
    运费测算: 'Nakliye ücreti hesaplama',
    请输入处理方式: 'Lütfen işlem yöntemini girin',
    添加回款明细: 'Geri ödeme detayı ekle',
    其他费用: 'Diğer ücretler',
    费用减免: 'Ücret indirimi',
    额外费用: 'Ek ücretler',
    费用说明: 'Ücret açıklaması',
    职责: 'Sorumluluk',
    直接输入并选择: 'Doğrudan gir ve seç',
    批量生成入库预报: 'Toplu depo giriş tahmini oluştur',
    各产品数量: 'Her ürün miktarı',
    请填写数量: 'Lütfen miktarı doldurun',
    平台单号: 'Platform sipariş numarası',
    请输入平台单号: 'Lütfen platform sipariş numarasını girin',
    '仓库代退-商品退货单': 'Depo iade - Ürün iade formu',
    添加快递单号: 'Kargo takip numarası ekle',
    码头: 'İskele',
    请选择码头: 'Lütfen iskeleyi seçin',
    三方仓产品调拨: 'Üçüncü taraf depo ürün transferi',
    关联网页: 'İlişkili web sayfası',
    字段取值: 'Alan değeri',
    请输入取值字段: 'Lütfen değer alanını girin',
    部件属性: 'Parça özelliği',
    '部件属性在设置》扩展字段》产品中添加':
      'Parça özellikleri Ayarlar > Genişletilmiş Alanlar > Ürün bölümünde eklenir',
    请选择部件包含的属性: 'Lütfen parça içeren özellikleri seçin',
    密钥: 'Gizli anahtar',
    请输入密钥: 'Lütfen gizli anahtarı girin',
    父级仓库: 'Üst düzey depo',
    打印图片: 'Resmi yazdır',
    模块名称: 'Modül adı',
    请输入模块名称: 'Lütfen modül adını girin',
    显示移动端: 'Mobil görünümü göster',
    凭证文件: 'Belge dosyası',
    生产: 'Üretim',
    '良品数量(实际入库数量)': 'İyi ürün miktarı (gerçek depo giriş miktarı)',
    请输入Key: 'Lütfen Key girin',
    请输入Secret: 'Lütfen Secret girin',
    资产: 'Varlık',
    资产类型: 'Varlık türü',
    请选择资产类型: 'Lütfen varlık türünü seçin',
    资产状态: 'Varlık durumu',
    请选择资产状态: 'Lütfen varlık durumunu seçin',
    资产编码: 'Varlık kodu',
    请输入资产编码: 'Lütfen varlık kodunu girin',
    资产名称: 'Varlık adı',
    请输入资产名称: 'Lütfen varlık adını girin',
    购入日期: 'Satın alma tarihi',
    请选择购入日期: 'Lütfen satın alma tarihini seçin',
    请输入规格型号: 'Lütfen spesifikasyon modelini girin',
    设备序列号: 'Cihaz seri numarası',
    请输入设备序列号: 'Lütfen cihaz seri numarasını girin',
    价值币种: 'Değer para birimi',
    期初价值: 'Başlangıç değeri',
    请输入期初价值: 'Lütfen başlangıç değerini girin',
    当前价值: 'Mevcut değer',
    请输入当前价值: 'Lütfen mevcut değeri girin',
    使用人: 'Kullanıcı',
    请选择使用人: 'Lütfen kullanıcı seçin',
    使用部门: 'Kullanım departmanı',
    请选择使用部门: 'Lütfen kullanım departmanını seçin',
    存放位置: 'Depolama konumu',
    请输入存放位置: 'Lütfen depolama konumunu girin',
    资产图集: 'Varlık resim koleksiyonu',
    资产描述: 'Varlık açıklaması',
    请输入资产描述: 'Lütfen varlık açıklamasını girin',
    生产模具: 'Üretim kalıbı',
    请输入模具名称: 'Lütfen kalıp adını girin',
    请选择模具类型: 'Lütfen kalıp türünü seçin',
    请输入模具编码SN: "Lütfen kalıp kodu SN'sini girin",
    模具状态: 'Kalıp durumu',
    请输入模具成本: 'Lütfen kalıp maliyetini girin',
    成本币种: 'Maliyet para birimi',
    模具位置: 'Kalıp konumu',
    请输入模具位置: 'Lütfen kalıp konumunu girin',
    请输入成本描述: 'Lütfen maliyet açıklamasını girin',
    请输入耗材描述: 'Lütfen sarf malzemesi açıklamasını girin',
    请选择模具开发商: 'Lütfen kalıp geliştiriciyi seçin',
    请选择模具维护方: 'Lütfen kalıp bakım sağlayıcıyı seçin',
    请选择模具加工方: 'Lütfen kalıp işleyen tarafı seçin',
    请输入模具描述: 'Lütfen kalıp açıklamasını girin',
    请输入产权描述: 'Lütfen mülkiyet açıklamasını girin',
    请输入项目名称: 'Lütfen proje adını girin',
    项目标签: 'Proje etiketi',
    项目阶段: 'Proje aşaması',
    请输入启动时间: 'Lütfen başlatma zamanını girin',
    请输入预计完结时间: 'Lütfen tahmini tamamlanma zamanını girin',
    请输入实际完结时间: 'Lütfen gerçek tamamlanma zamanını girin',
    项目预算: 'Proje bütçesi',
    请输入项目预计研发成本:
      'Lütfen proje tahmini araştırma-geliştirme maliyetini girin',
    请输入项目预计生产成本: 'Lütfen proje tahmini üretim maliyetini girin',
    请输入预计售价: 'Lütfen tahmini satış fiyatını girin',
    请输入项目预计回本数量: 'Lütfen proje tahmini kar noktası miktarını girin',
    请输入项目描述: 'Lütfen proje açıklamasını girin',
    请输入项目成本描述: 'Lütfen proje maliyet açıklamasını girin',
    请输入项目产品成本描述: 'Lütfen proje ürün maliyet açıklamasını girin',
    请输入项目复盘内容: 'Lütfen proje değerlendirme içeriğini girin',
    详情描述: 'Detay açıklaması',
    请输入详情描述: 'Lütfen detay açıklamasını girin',
    请选择发货地址: 'Lütfen gönderim adresini seçin',
    货架数量: 'Raf miktarı',
    请输入货架数量: 'Lütfen raf miktarını girin',
    '前缀标题如：仓库1-': 'Önek başlık örneği: Depo1-',
    '后缀标题如：-01行': 'Sonek başlık örneği: -01 satır',
    第三方仓库: 'Üçüncü taraf depo',
    三方仓库: 'Üçüncü taraf depo',
    请选择三方仓库公司: 'Lütfen üçüncü taraf depo şirketini seçin',
    产品授权大市场: 'Ürün yetkilendirme büyük pazarı',
    授权公司: 'Yetkilendirme şirketi',
    请选择授权公司: 'Lütfen yetkilendirme şirketini seçin',
    授权产品: 'Yetkilendirme ürünü',
    产品评论: 'Ürün yorumları',
    显示状态: 'Gösterim durumu',
    评论图片: 'Yorum resimleri',
    评论内容: 'Yorum içeriği',
    请输入评论内容: 'Lütfen yorum içeriğini girin',
    请输入标签名称: 'Lütfen etiket adını girin',
    标签类型: 'Etiket türü',
    请选择标签类型: 'Lütfen etiket türünü seçin',
    请选择关联模块: 'Lütfen ilişkili modülü seçin',
    请选择关联数据: 'Lütfen ilişkili veriyi seçin',
    关联模板: 'İlişkili şablon',
    请选择关联模板: 'Lütfen ilişkili şablonu seçin',
    请输入开始日期: 'Lütfen başlangıç tarihini girin',
    截止日期: 'Bitiş tarihi',
    请选择截止日期: 'Lütfen bitiş tarihini seçin',
    请输入任务描述内容: 'Lütfen görev açıklama içeriğini girin',
    完成任务: 'Görevi tamamla',
    请输入任务答辩内容: 'Lütfen görev savunma içeriğini girin',
    合格情况: 'Uygunluk durumu',
    请选择合格情况: 'Lütfen uygunluk durumunu seçin',
    请选择入库日期: 'Lütfen depo giriş tarihini seçin',
    是否有清单: 'Liste var mı',
    销售日期: 'Satış tarihi',
    请选择销售日期: 'Lütfen satış tarihini seçin',
    产品标签: 'Ürün etiketi',
    数据范围: 'Veri aralığı',
    请选择复核状态: 'Lütfen yeniden kontrol durumunu seçin',
    单品数量: 'Tek ürün miktarı',
    请选择单品数量: 'Lütfen tek ürün miktarını seçin',
    前缀标题: 'Önek başlık',
    '前缀标题如：仓库': 'Önek başlık örneği: Depo',
    后缀标题: 'Sonek başlık',
    后缀标题如: 'Sonek başlık örneği',
    大于: 'Büyük',
    入库状态: 'Depo giriş durumu',
    发货地: 'Gönderim yeri',
    请选择业务类型: 'Lütfen iş türünü seçin',
    采购单: 'Satın alma formu',
    '请搜索/选择采购单': 'Lütfen satın alma formu ara/seç',
    请选择参与人: 'Lütfen katılımcı seçin',
    请选择开始时间: 'Lütfen başlangıç zamanını seçin',
    请选择跟进人: 'Lütfen takip eden kişiyi seçin',
    请选择跟进时间: 'Lütfen takip zamanını seçin',
    后: 'Sonra',
    分钟: 'Dakika',
    昨天: 'Dün',
    下载查看: 'İndir ve görüntüle',
    '导入数据过多，已添加至异步导入队列生成':
      'Çok fazla veri içe aktarıldı, asenkron içe aktarma kuyruğuna eklendi',
    '您确定要将当前任务进行作废操作？':
      'Mevcut görevi iptal etmek istediğinizden emin misiniz?',
    子任务: 'Alt görev',
    创建: 'Oluştur',
    负责: 'Sorumlu',
    模块: 'Modül',
    跟进模块: 'Takip modülü',
    查看富文本内容: 'Zengin metin içeriğini görüntüle',
    跟进附件: 'Takip eki',
    跟进位置: 'Takip konumu',
    富文本内容: 'Zengin metin içeriği',
    暂无关联数据: 'Henüz ilişkili veri yok',
    列表显示: 'Liste görünümü',
    日历显示: 'Takvim görünümü',
    初一: 'İlk gün',
    多任务: 'Çoklu görev',
    项: 'Öğe',
    请先添加数据: 'Lütfen önce veri ekleyin',
    组合产品: 'Birleşik ürün',
    "90天销售笔数'": '90 gün satış sayısı',
    '90天销售客户数': '90 gün satış müşteri sayısı',
    最近销售: 'Son satışlar',
    资产图片: 'Varlık resimleri',
    资产详情: 'Varlık detayları',
    上次采购: 'Son satın alma',
    客户订单: 'Müşteri siparişi',
    KA一个月未下单: 'KA bir ay sipariş vermedi',
    KA三个月未下单: 'KA üç ay sipariş vermedi',
    KA一个月未跟进: 'KA bir ay takip edilmedi',
    合并客户数据: 'Müşteri verilerini birleştir',
    被合并客户: 'Birleştirilecek müşteri',
    请选择被合并客户: 'Lütfen birleştirilecek müşteriyi seçin',
    合并到客户: 'Müşteriye birleştir',
    请选择合并到客户: 'Lütfen müşteriye birleştir seçin',
    模具详情: 'Kalıp detayları',
    位置状态变化: 'Konum durum değişikliği',
    项目详情: 'Proje detayları',
    模具明细: 'Kalıp detayları',
    关联服务商: 'İlişkili servis sağlayıcı',
    模具供应商详情: 'Kalıp tedarikçi detayları',
    关联项目: 'İlişkili proje',
    关联模具: 'İlişkili kalıp',
    客户头像: 'Müşteri avatarı',
    请选择服务商: 'Lütfen servis sağlayıcı seçin',
    成本价格: 'Maliyet fiyatı',
    包含模具: 'Kalıp dahil',
    开发状态: 'Geliştirme durumu',
    距离完结: 'Tamamlanmaya kalan süre',
    距完结: 'Tamamlanmaya kalan',
    '您确定要同步产品到BOM吗？':
      "Ürünü BOM'a senkronize etmek istediğinizden emin misiniz?",
    计划信息: 'Plan bilgileri',
    明细信息: 'Detay bilgileri',
    关联采购订单: 'İlişkili satın alma siparişi',
    说明: 'Açıklama',
    凭证图: 'Belge resmi',
    计划付款: 'Planlanan ödeme',
    计划占比: 'Plan oranı',
    已付占比: 'Ödenen oranı',
    计划回款: 'Planlanan geri ödeme',
    回款信息: 'Geri ödeme bilgileri',
    已回占比: 'Geri ödenen oranı',
    图表统计: 'Grafik istatistikleri',
    渠道销量: 'Kanal satışları',
    新增刊登产品: 'Yeni listelenen ürün',
    新增刊登排名: 'Yeni liste sıralaması',
    渠道新增刊登: 'Kanal yeni listelemeler',
    销售产品: 'Satış ürünleri',
    提成排行: 'Komisyon sıralaması',
    计提金额: 'Tahakkuk eden tutar',
    上一时间段: 'Önceki zaman dilimi',
    当前时间段: 'Mevcut zaman dilimi',
    请选择统计币种: 'Lütfen istatistik para birimini seçin',
    库存预警: 'Stok uyarısı',
    剩余库存: 'Kalan stok',
    请选择操作人: 'Lütfen operatörü seçin',
    操作内容: 'Operasyon içeriği',
    渠道大类: 'Kanal ana kategorisi',
    渠道店铺: 'Kanal mağazası',
    自产货源: 'Kendi üretimi kaynak',
    零售适配评分: 'Perakende uyumu puanı',
    未上架产品: 'Raflanmamış ürün',
    AI分析: 'AI analizi',
    请选择尺寸: 'Lütfen boyut seçin',
    请输入重量: 'Lütfen ağırlık girin',
    评论: 'Yorum',
    '您确定要对当前所有数据进行刷新操作？':
      'Mevcut tüm verileri yenilemek istediğinizden emin misiniz?',
    组合商品: 'Birleşik ürün',
    商品编码: 'Ürün kodu',
    商品分类: 'Ürün kategorisi',
    价格公式: 'Fiyat formülü',
    尺码表: 'Beden ölçüsü tablosu',
    是否关键商品: 'Kritik ürün mü',
    批量修改尺码表: 'Toplu beden ölçüsü tablosu değiştirme',
    请选择尺码表: 'Lütfen beden ölçüsü tablosu seçin',
    推送到第三方店铺: 'Üçüncü taraf mağazaya gönder',
    请选择第三方店铺: 'Lütfen üçüncü taraf mağazayı seçin',
    请选择规类型: 'Lütfen spesifikasyon türünü seçin',
    添加规格: 'Spesifikasyon ekle',
    '规格类型在：设置》产品设置》规格类型中添加':
      'Spesifikasyon türleri: Ayarlar > Ürün Ayarları > Spesifikasyon Türleri bölümünde eklenir',
    '不能选择重复属性！！': 'Yinelenen özellik seçilemez!!',
    商品详情: 'Ürün detayları',
    产品SKU: 'Ürün SKU',
    产品售价: 'Ürün satış fiyatı',
    规格属性: 'Spesifikasyon özellikleri',
    选择规格: 'Spesifikasyon seç',
    商品属性: 'Ürün özellikleri',
    获取得物价格: 'Dewu fiyatını al',
    添加规格模板: 'Spesifikasyon şablonu ekle',
    规格模板名称: 'Spesifikasyon şablon adı',
    请输入模板名称: 'Lütfen şablon adını girin',
    '请添加规格及属性值！！':
      'Lütfen spesifikasyon ve özellik değerlerini ekleyin!!',
    '商品规格数量过多，请重新选择！':
      'Ürün spesifikasyon miktarı çok fazla, lütfen yeniden seçin!',
    '产品编码有重复请检查！！':
      'Ürün kodunda yinelenme var, lütfen kontrol edin!!',
    规格设置: 'Spesifikasyon ayarları',
    采购总量: 'Toplam satın alma miktarı',
    最高售价: 'En yüksek satış fiyatı',
    最近一次售价: 'Son satış fiyatı',
    最近一次采购时间: 'Son satın alma zamanı',
    更改: 'Değiştir',
    查看历史采购: 'Geçmiş satın almaları görüntüle',
    智能AI: 'Akıllı AI',
    销售预测: 'Satış tahmini',
    '实线为真实销量；虚线为预测销量':
      'Düz çizgi gerçek satışlar; kesikli çizgi tahmini satışlar',
    PROPHET方法预测: 'PROPHET yöntemi tahmini',
    PROPHET方法预测Tips:
      "PROPHET, Facebook (şimdi Meta) tarafından açık kaynak olarak sunulan bir zaman serisi tahmin kütüphanesidir, adı Prophet'tır. Zaman serisi verilerini modelleme ve tahmin için kullanılır, belirgin mevsimsellik ve tatil etkilerine sahip veriler için uygundur",
    SARIMA方法预测: 'SARIMA yöntemi tahmini',
    SARIMA方法预测Tips:
      "SARIMA, Seasonal Autoregressive Integrated Moving Average'in kısaltmasıdır, zaman serisi tahmini için klasik bir istatistiksel modeldir. ARIMA modelinin genişletilmiş bir versiyonudur, belirgin mevsimsel desenlere sahip verileri işlemek için özel olarak tasarlanmıştır",
    客户采购: 'Müşteri satın alması',
    预计出库: 'Tahmini çıkış',
    真实销量: 'Gerçek satışlar',
    方法预测: 'Yöntem tahmini',
    '零售价格/建议售价-最低售价/成本':
      'Perakende fiyatı/Önerilen satış fiyatı - Minimum satış fiyatı/Maliyet',
    '90天销量/笔数': '90 gün satışlar/sayı',
    授权市场: 'Yetkilendirme pazarı',
    '您确定下架当前产品？':
      'Mevcut ürünü raflamak istediğinizden emin misiniz?',
    '您确定要对当前所有数据进行比价并上架？':
      'Mevcut tüm veriler için fiyat karşılaştırması yaparak raflamak istediğinizden emin misiniz?',
    '您确定要对当前所选数据进行比价并上架？':
      'Mevcut seçili veriler için fiyat karşılaştırması yaparak raflamak istediğinizden emin misiniz?',
    批量下架: 'Toplu raflama',
    自产滞销: 'Kendi üretimi滞销',
    自产滞销Tips:
      'Kendi üretimi滞销 (kendi üretimi, 90 gün satış < 50 adet), stok miktarına göre büyükten küçüğe, son satış zamanına göre eskiden yeniye sıralama',
    外购滞销: 'Dış satın alma滞销',
    外购滞销Tips:
      'Dış satın alma滞销 (dış satın alma, stok var ve 90 gün satış < 10), stok miktarına göre büyükten küçüğe, son satış zamanına göre eskiden yeniye sıralama',
    省市区: 'İl/İlçe/Bölge',
    位置: 'Konum',
    操作记录: 'Operasyon kayıtları',
    主域名: 'Ana alan adı',
    网页快照: 'Web sayfası anlık görüntüsü',
    条形码: 'Barkod',
    '起订量(moq)': 'Minimum sipariş miktarı (moq)',
    '您确定要对当客户订单中的产品进行同步吗？':
      'Mevcut müşteri siparişindeki ürünleri senkronize etmek istediğinizden emin misiniz?',
    同步订单中的产品: 'Siparişteki ürünleri senkronize et',
    采购单的其他费用金额: 'Satın alma formunun diğer ücret miktarı',
    '您确定要对当前数据直接生成入库单并审核通过？':
      'Mevcut veriler için doğrudan depo giriş formu oluşturarak onaylamak istediğinizden emin misiniz?',
    '您确认将产品货物状态变为采购？':
      'Ürün mal durumunu satın alma olarak değiştirmeyi onaylıyor musunuz?',
    '您确定要批量提审选中的信息？':
      'Seçili bilgileri toplu olarak incelemeye göndermek istediğinizden emin misiniz?',
    派货行程单详情: 'Sevkiyat güzergah formu detayları',
    配送地址: 'Dağıtım adresi',
    '您确定要对当前数据完成配送？':
      'Mevcut veriler için dağıtım tamamlamak istediğinizden emin misiniz?',
    包含单数: 'İçerik form sayısı',
    '您确定要对当前数据开始派货？':
      'Mevcut veriler için sevkiyat başlatmak istediğinizden emin misiniz?',
    '您确定要对当前数据结束派货？':
      'Mevcut veriler için sevkiyat sonlandırmak istediğinizden emin misiniz?',
    '您确定要生成出库单？':
      'Çıkış formu oluşturmak istediğinizden emin misiniz?',
    各仓库库存: 'Her depo stoku',
    '您确定要对当前数据进行自动派货？':
      'Mevcut veriler için otomatik sevkiyat yapmak istediğinizden emin misiniz?',
    是否打印: 'Yazdırılsın mı',
    您确定要对选中的数据进行批量打印:
      'Seçili verileri toplu yazdırmak istediğinizden emin misiniz',
    工厂库存: 'Fabrika stoku',
    入库记录: 'Depo giriş kayıtları',
    库存低于: 'Stok alt sınırı',
    天销售: 'Günlük satış',
    '天销售,滞销！': 'Günlük satış,滞销!',
    可用天数: 'Kullanılabilir gün sayısı',
    根据当前库存和日均销售量计算预估可用天数:
      'Mevcut stok ve günlük ortalama satış miktarına göre tahmini kullanılabilir gün sayısını hesapla',
    '你确定要复制和当前数据子节点结构一样？':
      'Mevcut veri alt düğüm yapısıyla aynı yapıyı kopyalamak istediğinizden emin misiniz?',
    splitTableTips: 'Raf miktarı varsa lütfen dikey çizgi (|) ile ayırın',
    加载中: 'Yükleniyor',
    productCategoryNumStock: 'Ürün kategorisi | Toplam miktar (pozisyon)',
    productCategoryNum: 'Ürün kategorisi | Miktar',
    等待处理数量: 'İşlem bekleyen miktar',
    '已处理/订单数': 'İşlenmiş/Sipariş sayısı',
    '处理完成！！': 'İşlem tamamlandı!!',
    '您确定要批量打印面单吗？':
      'Toplu olarak etiket yazdırmak istediğinizden emin misiniz?',
    '您确定要批量删除所选数据吗？':
      'Seçili verileri toplu silmek istediğinizden emin misiniz?',
    '您确定要批量确认运单费用吗？':
      'Toplu olarak kargo ücretlerini onaylamak istediğinizden emin misiniz?',
    天销售笔数: 'Günlük satış sayısı',
    天销售客户数: 'Günlük satış müşteri sayısı',
    '天销量/笔数': 'Günlük satışlar/sayı',
    '尺寸/重量': 'Boyut/Ağırlık',
    预估费用: 'Tahmini ücret',
    收货地: 'Alım yeri',
    '您确定要使用当前预估费用进行费用确认吗？':
      'Mevcut tahmini ücreti kullanarak ücret onayı yapmak istediğinizden emin misiniz?',
    第三方仓库详情: 'Üçüncü taraf depo detayları',
    所在仓: 'Bulunduğu depo',
    待发货数量: 'Sevkiyat bekleyen miktar',
    毛利: 'Brüt kar',
    订单毛利金额: 'Sipariş brüt kar tutarı',
    '订单金额-已收金额-优惠金额':
      'Sipariş tutarı - Alınan tutar - İndirim tutarı',
    订单的其他费用金额: 'Siparişin diğer ücret miktarı',
    '您确定要对当前数据撤销提审？':
      'Mevcut veriler için inceleme gönderimini iptal etmek istediğinizden emin misiniz?',
    仅撤销: 'Sadece iptal et',
    撤销并删除关联单据: 'İptal et ve ilişkili belgeleri sil',
    '您确定要对当前订单利润进行重新计算？':
      'Mevcut sipariş karını yeniden hesaplamak istediğinizden emin misiniz?',
    订单复核: 'Sipariş yeniden kontrol',
    订单金额调整: 'Sipariş tutarı ayarlama',
    未提交: 'Gönderilmedi',
    未审核: 'İncelenmedi',
    已审核: 'İncelendi',
    未复核: 'Yeniden kontrol edilmedi',
    已复核: 'Yeniden kontrol edildi',
    大单品订单: 'Büyük ürün siparişi',
    '您确定要批量出库选中的信息？':
      'Seçili bilgileri toplu olarak çıkış yapmak istediğinizden emin misiniz?',
    删除时间: 'Silme zamanı',
    '您确定要恢复当前订单的信息？':
      'Mevcut sipariş bilgilerini geri yüklemek istediğinizden emin misiniz?',
    订单模版: 'Sipariş şablonu',
    反馈处理: 'Geri bildirim işleme',
    岗位描述: 'Pozisyon açıklaması',
    最新编辑: 'En son düzenleme',
    使用公司: 'Kullanan şirket',
    标签名称: 'Etiket adı',
    关联信息编码: 'İlişkili bilgi kodu',
    标签查询: 'Etiket sorgulama',
    标签列表: 'Etiket listesi',
    操作说明: 'Operasyon talimatları',
    请输入操作说明: 'Lütfen operasyon talimatlarını girin',
    显示选项卡: 'Sekmeleri göster',
    规格值: 'Spesifikasyon değeri',
    产品规格类型: 'Ürün spesifikasyon türü',
    规格名称: 'Spesifikasyon adı',
    请输入规格名称: 'Lütfen spesifikasyon adını girin',
    '颜色、尺寸、重量等': 'Renk, boyut, ağırlık vb.',
    请输入规格属性: 'Lütfen spesifikasyon özelliğini girin',
    '请输入规格属性值如红色、黑色、白色等':
      'Lütfen spesifikasyon özellik değerlerini girin (örneğin kırmızı, siyah, beyaz vb.)',
    服务商类型: 'Servis sağlayıcı türü',
    规格类型: 'Spesifikasyon türü',
    常见问题: 'Sıkça sorulan sorular',
    问题类型: 'Soru türü',
    币种汇率: 'Para birimi döviz kuru',
    kickcrew页面价格: 'Kickcrew sayfa fiyatı',
    '美元换算人民币汇率）': "USD'den CNY'ye döviz kuru)",
    汽配行业不适用: 'Otomotiv yedek parça sektörü için geçerli değil',
    请输入价格公式: 'Lütfen fiyat formülünü girin',
    '如（price': 'Örneğin (fiyat',
    严格宽松模式: 'Sıkı/gevşek mod',
    单号规则: 'Belge numarası kuralları',
    页面设置: 'Sayfa ayarları',
    搜索条件缓存: 'Arama koşulları önbelleği',
    '页面搜索条件缓存开启后，页面搜索条件会缓存，下次访问时会自动加载上次搜索条件，请谨慎使用':
      'Sayfa arama koşulları önbelleği etkinleştirildikten sonra, sayfa arama koşulları önbelleğe alınır, bir sonraki ziyarette otomatik olarak son arama koşulları yüklenir, lütfen dikkatli kullanın',
    展示产品编辑时间: 'Ürün düzenleme zamanını göster',
    '产品编辑时间开启后，产品编辑时间和编辑人信息会显示在产品列表图片下方':
      'Ürün düzenleme zamanı etkinleştirildikten sonra, ürün düzenleme zamanı ve düzenleyen bilgileri ürün listesi resimlerinin altında gösterilir',
    展示产品最近销售时间: 'Ürün son satış zamanını göster',
    '产品最近销售时间开启后，产品最近销售时间信息会显示在产品明细列表图片下方':
      'Ürün son satış zamanı etkinleştirildikten sonra, ürün son satış zamanı bilgileri ürün detay listesi resimlerinin altında gösterilir',
    自动保存form表单: 'Formu otomatik kaydet',
    '自动保存form表单开启后，打开编辑弹窗将会自动保存form表单内容':
      'Formu otomatik kaydet etkinleştirildikten sonra, düzenleme penceresi açıldığında form içeriği otomatik olarak kaydedilir',
    电商小程序审核: 'E-ticaret mini program incelemesi',
    开启后文章分类将不显示:
      'Etkinleştirildikten sonra makale kategorileri gösterilmeyecek',
    双击复制单元格: 'Hücreyi kopyalamak için çift tıklayın',
    '开启后本系统中列表支持双击复制单元格内容，方便快捷复制文案':
      'Etkinleştirildikten sonra bu sistemdeki listeler hücre içeriğini kopyalamak için çift tıklamayı destekler, metin kopyalama kolay ve hızlı olur',
    tab页新开页面: 'Tab sayfası yeni pencere aç',
    '开启后本系统中所有的tab页都会在新页面打开，方便数据对比':
      'Etkinleştirildikten sonra bu sistemdeki tüm tab sayfaları yeni pencerede açılır, veri karşılaştırması kolay olur',
    虚拟列表: 'Sanal liste',
    '开启后本系统详情页明细列表将使用虚拟列表，请谨慎使用':
      'Etkinleştirildikten sonra bu sistem detay sayfası detay listeleri sanal listeyi kullanır, lütfen dikkatli kullanın',
    此操作会带来不必要的性能开销: 'Bu işlem gereksiz performans yükü getirir',
    详情列表拖拽排序: 'Detay listesi sürükle sıralama',
    开启后本系统详情页明细列表可以自由拖拽排序:
      'Etkinleştirildikten sonra bu sistem detay sayfası detay listeleri serbestçe sürükle sıralanabilir',
    其他设置: 'Diğer ayarlar',
    订单默认渠道: 'Sipariş varsayılan kanalı',
    设置后订单下单时会自动默认选择当前渠道值:
      'Ayarlandıktan sonra sipariş verildiğinde otomatik olarak mevcut kanal değeri varsayılan olarak seçilir',
    请搜索默认渠道: 'Lütfen varsayılan kanal ara',
    '确定要测试吗？': 'Test yapmak istediğinizden emin misiniz?',
    执行周期: 'Yürütme döngüsü',
    请选择执行类型: 'Lütfen yürütme türünü seçin',
    选择执行时间: 'Yürütme zamanı seç',
    电商小程序APPID: 'E-ticaret mini program APPID',
    请输入电商小程序APPID: 'Lütfen e-ticaret mini program APPID girin',
    电商小程序Secret: 'E-ticaret mini program Secret',
    请输入电商小程序AppSecret: 'Lütfen e-ticaret mini program AppSecret girin',
    微信配置: 'WeChat yapılandırması',
    定时任务配置: 'Zamanlanmış görev yapılandırması',
    任务模板详情: 'Görev şablon detayları',
    任务模板: 'Görev şablonu',
    纸张大小: 'Kağıt boyutu',
    请选择纸张大小: 'Lütfen kağıt boyutunu seçin',
    纸张方向: 'Kağıt yönü',
    请选择纸张方向: 'Lütfen kağıt yönünü seçin',
    预览: 'Önizleme',
    普通导出: 'Normal dışa aktar',
    普通打印: 'Normal yazdır',
    输出PDF: 'PDF çıktı al',
    打印机打印: 'Yazıcı yazdır',
    预览模板: 'Şablon önizleme',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在分类中。':
      'Bu içerik şu bağımlılığa sahiptir: Ürün > Ürün Kategorisi, göstermek istediğiniz kategorileri işaretleyebilirsiniz, işaretlendikten sonra kategoriler kategorilerde görünecektir.',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页(PC端)导航栏中。':
      'Bu içerik şu bağımlılığa sahiptir: Ürün > Ürün Kategorisi, göstermek istediğiniz kategorileri işaretleyebilirsiniz, işaretlendikten sonra kategoriler ana sayfa (PC tarafı) navigasyon çubuğunda görünecektir.',
    授权时间: 'Yetkilendirme zamanı',
    授权企业: 'Yetkilendirme şirketi',
    '您确定要对当前数据取消授权？':
      'Mevcut veriler için yetkilendirmeyi iptal etmek istediğinizden emin misiniz?',
    // TODO: 2025-12-01
    "OEM信息": "OEM Bilgisi",
    "谷歌搜图": "Google Görsel Arama",
    "待完善、不售卖产品": "Tamamlanması Gereken, Satılmayan Ürünler",
    "新产品": "Yeni Ürün",
    "图片地址": "Resim Adresi",
    "应用": "Uygulama",
    "图纸信息": "Çizim Bilgileri",
    "适配车型": "Uyumlu Araç Modelleri",
    "版本": "Versiyon",
    "指导价": "Rehber Fiyatı",
    "位置编号": "Konum Numarası",
    "使用年份": "Kullanım Yılı",
    "图纸": "Çizimler",
    "型号": "Model",
    "发动机": "Motor",
    "市场/地区": "Pazar/Bölge",
    "部件图": "Parça Şeması",
    "部件信息": "Parça Bilgileri",
    "适用品牌": "Uygun Markalar",
    "部件编码": "Parça Kodu",
    "回本周期": "Geri Kazanım Süresi",
    "无法估算": "Tahmin Edilemiyor",
    "回本日": "Geri Kazanım Günü",
    "税费": "Vergi ve Harçlar",
    "评价": "Değerlendirme",
    "海关编码": "Gümrük Kodu",
    "新旧类型": "Yeni/Eski Türü",
    "订单评价": "Sipariş Değerlendirmesi",
    "订单预审": "Sipariş Ön İnceleme",
    "是否施工": "İnşaat Yapılacak mı",
    "原厂零售价": "Fabrika Çıkışlı Perakende Fiyatı",
    "请选择新旧类型": "Lütfen Yeni/Eski Türünü Seçin",
    "请输入海关编码": "Lütfen Gümrük Kodunu Girin",
    "google搜索OEM码": "Google ile OEM Kodu Arama",
    "预计完工": "Tahmini Tamamlanma",
    "请选择预计完成时间": "Lütfen Tahmini Tamamlanma Zamanını Seçin",
    "请输入箱规毛重": "Lütfen Kutu Spesifikasyonu Brüt Ağırlığını Girin",
    "产品报价": "Ürün Teklifi",
    "请输入产品报价": "Lütfen Ürün Teklifini Girin",
    "产品推介渠道": "Ürün Tanıtım Kanalı",
    "其他信息": "Diğer Bilgiler",
    "账期备注": "Vade Süresi Notları",
    "图片视频": "Resimler ve Videolar",
    "线索类型": "Fırsat Türü",
    "图像": "Görüntü",
    "支持排序": "Sıralamayı Destekle",
    "按照产品已有价格": "Mevcut Ürün Fiyatlarına Göre",
    "优先使用": "Öncelikli Kullanım",
    "零售价": "Perakende Fiyatı",
    "项目分类": "Proje Sınıflandırması",
    "请搜索/选择项目分类": "Lütfen Proje Sınıflandırmasını Arayın/Seçin",
    "请输入服务商名称": "Lütfen Hizmet Sağlayıcı Adını Girin",
    "跟踪产品": "İzlenen Ürün",
    "我方产品": "Bizim Ürünümüz",
    "请输入我方产品地址": "Lütfen Bizim Ürün Adresimizi Girin",
    "竞品产品": "Rakip Ürün",
    "请输入竞品产品地址": "Lütfen Rakip Ürün Adresini Girin",
    "添加竞品产品地址": "Rakip Ürün Adresi Ekle",
    "最低价格": "En Düşük Fiyat",
    "最低跟踪价格": "En Düşük İzleme Fiyatı",
    "打标签": "Etiketle",
    "请搜索/选择新旧类型": "Lütfen Yeni/Eski Türünü Arayın/Seçin",
    "未销售天数": "Satılmayan Gün Sayısı",
    "请输入未销售天数": "Lütfen Satılmayan Gün Sayısını Girin",
    "请选择项目分类": "Lütfen Proje Sınıflandırmasını Seçin",
    "超时": "Zaman Aşımı",
    "到期": "Vade Bitimi",
    "个月": "Ay",
    "标签明细": "Etiket Detayları",
    "关联信息ID": "İlişkili Bilgi ID'si",
    "暂为匹配到当前关联信息": "Şu Anda İlişkili Bilgiyle Eşleşmedi",
    "查看明细": "Detayları Görüntüle",
    "占用数量": "Dolu Miktar",
    "已购产品": "Satın Alınan Ürünler",
    "未购产品": "Satın Alınmamış Ürünler",
    "购买产品车型明细": "Satın Alınan Ürün Araç Model Detayları",
    "上次采购价格": "Son Alım Fiyatı",
    "上次采购数量": "Son Alım Miktarı",
    "上次采购订单": "Son Alım Siparişi",
    "客户成长性": "Müşteri Büyümesi",
    "采购频率": "Alım Sıklığı",
    "每笔订单平均间隔": "Ortalama Sipariş Aralığı",
    "以产品品牌分类的产品分布情况": "Marka Bazında Ürün Dağılımı",
    "以产品一级分类的产品分布情况": "Birincil Kategori Bazında Ürün Dağılımı",
    "二级分类": "İkincil Kategori",
    "以产品二级分类的产品分布情况": "İkincil Kategori Bazında Ürün Dağılımı",
    "以产品车型分类的产品分布情况": "Araç Modeli Bazında Ürün Dağılımı",
    "以产品部件分类的产品分布情况": "Parça Bazında Ürün Dağılımı",
    "季": "Çeyrek",
    "至": "Kadar",
    "暂无关联数据！": "İlişkili Veri Yok!",
    "项目类型": "Proje Türü",
    "利润金额": "Kar Tutarı",
    "订单利润": "Sipariş Karı",
    "客户推荐": "Müşteri Önerisi",
    "图文标题": "Grafik ve Metin Başlığı",
    "请输入图文标题": "Lütfen Grafik ve Metin Başlığını Girin",
    "最低售价/成本/原厂零售价": "En Düşük Satış Fiyatı/Maliyet/Fabrika Perakende Fiyatı",
    "预计完成时间": "Tahmini Tamamlanma Zamanı",
    "请先填写OEM编码": "Lütfen Önce OEM Kodunu Doldurun",
    "我方售价": "Bizim Satış Fiyatımız",
    "竞品售价": "Rakip Satış Fiyatı",
    "天销售少于": "Gün İçinde Satış Miktarı Az Olanlar",
    "创建时间大于": "Oluşturma Zamanı Büyük Olanlar",
    "天，按去库存周期由大到小排列": "Gün, Stok Azaltma Süresine Göre Büyükten Küçüğe Sıralı",
    "天订单": "Günlük Sipariş",
    "天客户": "Günlük Müşteri",
    "去库存": "Stok Azaltma",
    "您确定要批量出库？": "Toplu Depo Çıkışı Yapmak İstediğinizden Emin misiniz?",
    "已审现金": "İncelenmiş Nakit",
    "已审挂账": "İncelenmiş Vadeli",
    "作废订单": "İptal Edilen Siparişler",
    "拥有成员": "Üyeler",
    "关联父级信息": "İlişkili Üst Bilgi",
    "产品信息中的箱规尺寸": "Ürün Bilgilerindeki Kutu Spesifikasyonu Boyutları",
    "产品信息中的箱规中的重量": "Ürün Bilgilerindeki Kutu Spesifikasyonu Ağırlığı",
    "上次跟进内容": "Son Takip İçeriği",
    "上次跟进附件": "Son Takip Eki",
    "上次跟进位置": "Son Takip Konumu",
    "上次跟进时间": "Son Takip Zamanı"
  },
}
